import { PaymentMethodSourceConfiguration } from './../../shared/interface/payment-method-source-configuration.interface';
import { animate, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { orderBy } from 'lodash';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { ImpersonateUserConstants } from '../constants/impersonate-user.constants';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { ContactTypeValue } from '../../common/enums/contact-type.value.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../common/pipes/currency-format.pipe';
import { GroupByPipe } from '../../common/pipes/group-by.pipe';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import { MemberActivityLogType } from '../../shared/common/enumerations';
import { Language } from '../../shared/components/ILanguage';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from "../../shared/constants/common.constants";
import { AddressVisibility } from '../../shared/interface/address-visibility';
import { Country } from '../../shared/interface/country.interface';
import { DisplayPriceConfig } from '../../shared/interface/display-price-config.interface';
import { MemberAllowedCountries } from '../../shared/interface/member-allowed-countries.interface';
import { Member } from '../../shared/interface/member.interface';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { WholesaleQualifiedResponse } from '../../shared/interface/wholesaleQualifiedResponse.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MemberDisplayPriceConfigService } from '../../shared/services/member-display-price-config.service';
import { MessageService } from '../../shared/services/message.service';
import { CustomValidators } from '../../shared/Utils/custom-validator';
import { Utils } from '../../shared/Utils/utils';
import { Constants, DelivaryOptionType, IsoCodeThree, MemberType, ProductSource, UserTitleType } from '../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, PromotionOrderType, PurchaseFlow, RowStatus } from '../common/enumerations';
import { DateConstants } from '../constants/date.constants';
import { MemberTypeId } from '../constants/member-type-id.enum';
import { PaymentMethodTypeConstants } from '../constants/payment-method-types.constants';
import { PaymentConstants } from '../constants/payment.constants';
import { PhoneCodesConstants } from '../constants/phone-codes.constant';
import { PortalDisplayPage } from '../constants/portal-display-page.enum';
import { ResponseStatus } from '../constants/response-status-constants';
import { StatusConstants } from '../constants/status.constants';
import { Translations } from '../constants/translations.constants';
import { EcheckPhoneNumberValidation } from '../directive/echeck-phone-validation';
import { ValidateDateOfBirth } from '../directive/validate-dob';
import { BonusPaymentOption } from '../enums/bonus-payment-option.enum';
import { CartTypes } from '../enums/cart-type.enum';
import { DisplaySectionId, DocumentLibraryMemberId, Portal } from '../enums/document-library-member-id.enum';
import { AccountType } from '../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../enums/echeck-portal-types.enum';
import { ImageType } from '../enums/image-type.enum';
import { MemberOrderType } from '../enums/member-order-type.enum';
import { MemberStatus } from '../enums/member-status.enum';
import { MemberTitleExtEnums } from '../enums/member-title.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MessageTypeEnum } from '../enums/message-type.enums';
import { NotificationType } from '../enums/notification-types.enum';
import {
    AddressType, OrderSourceType,
    OrderStatus, PaymentMethodTypes, PaymentType, PriceType,
    ProductWeightMetric, PurchaseFlows,
    PurchaseFlowType, ShippingOrderType, ShippingType, Source
} from '../enums/order-source-type';
import { OrderSourceTypes, OrderSourceValue } from '../enums/order-source.enum';
import { SecType } from '../enums/payment-ach-sectypes.enum';
import { PaymentCardTypes } from '../enums/payment-card-types.enum';
import { ProductMetatDataValue } from '../enums/product-metadata.enum';
import { SelectEnum } from '../enums/selection.enum';
import { ShippingMemberTitle } from '../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../enums/shipping-member-type.enum';
import { SponsorSearchOption } from '../enums/sponsor-search-option.enum';
import { SponsorWizardSearchType } from '../enums/sponsor-wizard-type.enum';
import { ValueType } from '../enums/value-type.enum';
import { PersonalAch } from '../interface/ach-payment/payment-achrequest.interface';
import { ActivityLogKey } from '../interface/activityLogKey';
import { Address } from '../interface/address';
import { AppCountryConfig } from '../interface/app-config';
import { BankDetails } from '../interface/bank-details.interface';
import { BonusInfo } from '../interface/bonus-info.interface';
import { CheckoutConfig } from '../interface/checkout-config.interface';
import { DiscountPercentageResponse } from '../interface/discount-percentage.response.interface';
import { PersonalCheck } from '../interface/eCheck/payment-echeckrequest.interface';
import { ValidateEcheckRequest } from '../interface/eCheck/validate-echeck-request.interface';
import { ValidateEcheckResponse } from '../interface/eCheck/validate-echeck-response.interface';
import {
    EnrollInfo,
    EnrollSession, LegalRequirements, MemberCommunicationPreference, Order, PersonalInformation, SponsorInformation,
    SponsorSearchRequest, SponsorSearchResponse, ZipCodePattern
} from '../interface/enrollment';
import { DocumentLibrary, DocumentLibraryRequest } from '../interface/enrollment/document-library.interface';
import { RebindSponsorData } from '../interface/enrollment/sponsor-rebind-data.interface';
import { FBOBusinessEntity } from '../interface/fbo-business-entity';
import { IdentificationPatternByCountry } from '../interface/government-identification-pattern.interface';
import { MemebrCCOverrideResponse } from '../interface/member-ccoverride-response.interface';
import { MemberLevelHistory } from '../interface/member-level-history.interface';
import { MemberOrderCCInfo } from '../interface/member-order-cc-info';
import { OrderRulesRequest } from '../interface/order-rules-request.interface';
import { OrderRulesResponse } from '../interface/order-rules-response.interface';
import { PayvisionSavedCardResponse } from '../interface/payvision/payvision-saved-card-response.interface';
import { PayvisionSavedCard } from '../interface/payvision/payvision-saved-card.interface';
import { PersonalInfoConfig } from '../interface/personal-info-config.interface';
import { PriceTierResponse } from '../interface/price-tier-response';
import { Product, ProductAssociation } from '../interface/product-info';
import { ProductModel, ProductRestrictionModel } from '../interface/product-restriction.interface';
import { ProductRewardModel } from '../interface/product-reward-model';
import { PromotionRequestModel } from '../interface/promotion-request-model';
import { PromotionReponseModel } from '../interface/promotion-response-model';
import { RestrictedProduct } from '../interface/restricted-product.interface';
import { ShippingMethod } from '../interface/ship-method';
import { ShippingAddressInfoConfig } from '../interface/shipping-address-info-config.interface';
import { ShippingOptionsRequest } from '../interface/shipping-options-request';
import { ShippingOptionsResponse } from '../interface/shipping-options-response';
import { ShippingProductModel } from '../interface/shipping-product.interface';
import { SponsorConfig } from '../interface/sponsor-config.interface';
import { TaxRequest } from '../interface/tax-request';
import { TaxType } from '../interface/tax-type.interface';
import { Cart } from '../models/cart.model';
import { DeleteModal } from '../models/delete-modal';
import { Item } from '../models/item.model';

import { OrderInfoTab } from '../models/order-info-tab-model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { AchService } from '../services/ach.service';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { ConfigurationService } from '../services/configuration.service';
import { AddressService } from '../services/address.service';
import { CustomerService } from '../services/customer.service';
import { DocumentService } from '../services/document.service';
import { EcheckService } from '../services/echeck.service';
import { EnrollmentMessageService } from '../services/enrollment-message.service';
import { EnrollService } from '../services/enrollment.service';
import { OrderService } from '../services/order.service';
import { PayvisionService } from '../services/payvision.service';
import { PersonalInfoConfigService } from '../services/personal-info-config.service';
import { PersonalMessageService } from '../services/personal-schema-form.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { SponsorConfigService } from '../services/sponsor-config.service';
import { SponsorService } from '../services/sponsor.service';
import { CustomValidator } from './customvalidation.component';
import { Promotion } from '../interface/promotion';
import { OrderTrackingRequest } from '../interface/orderTracking';
import { StockQuantity } from '../interface/stock-quantity';
import { CollectionPoint, GeoPoint } from '../interface/pudo-location.interface';
import { PudoLocationRequest } from '../interface/pudo-location-request.interface';
import { BusinessHour, SplitHour } from '../interface/business-hour.interface';
import { BusinessInfo } from '../interface/business-info.interface';
import { MemberContact } from '../interface/member-contact';
import { PaymentDroolsRequest } from '../interface/payment-drools-request.interface';
import { PaymentDroolsResponse } from '../interface/payment-drools-response.interface';
import { PaymentModeConstants } from '../constants/payment-mode.constants';
import { PriceTier, StorerPiceTier } from '../constants/pricetier.constants';
import { MemberPreferencesType } from '../enums/member-preferences.enum';
import { State } from '../../shared/interface/state.interface';
import { JsonpClientBackend } from '@angular/common/http';
import { AccountRestrictionStatus } from "../../common/enums/account-restricted.enum";
import { RetailFreeShippingConstants } from '../constants/retail-free-shipping.constants';
import { MemberMetaDataEnum } from '../enums/member-meta-data.enum';
import { EnrollmentCommonService } from '../../shared/services/enrollment-common.service';
import { PaymentProcessorAlias } from '../enums/payment-processor-alias.enum';
import { BonusConstants } from '../constants/bonus-status.constants';
import { Subscription } from 'rxjs';
import { BankWireTransferConstants } from '../constants/bank-wire-transfer-configuration.constants';
import { transactional } from '../enums/sponsor-transactional-source-type.enum';

declare var Worldpay: any;
declare var Accept: any;

@Component({
    selector: 'order-promotion',
    templateUrl: '../templates/template1/views/order-promotion.component.html',
    styleUrls: [
        '../templates/template1/themes/default/less/order-promotion.less', '../templates/template1/themes/default/less/print-preview.less'
    ],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scaleX(0)' }),
                animate('500ms ease-in', style({ opacity: 1, transform: 'scaleX(1)' }))
            ]),
            transition(':leave', [
                animate('400ms ease-in', style({ opacity: 0, transform: 'scaleX(0)' }))
            ])
        ])
    ],
    providers: [TitleCasePipe, GroupByPipe]
    // encapsulation: ViewEncapsulation.None
})
export class OrderPromotionComponent implements OnInit {
    @Input() fboid: string;
    @Input() orderFromLookup: boolean;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    showAddressFormValidations = false;
    cartMessageID: any;
    memberInfo: any;
    memberTypeId: any;
    memberTypeEnum = MemberTypeEnum;
    orderType = OrderType;
    deliveryPreference = DeliveryPreference;
    orderFormGroup: FormGroup;
    fboUpgradeForm: FormGroup;
    paymentReferenceNumber: FormGroup;
    displayStatementForWavePayment: boolean = false;
    items: any[] = [];
    countries: any[] = [];
    memberCountries: any[] = [];
    states: any[] = [];
    memberSearchSubmitted = false;
    memberAddressDetails: any[] = [];
    memberShippingDetails: any[] = [];
    shippingAddressInfo: any;
    address: any = {};
    addressType: AddressType;
    isnewcardAdded: boolean;
    displayPudoAddress: boolean;
    showPudoPickupPersonAddressForm: boolean = false;
    pudoShippingAddressInfo: Address = null;
    selectedPudoCollectionPoint: CollectionPoint = null;
    pudoLocationSearchForm: FormGroup;
    loadingPudoPickupLocations: boolean;
    pudoAddressSubmitted: boolean;
    pudoAddress: any;
    savedPudoAddressId: number;
    pudoShippingMethod: ShippingMethod = null;
    dropshipPudoShippingMethod: ShippingMethod = null;
    pudoLocationsNotFound: boolean = false;
    pudoCollectionPoints: CollectionPoint[] = null;
    countryTaxInclusive: boolean;
    storeInfo: StoreConfig;
    shipMethodValidation: any = '';
    verifiedShippingAddressId: number;
    fpcOrderGlobalUrl: string;
    shippingDeliveryOptionAvailable = false;
    pickupDeliveryOptionAvailable = false;
    agreementCheckError: boolean;
    formSubmitted: boolean;
    isCalculateTax: boolean;
    defaultCurrency = CommonConstant.Default_Currency;
    governmentIdExist: boolean;
    subTotal = 0.0;
    retailSubTotal = 0.0;
    totalCommissionableVolume = 0;
    selectedIsoCountryCode: any = '';
    selectedCountryCodeTwo = '';
    shipMethods: ShippingOptionsResponse;
    shippingMethods: ShippingMethod[] = [];
    savedCards: any[] = [];
    selectedPaymentMethod: any;
    isPaymentWithSavedCard = false;
    isSubmitted = false;
    deleteModal: DeleteModal;
    products: any[] = [];

    orderTaxResponse: any;
    taxableAmount = 0;
    shippingCost = 0;
    orginalShippingCost = 0;
    searchReqValues: any;
    shipMethod: any = {};
    showSelectedShipMethod = false;
    languageCode = 'en-US';
    languageShortCode = 'en';
    languageCulture = 'en-US';
    payByLinkLanguageShortCode = 'en';
    disableDelivery = false;
    pollCount = 0;
    maxPollCount = 15;
    importFeeValue = 0;
    importFeeEnabled = false;
    itemSearch: any;
    selectEnum = SelectEnum;
    userInfo: UserInfo;
    memberStatus;
    isActive: boolean;
    storeId: number;
    credit_Card_show: boolean;
    echeck_show: boolean;
    gstTax: number;
    pstTax: number;
    storeDefaultLanguage: string;
    taxCalculationStatus: boolean;
    minMaxPriceValidation: boolean;
    isFocused: boolean;
    datePickerStartDateAt = new Date();
    invalidGovernmentId: boolean;
    governmentIdValidInProgress: boolean;
    optInCheck = true;
    isFPCOptInEnabled = false;
    selectedpickup: number;
    displayPriceConfig: DisplayPriceConfig;
    memberLevelHistory: MemberLevelHistory[];
    isMemberFboUpgraded = false;
    upgradeFboLimitExceeded = false;
    isFBOValidationPending = false;
    accountMemberInfo: any;
    paymentAchForm: FormGroup;
    savedAch: string;
    bankDetailsCountryList: BankDetails[];
    orderSessionGuid: string;
    isWhosaleCheckNotCalculated = false;
    banContact_misterCash_and_maestro_show: boolean;
    misterCash_and_maestro_show: boolean;
    identificationPatternByCountry: IdentificationPatternByCountry;
    single_debit_show = false;
    direct_debit_show = false;
    acceptPaymentDocuments = null;
    disableBonusAgreement: boolean = true;
    accountNumber: string = "";
    businessEntityDetails: any;
    businessInformation: BusinessInfo;
    pay_by_link_show: boolean;
    emailForm: FormGroup;
    isPayByLinkValid = true;
    storeDefaultLanguageShortCode: string = 'en';
    taxInclusiveSubTotal: number;
    taxExclusiveSubTotal: number;
    paymentDroolsResponse: PaymentDroolsResponse[];
    removedPaymentMethods: string[];
    isNexioPayment: boolean;
    showNexioPayment: boolean;
    storeResponeLanguages = [];
    storeLangCultureId: any;
    memberPreference = [];
    memberHomeCountry: string;
    storeDetails: StoreConfig;
    priceTierName: string;
    dateOfBirthMember: any;
    overrideMinimumLimitIsEnabled: boolean = false;
    verifyPudoAddress: boolean = true;
    translateOptions = {
        translateText: "checkout.Forever Living Products {{countryName}} GmbH",
        translateParams: { countryName: '' }
    };
    itemTotal: number;
    cityList: any = [];
    itemShippingCost: number
    deliveryOptionPurchaseFlow: string;
    @ViewChild('paymentModal') paymentModalPopup: Modal;
    @ViewChild('payvisionPayment') payvisionPayment: Modal;
    @ViewChild('overrideMinimumLimit') overrideMinimumLimit: Modal;
    @ViewChild('eCheckPaymentPopup') eCheckPaymentPopup: Modal;
    @ViewChild('showWorldPayXMLPopup') showWorldPayXMLPopup: Modal;
    @ViewChild('showAdyenPaymentPopup') showAdyenPaymentPopup: Modal;
    @ViewChild('showNIPopup') showNIPopup: Modal;
    @ViewChild('showNexioPopup') showNexioPopup: Modal;
    @ViewChild('achPaymentPopup') achPaymentPopup: Modal;
    @ViewChild('shipMethodId') shipMethodId: ElementRef;
    @ViewChild('creditCardPayment') creditCardPayment: ElementRef;
    @ViewChild('paymentFormBtn') paymentFormBtn: ElementRef;
    @ViewChild('eCheckPayment') eCheckPayment: ElementRef;
    @ViewChild('savedCardsDdl') savedCardsDdl: ElementRef;
    @ViewChild('savedEcheckDdl') savedEcheckDdl: ElementRef;
    @ViewChild('showRestrictedProducts') showRestrictedProducts: Modal;
    @ViewChild('outOfStockModal') outOfStockModal: Modal;
    @ViewChild('saveEcheckFormBtn') saveEcheckFormBtn: ElementRef;
    @ViewChild('savedAddress') savedAddressElement: ElementRef;
    @ViewChild('addNewAddressEle') addNewAddressEle: ElementRef;
    @ViewChild('seachItemElement') seachItemElement: ElementRef;
    @ViewChild('itemLevelSearch') itemLevelSearch: ElementRef;
    @ViewChild('paymentAch') paymentAch: ElementRef;
    @ViewChild('updateMemberLevel') updateMemberLevelPopup: Modal;
    @ViewChild('orderTypeChangeConfirmation') orderTypeChangeConfirmation: Modal;
    operatingCountry: any = [];
    isOverrideMinimumLimit: boolean = false;
    billingAddressInfo: any;
    imageTypes: any = ImageType;
    paymentComponentSettings: PaymentComponentSettings = new PaymentComponentSettings();
    memberId: number;
    countryCode: string;
    addNewpayvisionCard: boolean;
    selectedpayvisionCardInfo: any;
    orderSession: any = {};
    isOrderSessionInfo: boolean;
    addNeweCheck: boolean;
    selectedECheckInfo: PersonalCheck;
    selectedAchInfo: PersonalAch;
    echeckForm: FormGroup;
    accountTypes: Array<string>;
    echeckRequest: PersonalCheck;
    achRequest: PersonalAch;
    achPaymentInfo: any;
    eCheckTokenRes: string;
    savedEChecks: string;
    isWorldpayPayment: boolean;
    isAdyenPayment: boolean;
    isNIPayment: boolean;
    showWorldpayXml: boolean;
    showAdyenPayment: boolean;
    showNIPayment: boolean;
    echeckSubmitted: boolean;
    createOrderInfo: any;
    eCheckValidationMessages: Array<String>;
    restrictedProducts: Array<String>;
    shippingAddressInfoConfig: ShippingAddressInfoConfig;
    checkoutConfig: CheckoutConfig;
    appConfig: AppCountryConfig;
    skipAddressVerification: boolean;
    zipCodePatterns: any;
    setPickupAddress: Address;
    deliveryPreferenceType: any = this.deliveryPreference.DELIVERY;
    FBORegularOrderPermissions: number[] = [
        Permission.REGULAR_ORDER_CREATE,
        Permission.REGULAR_ORDER_MANAGE
    ];
    FBOPOSOrderPermissions: number[] = [
        Permission.POS_ORDER_CREATE,
        Permission.POS_ORDER_MANAGE
    ];

    serviceOrderTypePermissions: number[] = [
        Permission.REPLACEMENT_ORDER_CREATE,
        Permission.REPLACEMENT_ORDER_MANAGE
    ];

    overrideMinimumOrderLimitPermissions: number[] = [
        Permission.OVERRIDE_MINIMUM_LIMIT
    ]
    hasPOSOrderPermissions: boolean;
    hasRegularOrderPermissions: boolean;
    hasNewFPCOrderPermissions: boolean;
    hasNewFBOOrderPermissions: boolean;
    showPOSOrderValidation: boolean;
    hasMinimumOverrideLimit: boolean;
    shippingSchemaUrl: string;
    billingSchemaUrl: string;
    showShippingData: boolean;
    showSavedAddress: boolean;
    showAddressForm: boolean;
    savedAddressId: number;
    money_Order_show: boolean;
    wire_Transfer_show: boolean;
    bank_transfer_show: boolean;
    ach_show: boolean
    cash_on_delivery_show: boolean;
    orange_money_show: boolean;
    backDateOrderPermission = false;
    enableBackDateOrder = false;
    thresholdCrossed: boolean;
    memberCCLimitExceeded: boolean;
    orderRules: OrderRulesResponse;
    memberOrderCCInfo: MemberOrderCCInfo;
    personalDiscountPercentage: number;
    productErrorMsg: string;
    savePaymentMethod: boolean;
    monthlyCCValue: number;
    isNewCard: Boolean = false;
    memberCCOverride: MemebrCCOverrideResponse;
    memberCCOverrideLimitExceeded: boolean;
    memberCart: Cart;
    memberCartInfo: Cart;
    createShoppingBagPermission: boolean;
    viewShoppingBagPermission: boolean;
    shoppingCartCount = 0;
    depositFeeProductCount = 0;
    itemCount = 0;
    existingItemCount = 0;
    isRestrictionPopupOpened: boolean;
    shoppingBagClicked: boolean;
    showOptin: boolean;
    outOfStockItems: Product[];
    hasNewGuestOrderPermissions: boolean;
    hasNewRetailOrderPermissions: boolean;
    stores: Country[];
    storeLanguages: Language[];
    agreementDocuments: DocumentLibrary[];
    agreementCheck: boolean;
    guestFormValidated: boolean;
    guestPersonalInfoFormValid = true;
    personalInformation: PersonalInformation;
    retuningGuestUser: Member;
    sponsorPollCount = 0;
    sponsorMaxPollCount = environment.longPollCount;
    isSponsorFound: boolean;
    sponsorInformation: SponsorInformation;
    documentsRequest: DocumentLibraryRequest;
    isGuestMemberType = false;
    legalRequirements: LegalRequirements;
    // handle all error messages
    fieldErrors: any[];
    personalInfoFormValid = true;
    mailingSchemaUrl: string;
    displayMailingAddressForm: boolean;
    mailingAddress: Address;
    memberCommunicationPreferences: MemberCommunicationPreference = {
        email: true,
        phone: false
    };
    liveFormAddress: Address;
    rebindSponsorData: RebindSponsorData;
    orderTypeSelectedValue: number;
    liveFormPersonalInfo: PersonalInformation;
    distributorMaxCC: number;
    existingCC: number;
    memberDiscountPercentage: DiscountPercentageResponse;
    memberCartSessionGuid: string;
    mailAlreadyExist = false;
    showMailingAddress = true;
    showShippingAddress = true;
    addNewCardClicked: boolean;
    isMemberHasAccessToOrder = true;
    restrictedDays = 0;
    cartLimitExceed = false;
    cartLimitNotReach = false;
    sponsorConfig: SponsorConfig;
    paymentTypeEnum = PaymentType;
    bankDetailsList = [];
    shippingTax: number;
    memberShippingDiscountOfferEligible = false;
    originalShippingTax: number;
    shippingAddressChanged: boolean;
    orderTypePrevValue: number;
    countryID: any;
    updateCartProduct: number;
    updateMemberDetail: any;
    achToken: string;
    addNewAchCard: boolean;
    fboReferralId: string;
    taxType = TaxType;
    addressSearchResult: any[] = [];
    businessEntityId: number;
    serviceOrderPermissions: boolean;
    enableServiceOrder = environment.enableServiceOrder;

    phoneNumberFormat: string;
    bonusInformation: BonusInfo
    bonusPaymentOption = BonusPaymentOption;
    bonusPaymentOptionType: string;
    bonusInfoSchemaUrl: string;
    personalInfoConfig: PersonalInfoConfig;
    bonusInfoFormValidated = true;
    bonusInfoVerified: boolean;
    isNewFPC: boolean;
    guestToRetailMember: any;
    guestToRetailShippingId: any;
    productPromotionResponse: PromotionReponseModel;
    promotionRequest: PromotionRequestModel;
    productPromotions: ProductRewardModel[] = [];
    promotionModels = [];
    clickTimeout = [];
    promotionIds = [];
    paymentTermsAndPoliciyDocuments: DocumentLibrary[];
    hide_direct_debit: boolean;
    homeCountry: string;
    ShippingPhoneNumberFormat: string;
    beneluxCountry: boolean = false;
    bonusInfoAgreements: DocumentLibrary[] = [];
    bonusInfoAgreementCheckError: boolean;
    hasFboBonusInfoViewPermission: boolean = false;
    hasFboBonusInfoDeletePermission: boolean = false;
    hasFboBonusInfoManagePermission: boolean = false;
    hasPersistedMemberId: boolean = false;
    persistedMemberId: string;
    businessInfoSchemaUrl: string;
    initialPaymentMethods: any;
    dropShipDeliveryOptionDisabled = false;
    storeLanguageCultureName: string;
    hidePudoPickupLocationsButton: boolean = true;
    formPickupPersonAddressValid: boolean;
    zipPattern: any;
    productDiscountPercentage: any;
    accountRestriction: boolean = false;
    memberDetails: any;
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    accountViewPermission: boolean = false;
    displayDropAddress: boolean;
    showDropShipPersonAddressForm: boolean = false;
    dropShipOptionAvailable = false;
    dropShipAddress: any | {};
    dropLoactionSelected = false;
    depsoitFeeProductsInfo: Product[] = [];
    productAssociationInfo: ProductAssociation[] = [];
    purchaseFlowType = null;
    enableRetailFreeShipping = environment && environment.enableRetailFreeShipping ? true : false;
    retailFreeShippingEnabledCountries = environment.retailFreeShippingEnabledCountries;
    RFSConstants = RetailFreeShippingConstants;
    sessionGuid: any;
    orderLevelDiscount = 0;
    isBWPEnabledProduct: boolean = false;
    isBWPEnabled: boolean = false;
    isSelectedBonusPaymentOptionType: boolean = false;
    scandinavianCountry: string
    liveFormStatusIsValid: boolean;
    liveFormStatusIsValidAndProductsEnabled: boolean;
    bonusInfoAvailable: boolean = false;
    isTaxMetaDataAvailable: boolean;
    isWorldPayEnabledCountry: boolean;
    retailDeliveryFee: number = 0;
    pudoSuggestedAddressSubscription: Subscription;
    sponsorSearchTimeDelay = environment.sponsorSearchTimeDelay;
    isPrivacyPreference: boolean;
    zipCodePattern: any;
    storePaymentInfo: any;
    enableNexioPaymentForPickUpCenter: boolean = environment.enableNexioPaymentForPickUpCenter;
    isShippingTaxAddedToShippingCost: boolean = false;
    customBankTransferDetailsConfiguration = BankWireTransferConstants.BankTransferCountries;
    customWireTransferDetailsConfiguration = BankWireTransferConstants.WireTransferCountries;
    showCustomerBankTransferDetails = false;
    showCustomerWireTransferDetails = false;
    isPickUpOptionExist = false;
    isDropShipOptionExist = false;
    showDistance: boolean = false;
    constructor(private _orderService: OrderService,
        private _echeckService: EcheckService,
        private _sanitizer: DomSanitizer,
        private _formbuilder: FormBuilder,
        private _http: Http,
        private _commonService: CommonService,
        private _translatePipe: TranslateService,
        private _translateKey: TranslateKey,
        private _documentService: DocumentService,
        private _currencyPipe: CurrencyTransformPipe,
        private _cacheService: CacheService,
        private _customerService: CustomerService,
        private messageService: MessageService,
        private _payvisionService: PayvisionService,
        private _titleCase: TitleCasePipe,
        private _maskPipe: MaskPipe,
        private _enrollmentMessageService: EnrollmentMessageService,
        private _enrollmentCommonService: EnrollmentCommonService,
        private _addressService: AddressService,
        private _enrollService: EnrollService,
        private _shippingAddressInfoConfigService: ShippingAddressInfoConfigService,
        private _sponsorConfigService: SponsorConfigService,
        private _checkoutConfigService: CheckoutConfigService,
        private _memberDisplayPriceConfigService: MemberDisplayPriceConfigService,
        private chRef: ChangeDetectorRef,
        private _appConfigService: AppConfigService,
        private _translateService: TranslateService,
        private _achService: AchService,
        private _sponsorService: SponsorService,
        private _configurationService: ConfigurationService,
        private _personalInfoConfigService: PersonalInfoConfigService,
        private _personalMessageService: PersonalMessageService,
        private _groupByPipe: GroupByPipe,
        @Inject(DOCUMENT) private document: any
    ) {
    }
    ngOnInit(): void {
        this.dropShipDeliveryOptionDisabled = false;
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        this.showDistance = environment.restrictGoogleMapNavigation;
        this.getDistributorInfoFromStorage();
        this.subscribePersistedMemberId();
        this.getAllPermissions();
        this.buildForm();
        this.getOperatingCountries();
        this.getStates();
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);

        if (this.orderSession && (this.orderSession.orderType === OrderType.NEW_FPC || this.orderSession.orderType === OrderType.NEW_FBO || this.orderSession.orderType === OrderType.SERVICE_ORDER)) {
            this.orderTypeChange(this.orderSession.orderType);
            this.pudoAddress = this.orderSession.pudoaddress ? this.orderSession.pudoaddress : this.pudoAddress;
            return;
        }
        sessionStorage.removeItem(CacheKey.OrderInfo);

        if (this.orderSession) {
            this.shoppingBagClicked = this.orderSession && this.orderSession.shoppingBagClicked ? true : false;
            this.memberCartSessionGuid = this.orderSession.memberCartSessionGuid;
            this.minMaxPriceValidation = this.orderSession.minMaxPriceValidation;
            this.businessEntityId = this.orderSession.businessEntityId;
            this.taxCalculationStatus = this.orderSession.taxCalculationStatus;
            this.languageCulture = this.orderSession.languageCulture;
            this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
            this.shipMethods = this.orderSession.shipMethods;
            this.storeInfo = this.orderSession.storeInfo;
            if (this.storeInfo && this.memberInfo) {
                this.memberInfo = { ...this.memberInfo, displayMiddleName: this.storeInfo.displayMiddleName };
            }
            this.appConfig = this.orderSession.appConfig;
            this.orderTaxResponse = this.orderSession.orderTaxResponse;
            this.countryTaxInclusive = this.orderSession.countryTaxInclusive;
        }

        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.getCountries();
        this.getZipCodePatterns();
        this.deleteModal = new DeleteModal(this.clearData.bind(this),
            this.closeDeleteMessage.bind(this), this.closeDeleteMessage.bind(this));
        this.deleteModal.viewActionButtons = true;

        this.selectedPaymentMethod = PaymentMethodTypes.Credit_Card.toString();
        this.orderFromLookup || this.isOrderSessionInfo
            ? (document.getElementById('country') ? document.getElementById('country').focus() : null)
            : (document.getElementById('memberInfo') ? document.getElementById('memberInfo').focus() : null);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.sessionGuid = this._cacheService.getSessionValue(CacheKey.SessionGuid) || this._enrollmentCommonService.getSessionGuid();
        this.accountTypes = [AccountType.Checking, AccountType.Savings];
        this.subscribeSaveAddress();
        this.setPUDOSuggestedAddress();
    }

    clearData(): void {

    }

    getFormControls() {
        const items: any = this.orderFormGroup.get('items');
        return items.controls;
    }

    closeDeleteMessage(): void {

    }

    /**
     * @description This method used to get all permissions
     * getAllPermissions()
     * @memberof OrderPromotionComponent
    */
    getAllPermissions(): void {
        this.backDateOrderPermission = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.ORDER_BACKDATE + ']'), AccessLevel.Customer_Service);
        this.hasRegularOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + this.FBORegularOrderPermissions + ']'), AccessLevel.Customer_Service);
        this.hasPOSOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + this.FBOPOSOrderPermissions + ']'), AccessLevel.Customer_Service);
        this.hasNewGuestOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.MANAGE_RETAIL_AND_GUEST + ']'), AccessLevel.Customer_Service);
        this.hasNewRetailOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.MANAGE_RETAIL + ']'), AccessLevel.Customer_Service);
        this.hasNewFPCOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.MANAGE_FPC + ']'), AccessLevel.Customer_Service);
        this.hasNewFBOOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.MANAGE_FBO + ']'), AccessLevel.Customer_Service);
        this.createShoppingBagPermission = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.CREATE_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.viewShoppingBagPermission = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.serviceOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + this.serviceOrderTypePermissions + ']'), AccessLevel.Customer_Service);
        this.hasMinimumOverrideLimit = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + this.overrideMinimumOrderLimitPermissions + ']'), AccessLevel.Customer_Service);
    }

    /**
     * @description This method used to prevent click event
     * onClickOfOrderType()
     * @memberof OrderPromotionComponent
    */
    onClickOfOrderType(event, orderType: OrderType): void {
        this.showDropShipPersonAddressForm = false;
        this.displayDropAddress = false;
        this.orderFormGroup.controls['orderType'].setValue(this.orderTypePrevValue);
        if (orderType === this.orderTypePrevValue) {
            return;
        }
        this.orderTypeSelectedValue = orderType;
        if(this.countries.length < 1){
            this.getCountries();
        }
        if (this.memberInfo || this.mailingAddress || this.shippingAddressInfo || this.address || this.personalInformation
            || this.sponsorInformation || (this.products && this.products.length) || (this.updateCartProduct > 0) || (this.updateMemberDetail != null)) {
            this.orderTypeChangeConfirmation.open();
            event.preventDefault ? event.preventDefault() : (event.returnValue = false);
        } else {
            this.orderTypeChange(orderType);
        }
    }

    onSelectOrderTypeChange(orderType: OrderType) {
        this.removeSessionGuid();
        this.orderTypeChange(orderType);
    }

    removeSessionGuid(): void {
        this._cacheService.removeSessionValue(CacheKey.SessionGuid);
    }
    //#region #Start Order Type Section

    orderTypeChange(orderType: OrderType) {
        this.mailAlreadyExist = false;
        this.orderTypePrevValue = orderType;
        this.updateCartProduct = 0;
        this.updateMemberDetail = null;
        this.orderFormGroup.controls['orderType'].setValue(orderType);
        if (!this.isOrderSessionInfo) {
            this.address = null;
            this.showSelectedShipMethod = false;
            this.showShippingData = false;
            this.paymentComponentSettings.savedCards = [];
        }
        if (!this.isOrderSessionInfo) {
            this.hasPersistedMemberId && orderType === OrderType.REGULAR ? this.clearAllTheForms(true, true) : this.clearAllTheForms(true, true, true);
        } else {
            this.clearAllTheForms();
        }
        if (orderType === OrderType.REGULAR) {
            this.onselectRegularOrder();
        } else if (orderType === OrderType.POS) {
            this.onSelectPOSOrder();
        } else if (orderType === OrderType.NEW_GUEST_RETAIL || orderType === OrderType.NEW_RETAIL) {
            this.onSelectNewGuestOrRetailFlow();
        } else if (orderType === OrderType.NEW_FPC) {
            this.isNewFPC = true;
        } else if (orderType === OrderType.SERVICE_ORDER) {
            this.isNewFPC = false;
        }
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    }

    /**
     * @description This method used to settings for POS order flow
     * onselectRegularOrder()
     * @memberof OrderPromotionComponent
    */
    onSelectPOSOrder(): void {
        this.orderFormGroup.controls['memberInfo'].setValidators([Validators.required,
        Utils.noEmptyString, Utils.searchByMemberValidation]);
        this.disableDelivery = true;
        this.orderFormGroup.patchValue({
            deliveryPreference: DeliveryPreference.PICKUP
        });
        if (this.orderFromLookup) {
            this.getDistributorInfo();
        }
        this.updateTotalsAndShipMethod();
    }

    /**
     * @description This method used to settings for regular order flow
     * onselectRegularOrder()
     * @memberof OrderPromotionComponent
    */
    onselectRegularOrder(): void {
        if (this.createOrderInfo && this.createOrderInfo.distributorId) {
            this.fboid = this.createOrderInfo.distributorId;
        }
        if (this.hasPersistedMemberId && (!this.fboid || !this.orderFormGroup.controls['memberInfo'].value)) {
            this.fboid = this.persistedMemberId;
        }
        this.orderFormGroup.controls['memberInfo'].setValidators([Validators.required,
        Utils.noEmptyString, Utils.searchByMemberValidation]);
        this.disableDelivery = false;
        this.orderFormGroup.patchValue({
            deliveryPreference: DeliveryPreference.DELIVERY
        });
        this.updateTotalsAndShipMethod();
        if (this.orderFromLookup || this.hasPersistedMemberId) {
            this.getDistributorInfo();
        }
    }

    /**
     * @description This method used to reset settings for new guest order flow
     * onSelectNewGuestOrRetailFlow()
     * @memberof OrderPromotionComponent
    */
    onSelectNewGuestOrRetailFlow(): void {
        this.fboid = '';
        this.selectedIsoCountryCode = 'usa';
        this.memberInfo = null;
        this.orderFormGroup.controls['memberInfo'].clearValidators();
        this.orderFormGroup.controls['memberInfo'].updateValueAndValidity();
        this.memberTypeId = this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL ? MemberTypeEnum.GUEST
            : MemberTypeEnum.RETAIL;
        this.stores.forEach((allowedCountry: Country) => {
            const countryObj = this.countries.filter((country: Country) =>
                allowedCountry.isocodeThree === country.isocodeThree)[0];
            if (countryObj) {
                allowedCountry.id = countryObj.countryId;
                allowedCountry.name = countryObj.name;
                allowedCountry.isoCodeThree = countryObj.isocodeThree;
                allowedCountry.isoCodeTwo = countryObj.isocodeTwo;
            }
        });
        const countryId = this.stores.find(store => store.isocodeThree.toUpperCase() === IsoCodeThree.USA).id || this.stores[0].id;
        this.isOrderSessionInfo ? this.orderFormGroup.controls['countryId'].setValue(this.orderSession.countryId)
            : this.orderFormGroup.controls['countryId'].setValue(countryId);
        this.selectedCountry();
        this.disableDelivery = false;
        this.pickupDeliveryOptionAvailable = false;
        this.paymentComponentSettings.billingAddress = null;
        if (!(this.orderFormGroup.value.deliveryPreference) || !(this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY)) {
            this.orderFormGroup.patchValue({
                deliveryPreference: DeliveryPreference.DELIVERY
            });
        }
        this.showDropShipPersonAddressForm = false;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    }



    //#region #Start Build Forms Section

    /**
     * build Form
     */
    buildForm() {
        const isServiceOrder = this._cacheService.get(CacheKey.IsServiceOrder);
        const orderType = isServiceOrder ? OrderType.SERVICE_ORDER : (this.hasPOSOrderPermissions && !this.hasRegularOrderPermissions ? OrderType.POS : OrderType.REGULAR);
        this._cacheService.remove(CacheKey.IsServiceOrder);
        this.orderFormGroup = this._formbuilder.group({
            orderType: [orderType],
            memberInfo: ['', [Validators.required, Utils.noEmptyString, Utils.searchByMemberValidation]],
            items: this._formbuilder.array(this.items),
            countryId: ['', [Validators.required]],
            deliveryPreference: [DeliveryPreference.DELIVERY],
            shippingAddressId: [''],
            shipMethodId: ['', [Validators.required]],
            originalShippingCost: [0, [Validators.required]],
            shippingCost: [''],
            shippingCostPercentage: [''],
            itemSearch: [''],
            itemLevelSearch: [''],
            shippingCostSelector: [this.selectEnum.firstOption.toString()],
            paymentInstrumentId: ['', [Validators.required]],
            paymentSelector: [],
            backDateOrder: [false],
            saveForFutureUse: [false],
            language: [],
            isContactSponsor: [null],
            isShippingDiscountApplied: [false],
            originalShippingTax: [0, [Validators.required]]
        });
        this.orderTypeChange(this.orderFormGroup.controls['orderType'].value);
        this.buildPudoLocationSearchForm();
        this.buildPayByLinkForm();
    }

    /**
     * set Distributor Info from FboId
     */
    getDistributorInfo() {
        this.orderFormGroup.controls['memberInfo'].setValue(this.fboid);
        this.searchMember();
    }

    getDistributorInfoFromStorage(): void {
        this.createOrderInfo = this._cacheService.get('CreateOrderInfo');
        this._cacheService.remove('CreateOrderInfo');
        if (this.createOrderInfo) {
            this.fboid = this.createOrderInfo.distributorId;
            this.shoppingBagClicked = this.createOrderInfo.shoppingBagClicked;
            this.orderFromLookup = true;
        }
    }

    onKeydown(event: any) {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    }
    /**
     * create item number
     * @returns FormGroup
     */
    createItemNumberGroup(): FormGroup {
        return this._formbuilder.group({
            itemNumber: [''],
            quantity: [''],
            productId: [''],
            productItem: [{}],
            productNumber: [''],
            productName: [''],
            productImage: [[]],
            disableIncrement: [false],
            disableDelete: [false],
            disableDecrement: [true],
            isDepositFeeProduct: [false],
            depositFeeEnabled: [false]
        });
    }
    /**
    * ShippingAddressForm Intialize
    */
    createNewShippingAddress(): FormGroup {
        return this._formbuilder.group({
            name: [''],
            addressLine1: [''],
            addressLine2: [''],
            addressLine3: [''],
            addressLine4: [''],
            city: [''],
            stateId: [''],
            countryId: [''],
            postalCode: [''],
            phone: ['']
        });
    }

    getZipCodePatterns() {
        this._commonService.getZipCodePatterns().subscribe((response: any) => {
            this.zipCodePattern = response;
            const pattern = this.zipCodePattern.filter(x => x.isoCodeThree
                === this.selectedIsoCountryCode.toUpperCase())[0];
            this.zipPattern = pattern ? pattern.zipPattern : null;
        });
        return Validators.pattern(new RegExp(this.zipPattern));

    }

    buildPudoLocationSearchForm(zipCode: string = '', city: string = '', addressLine1: string = '', country: string = '', externalId: string = '') {
        this.pudoLocationSearchForm = this._formbuilder.group({
            zipCode: [zipCode, [Validators.required, this.getZipCodePatterns()]],
            externalId: [externalId],
            city: [city, [Validators.required]],
            country: [country],
            addressLine1: [addressLine1]
        })
        const countryCode = this.selectedIsoCountryCode || '';
        this.pudoLocationSearchForm.patchValue({
            country: countryCode.toUpperCase()
        });
    }
    //#region #Start Countries/ Store and States Section
    /**
    * get Countries
    */
    getCountries() {
        const allCountries = JSON.parse(localStorage.getItem("appadmin.Countries"));
        if (allCountries) {
            this.countries = allCountries;
            this._cacheService.set(CacheKey.COUNTRIES, this.countries);
            this.stores = this.countries.filter(country => country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled && this.isLiveCountry(country.isocodeThree));
            if (!this.orderFromLookup && this.fboid) {
                this.getDistributorInfo();
            } else if (this.isOrderSessionInfo) {
                this.orderFormGroup.controls['memberInfo'].setValue(this.orderSession.memberInfo);
                this.searchMember();
                this.orderFormGroup.controls['orderType'].setValue(this.orderSession.orderType);
                if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                }
                this.orderTypeChange(this.orderFormGroup.controls['orderType'].value);
            }
            this.orderFromLookup = this.isOrderSessionInfo ? this.orderSession.orderFromLookup : this.orderFromLookup;

        }

    }

    /**
     * @description this method will check Give country Titan Live Country Or Not
     * @author Akhil
     * @date 2021-09-16
     * @param {string} countryCode
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    isLiveCountry(countryCode: string): boolean {
        if (environment.liveCountries) {
            const liveCountries = environment.liveCountries.toLowerCase().split(',');
            if (liveCountries && liveCountries.length) {
                return liveCountries.some((liveCountryCode) => liveCountryCode.toLowerCase() === countryCode.toLowerCase());
            }
        }
        return true
    }
    /**
     * get States
     */
    getStates() {
        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
            }
        });
    }

    /**
     * Get Country Info by Code or Id
     * @param countryId
     * @param countryCode
     */
    private getCountryDetailsByCountryIdOrCode(countryId: number, countryCode: string): any {
        let countryObj = {};
        if (countryId) {
            countryObj = this.countries.filter((x: any) => x.countryId === countryId)[0];
        }
        if (countryCode) {
            countryObj = this.countries.filter((x: any) => x.isocodeThree === countryCode)[0];
        }
        return countryObj;
    }

    /**
     * Get State Info by Code or Id
     * @param stateId
     * @param stateCode
     */
    private getStateDetailsByStateIdOrCode(stateId: number, stateCode: string, countryCode?: string): any {
        let stateObj = {};
        if (stateId) {
            stateObj = this.states.filter((x: any) => x.id === stateId)[0];
        }
        if (stateCode && countryCode) {
            stateObj = this.states.filter((x: any) => x.stateCode === stateCode && x.countryCode === countryCode)[0];
        } else if (stateCode){
            stateObj = this.states.filter((x: any) => x.stateCode === stateCode)[0];
        }
        return stateObj;
    }

    /**
     * Checks Whether Order Can be BackDated or Not
     * @param timeZoneOffset
     */
    isBackDateOrderAvailable = (timeZoneOffset: number, operatingCountry: string) => {
        this.enableBackDateOrder = false;
        let processingMonth;
        let processingYear;
        var date = new Date();
        if (date.getMonth() === 0) {
            processingMonth = 12;
            processingYear = date.getFullYear() - 1;
        } else {
            processingMonth = date.getMonth();
            processingYear = date.getFullYear();
        }
        if (operatingCountry && processingMonth && processingYear) {
            this._customerService.getBonusRunStatusDetails(operatingCountry, processingMonth, processingYear).subscribe((response) => {
                if (response && response.success && response.bonusStatus && response.validations.length === 0) {
                    if ((response.bonusStatus.toLowerCase() === BonusConstants.Open.toLowerCase())
                        || (response.bonusStatus.toLowerCase() === BonusConstants.Restricted.toLowerCase())) {
                        this._orderService.isBackDateOrderAllowed(timeZoneOffset, this.countryCode).subscribe(response => {
                            if (response && response.success) {
                                this.enableBackDateOrder = true;
                            } else {
                                this.enableBackDateOrder = false;
                            }
                        }, (error) => {
                            this.enableBackDateOrder = false;
                        });
                    }
                }
            }, (error) => {
                this.enableBackDateOrder = false;
            });
        }
    }

    /**
     * event for OrderBackDate CheckBox change
     */
    backDateOrderChange(event) {
        this.orderFormGroup.controls['backDateOrder'].setValue(event.target.checked);
    }

    /**
     * On Country Select
     */
    selectedCountry() {
        this.isWhosaleCheckNotCalculated = false;
        this.showAddressForm = false;
        this.displayMailingAddressForm = false;
        this.isMemberHasAccessToOrder = true;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
        const selectedCountryID = this.orderFormGroup && this.orderFormGroup.value ? this.orderFormGroup.value.countryId : null;
        if (selectedCountryID) {
            const countryObj = this.countries.filter((x: Country) => x.countryId === +selectedCountryID)[0];
            if (this.memberInfo) {
                this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
            }
            this.orderFormGroup.controls['countryId'].disable();
            if (countryObj) {
                this.translateOptions.translateParams.countryName = countryObj.name;
                this.selectedIsoCountryCode = countryObj.isocodeThree;
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
                if(this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState){
                    this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                    this._cacheService.set(CacheKey.COUNTRY_ID,countryObj.countryId);
                    this.getCitiesByStates();
                }else{
                    this._cacheService.remove(CacheKey.COUNTRY_CODE);
                    this._cacheService.remove(CacheKey.COUNTRY_ID);
                }
                if (this.memberInfo && this.memberInfo.memberId && this.checkoutConfig && this.checkoutConfig.displayBusinessEntity) {
                    this.loadMemberBasicInfo(this.memberInfo.memberId);
                }
                this.getPaymentRules();
                this.countryCode = countryObj.isocodeThree;
                this.getZipCodePatterns();
                this.showShippingData = true;
                this.documentsRequest = null;
                this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                this.selectedCountryCodeTwo = countryObj.isocodeTwo;
                this.paymentComponentSettings.isoCountryCode = countryObj.isocodeThree;
                this.paymentComponentSettings.isoTwoletterCountryCode = countryObj.isocodeTwo;
                this.storeInfo = null;
                this.sponsorConfig = this._sponsorConfigService.getSettings(countryObj.isocodeThree);
                this.storeId = 0;
                this._enrollmentMessageService.setStoreInfo(this.storeInfo);
                this.getStoreInfo(countryObj.isocodeThree);

                this.skipAddressVerification = this.checkoutConfig.skipAddressVerification;
                if (this.checkoutConfig && this.checkoutConfig.loadParticipatingCountries) {
                    this.getParticipatingCountries(countryObj.isocodeThree);
                }
                if (!this.orderFormGroup.value.orderType || (this.orderFormGroup.value.orderType !== this.orderType.NEW_GUEST_RETAIL
                    && this.orderFormGroup.value.orderType !== this.orderType.NEW_RETAIL)
                    && this.checkoutConfig && !this.checkoutConfig.loadParticipatingCountries) {
                    this.getMemberAddressByMemberId(this.memberInfo.memberId, selectedCountryID);
                }
                this.clearAllTheForms(false);
                this.orderSession != null && this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
                this.address = null;
            }
        }
    }

    /**
    * @description This method used to load guest data from order session
    * loadGuestOrderSession()
    * @returns void
    */
    loadGuestOrderSession(): void {
        if (this.isOrderSessionInfo) {
            this.personalInformation = this.orderSession.personalInformation;
            this.mailAlreadyExist = this.orderSession.mailAlreadyExist;
            this.mailingAddress = this.orderSession.mailingAddress;
            this.memberCommunicationPreferences = this.orderSession.memberCommunicationPreferences;
            this.liveFormAddress = this.orderSession.liveFormAddress;
            this.orderFormGroup.controls['isContactSponsor'].setValue(this.memberCommunicationPreferences.email);
            this.retuningGuestUser = this.orderSession.retuningGuestUser;
            this.agreementDocuments = this.orderSession.documents;
            this.orderFormGroup.controls['language'].setValue(this.orderSession.language);
            this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
            this.guestToRetailShippingId = this.orderSession.verifiedShippingAddressId;
            this.isOverrideMinimumLimit = this.orderSession.isOverrideMinimumLimit;
            this.fetchTermsConditionDocument(this.agreementDocuments);
            if (this.orderSession.shippingAddressId || this.orderSession.shippingAddressInfo || this.orderSession.pudoaddress) {
                this.address = this.orderSession.shippingAddressInfo;
                if (this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                    this.address = this.orderSession.pudoaddress;
                    this.pudoAddress = this.address;
                }
                this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId, { onlySelf: true });
                if (this.address) {
                    this.shippingAddressInfo = this.address;
                    this.shippingAddressInfo.phoneNumber = this.address.phoneNumber ? this.address.phoneNumber : this.address.phone ? this.address.phone : null;
                    this.shippingAddressInfo.email = this.address.email ? this.address.email : null;
                    this.savedAddressId = this.address.id;
                    this.constructSchemaFormUrl(this.countryCode);
                    this.address.isSavedAddress = this.orderSession.isSavedAddress;
                    this.showShippingData = true;
                    this.address.id = this.orderSession.shippingAddressId;
                    this.pudoAddress = this.address;
                }
            } else {
                this.constructSchemaFormUrl(this.countryCode);
            }
            // check for shpping address when order info is in cache
            this.loadproductsFromSession();
        }
    }

    /**
    * @description This method used to get cart items by member
    * getCartItemsByMemberAndCartTypeId()
    * @returns void
    */
    getCartItemsByMemberAndCartTypeId(storeInfo: StoreConfig, isSaveBagClicked?: boolean): void {
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId,
            CartTypes.OrderCart, storeInfo)
            .subscribe((cartInfo: Cart) => {
                if (cartInfo && cartInfo.sessionGuid) {
                    this.memberCart = cartInfo;
                    if (!this.isOrderSessionInfo && cartInfo.items && cartInfo.items.length && !isSaveBagClicked) {
                        const productIds = cartInfo.items.map(x => x.productId);
                        this.getProductsByIds(productIds, storeInfo);
                    }
                } else {
                    this.memberCart = null;
                }
                if (isSaveBagClicked) {
                    this.saveBag(true);
                }
            }, error => {
                new Error(error);
            });
    }

    getCitiesByStates() {
        const countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
        this._addressService.getCitiesList(countryId).subscribe((response: any) => {
          console.log(response);
          
          if (response) {
            this.cityList = response;
            this._cacheService.set(CacheKey.Cities, response)
          }
        }
        );
      }

    buildReferenceNumberForm() {
        this.paymentReferenceNumber = this._formbuilder.group({
            referenceNumber: ['']
        })
    }
    paymentReferenceNumberFormValidations() {
        const paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        this.paymentReferenceNumber.get('referenceNumber').clearValidators();
        if (paymentSelectorValue === this.paymentTypeEnum.Orange_Money) {
            this.paymentReferenceNumber.get('referenceNumber').setValidators([Validators.required,Validators.maxLength(18),Validators.pattern('[O,o]{1}[M,m]{1}[ ]{0,1}[0-9]{1,}')]);
        } else if (paymentSelectorValue === this.paymentTypeEnum.Money_order) {
            this.paymentReferenceNumber.get('referenceNumber').setValidators([Validators.required, Validators.maxLength(18),Validators.pattern('[W,w]{1}[A,a]{1}[V,v]{1}[E,e]{1}[ ]{0,1}[0-9]{1,}')]);
        }
    }

    /**
     * get products by Ids
     */
    getProductsByIds(productsIds: Array<number>, storeInfo: StoreConfig) {
        let fpc5PercentEnabled: boolean = false;
        const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        let memberTitleId = this.memberInfo && this.memberInfo.memberLevelId
            ? this.memberInfo.memberLevelId : this.memberInfo.memberTitleId;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this.purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
        // HARD_DOWNGRADE CHECK FOR FPC USERS
        memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, storeInfo.id,
            memberTitleId, this.purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, storeInfo.taxInclusive).subscribe(response => {
                if (response && response.length > 0) {
                    this.loadproducts(response);
                }
            });
    }

    /**
     *load procducts from session
     */
    loadproducts(products: Product[]) {
        products.forEach((product: Product) => {
            this.addItemNumber();
            const items: any = this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                const index = (items.length - 1);
                if (product) {
                    const itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                    const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
                    const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (this.isOrderSessionInfo) {
                        const productInfo = this.orderSession.products.find((item: any) => product.id === item.productId);
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    } else if (this.orderFormGroup && !this.isOrderSessionInfo) {
                        let productInfo = null;
                        if (this.memberCart && this.memberCart.items.length > 0) {
                            productInfo = this.memberCart.items.find((item: any) => product.id === item.productId);
                        }
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    }
                    if (items.controls[index].controls['quantity'].value === 1) {
                        items.controls[index].controls['disableDecrement'].setValue(true);
                    } else {
                        items.controls[index].controls['disableDecrement'].setValue(false);
                    }
                    if (depositFeeEnabled) {
                        this.getDepositFeeProduct(product, true);
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && !this.isOrderSessionInfo) {
            this.getShipMethods();
        }
    }

    /**
    * Save and update bag items
    * @returns void
    */
    saveBag(isFallBack?: boolean): void {
        const items = this.getOrderLineItems(this.countryTaxInclusive);
        if (items && items.length) {
            if (this.memberCart && this.memberCart.sessionGuid) {
                this.prepareCartUpdateRequest();
                this._customerService.updateCart(this.memberCart, CartTypes.OrderCart,
                    this.storeInfo.id, this.memberInfo.memberId, 1).subscribe(response => {
                        if (response) {
                            this.createSuccessNotification(response);
                            this._cacheService.set(CacheKey.CARTUPDATED, 'true');
                        }
                    });
            } else {
                if (!isFallBack) {
                    this.getCartItemsByMemberAndCartTypeId(this.storeInfo, true);
                } else {
                    const cart = this.prepareCartCreateRequest();
                    this._customerService.saveCart(cart, CartTypes.OrderCart,
                        this.storeInfo.id, this.memberInfo.memberId, 1).subscribe(response => {
                            if (response) {
                                this.createSuccessNotification(response);
                                this._cacheService.set(CacheKey.CARTUPDATED, 'true');
                            }
                        });
                }
            }
            this.getShoppingCartCount(this.storeInfo);
        }
    }

    /**
    * show success notification after updating cart items
    * createSuccessNotification()
    * @returns void
    */
    createSuccessNotification(response: Cart): void {
        this.memberCart = response;
        const notification = this._translatePipe.get('order.Member cart items updated successfully')['value'];
        this._commonService.createNotification('', notification, NotificationType.SUCCESS);
    }

    /**
    * prepare create request
    * prepareCartCreateRequest()
    * @returns void
    */
    prepareCartCreateRequest(): Cart {
        const items = this.getOrderLineItems(this.countryTaxInclusive);
        const memberCart: Cart = { items: [] };
        items.forEach(item => {
            const productItem: Item = {
                productId: item.productId,
                quantity: item.quantity
            };
            memberCart.items.push(productItem);
        });
        return memberCart;
    }

    /**
    * prepare update request
    * prepareCartUpdateRequest()
    * @returns void
    */
    prepareCartUpdateRequest(): void {
        const items = this.getOrderLineItems(this.countryTaxInclusive);
        items.forEach(item => {
            const product = this.memberCart.items.find(itm => itm.productId === item.productId);
            if (product) {
                this.memberCart.items.forEach(cart => {
                    if (cart.productId === product.productId) {
                        cart.quantity = this.shoppingBagClicked ? item.quantity : cart.quantity + Number(item.quantity);
                    }
                });
            } else {
                const productItem: Item = {
                    productId: item.productId,
                    quantity: item.quantity
                };
                this.memberCart.items.push(productItem);
            }
        });
        if (this.shoppingBagClicked) {
            this.memberCart.items = this.memberCart.items.filter(item => {
                return items.map(product => product.productId).indexOf(item.productId) > -1;
            });
        }
    }

    /**
    * removing not available cart items based on logged in user
    * @param  {Cart} orderCart
    * @param  {CartItem[]} unAvailableCartItems
    */
    private deleteCart(sessionGuid: string) {
        if (sessionGuid) {
            this.shoppingCartCount = 0;
            this.itemCount = 0;
            this._customerService.removeCartItem(sessionGuid,
                this.storeInfo.id).subscribe(response => {
                });
        }
    }

    /**
     * @description constructing the schema form url
     * @date 2018-11-27
     * @memberof OrderPromotionComponent
     */
    constructSchemaFormUrl(countryCode: string): void {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        /*this.shippingSchemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;*/
        this.billingSchemaUrl = countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
            + environment.templateVersion;
        this.mailingSchemaUrl = countryCode.toLowerCase() + '-mailing-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(() => {
            this.address = this.address;
            this.mailingAddress = this.mailingAddress;
            this.displayMailingAddressForm = true;
            this.showAddressForm = true;
            this.shippingDeliveryOptionAvailable = true;
            }, 500);
        this.orderFormGroup.controls['countryId'].enable();
    }

    /**
     * @description get member cart items list
     * @date 2019-10-15
     * @memberof OrderPromotionComponent
     */
    getMemberCartItems(storeInfo: StoreConfig): void {
        if (this.orderFormGroup && this.orderFormGroup.value.orderType === this.orderType.REGULAR
            && this.shoppingBagClicked && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId(storeInfo);
        } else {
            this.memberCart = null;
        }
    }

    // get existing shopping cart item count
    getShoppingCartCount(storeInfo: StoreConfig): void {
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId,
            CartTypes.OrderCart, storeInfo)
            .subscribe((cartInfo: Cart) => {
                this.existingItemCount = 0;
                if (cartInfo && cartInfo.sessionGuid) {
                    this.memberCartInfo = cartInfo;
                    this.existingItemCount = 0;
                    let cartItems = cartInfo.items;
                    for (let index = 0; cartItems.length > 0 && cartItems.length > index; index++) {
                        this.existingItemCount += cartItems[index].quantity;
                    }
                    this.shoppingCartCount = this.existingItemCount;
                } else {
                    this.existingItemCount = 0;
                }
            }, error => {
                new Error(error);
            });
    }

    /**
     * Get Store Info
     * @param countryCode
     */
    getStoreInfo(countryCode: any, member?: boolean) {
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(response => {
                if (response) {

                    const storeInfo = response;
                    this.storeDetails = response
                    if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                        this.getShoppingCartCount(storeInfo);
                    }

                    this.distributorMaxCC = storeInfo.distributorMaxCC;
                    if (this.memberInfo && this.memberInfo.fboId && this.memberInfo.memberAllowedCountries
                        && this.memberInfo.memberAllowedCountries.length > 0
                        && (+this.memberInfo.memberTypeId === MemberTypeEnum.FPC || +this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
                        if (countryCode) {
                            this.getWholsesaleQualifiedDetails(this.memberInfo.fboId, countryCode, storeInfo);
                        } else {
                            this.getMemberDiscountPercentages(storeInfo);
                        }
                    } else {
                        this.getMemberDiscountPercentages(storeInfo);
                    }
                    this.storeId = response.id;
                    this.countryCode = countryCode;
                    this.getZipCodePatterns()
                    this.countryTaxInclusive = storeInfo.taxInclusive;
                    this.shippingAddressInfoConfig = this._shippingAddressInfoConfigService.getSettings(countryCode);
                    this.appConfig = this._appConfigService.getSettings(countryCode, this.memberInfo); //storeConfiguration
                    if (this.appConfig.enablePaymentReferenceNumber) {
                        this.buildReferenceNumberForm();
                    }
                    this.getOrderRules(storeInfo);
                    if (this.appConfig.isWireTransferLabelWithoutGmbh) {
                        this.translateOptions.translateText = "checkout.Forever Living Products {{countryName}}";
                    }
                    if (response.languages && response.languages.length > 0) {
                        this.storeDefaultLanguage = response.languages.find((languageCulture: any) => languageCulture.default).cultureName;
                        this.languageCulture = this.storeDefaultLanguage;
                        this.payByLinkLanguageShortCode = response.languages.find((languageCulture: any) => languageCulture.default).languageCode;
                    } else {
                        this.storeDefaultLanguage = this.languageCode;
                        this.languageCulture = this.languageCulture;
                        this.payByLinkLanguageShortCode = this.payByLinkLanguageShortCode;
                    }
                    if (this.customBankTransferDetailsConfiguration && this.customWireTransferDetailsConfiguration && this.selectedIsoCountryCode) {
                        let language = this._cacheService.get(CacheKey.Language);
                        this.showCustomerBankTransferDetails = this.customBankTransferDetailsConfiguration.includes(this.selectedIsoCountryCode) && language.toLowerCase() == this.storeDefaultLanguage.toLowerCase();
                        this.showCustomerWireTransferDetails = this.customWireTransferDetailsConfiguration.includes(this.selectedIsoCountryCode) && language.toLowerCase() == this.storeDefaultLanguage.toLowerCase();
                    }
                    if (this.orderFormGroup.value.orderType === this.orderType.REGULAR) {
                        let memberType: string;
                        if (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST) {
                            memberType = MemberType.GUEST;
                            this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;

                            if (this.isOrderSessionInfo) {
                                this.sponsorInformation = this.orderSession.sponsorInformation;
                            }
                        } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
                            memberType = MemberType.Distributor;
                            this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;

                        } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
                            memberType = MemberType.PREFERRED_CUSTOMER;
                            this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;

                        } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.RETAIL) {
                            memberType = MemberType.RETAIL;
                            this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                        }


                        this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
                        const getDeliveryOptionsRequest: any = {
                            memberTypeId: this.memberInfo ? this.memberInfo.memberTypeId : MemberTypeEnum.RETAIL,
                            memberType: memberType.toUpperCase(),
                            source: Source.CSP,
                            countryCode: countryCode,
                            purchaseFlow: this.deliveryOptionPurchaseFlow,
                            storeId: this.storeId
                        };
                        this.shippingDeliveryOptionAvailable = false;
                        this.pickupDeliveryOptionAvailable = false;
                        this._orderService.getDeliveryOptions(countryCode, getDeliveryOptionsRequest).subscribe(res => {
                            if (res) {
                                this.dropShipDeliveryOptionDisabled = false;
                                res.forEach(option => {
                                    if (option.optionValue === DelivaryOptionType.Delivery) {
                                        this.shippingDeliveryOptionAvailable = true;
                                    }
                                    if (option.optionValue === DelivaryOptionType.Pickup) {
                                        this.pickupDeliveryOptionAvailable = true;
                                    }
                                    if (option.optionValue === DelivaryOptionType.Dropship) {
                                        if (option.optionDisabled) {
                                            this.dropShipDeliveryOptionDisabled = true;
                                        } else if (this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                            this.dropShipOptionAvailable = true;
                                        } else {
                                            this.pickupDeliveryOptionAvailable = true;
                                        }
                                    }
                                });
                                // Dynamic Delivery option changes .
                                const isDropShip = res.find((x)=> x.optionValue == DelivaryOptionType.Dropship);
                                const isPickUp = res.find((x)=> x.optionValue == DelivaryOptionType.Pickup);
                                if (environment.scandinavianCountries && countryCode) {
                                    let scandinavianCountries = environment.scandinavianCountries;
                                    this.scandinavianCountry = scandinavianCountries.split(",").find(country => country === countryCode);
                                }
                                // For Scandian country checking for Pickup
                                if (this.scandinavianCountry && isPickUp) {
                                    this.isPickUpOptionExist = true;
                                }
                                // For Non-Scandian country checking for DropShip
                                if (!this.scandinavianCountry && isDropShip && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && !this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                    this.isDropShipOptionExist = true;
                                }
                                // For Non-Scandian country checking for PickUp
                                if (!this.scandinavianCountry && isPickUp && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                    this.isPickUpOptionExist = true;
                                }
                                if (!this.scandinavianCountry && isPickUp && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                    this.isPickUpOptionExist = true;
                                }
                                if (!this.pickupDeliveryOptionAvailable &&
                                    (+this.orderFormGroup.controls['orderType'].value === OrderType.POS)) {
                                    this.showPOSOrderValidation = true;
                                } else {
                                    this.showPOSOrderValidation = false;
                                    this.storeInfo = storeInfo;
                                    if (this.memberInfo) {
                                        this.memberInfo = { ...this.memberInfo, displayMiddleName: this.storeInfo.displayMiddleName };
                                    }
                                    this.storeInfo.ccNumberDecimals = 3;
                                    this.overrideMinimumLimitIsEnabled = this.getOverrideMinimumLimit();
                                    this.storeInfo.ccNumberFormat = 'CR';
                                    this.storeInfo.ccSymbol = 'CC';
                                    if (this.memberInfo) {
                                        this.loadSavedCardsForMemberId(this.memberInfo.memberId, countryCode);
                                        this.achToken = '';
                                        //this.getSavedEchecks();
                                    }
                                    if (this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                                        this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                                        this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
                                        this.constructSchemaFormUrl(this.countryCode);
                                        this.validationsOnDeliveryPreference();
                                    }
                                    this.paymentComponentSettings.languageCode = this.languageCode;
                                    this.paymentComponentSettings.storeId = this.storeInfo.id;
                                    this.paymentComponentSettings.currencyCode = this.storeInfo.currencyCode;
                                    this.paymentComponentSettings.numberDecimals = this.storeInfo.numberDecimals;
                                    this.countryCode = countryCode;
                                    this.getZipCodePatterns()
                                    this.memberId = this.memberInfo ? this.memberInfo.memberId : null;
                                    if (this.isOrderSessionInfo) {
                                        this.updateTotalsAndShipMethod();
                                    }
                                }
                                if (this.orderSession && this.orderSession.deliveryPreference === this.deliveryPreference.DROPSHIP
                                    && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                    this.getPudoLocations();
                                }
                            }
                        });
                        this.getStorePromotions();
                        this.getPaymentMethodsByStore();
                    } else {
                        this.guestFlowSettings(response);
                        this.getStorePromotions();
                    }
                    this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
                }
            }, error => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Store Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
    }

    /**
     * @description
     * @date 2020-04-20
     * @memberof OrderPromotionComponent
     */
    getMemberRankLevelHistory(orderRulesRequest, storeInfo: StoreConfig, userInfo: Member, isFboUpgradeFlow: boolean): void {
        if (!isFboUpgradeFlow) {
            return;
        }
        this.isFBOValidationPending = true;
        if (this.memberInfo && this.memberInfo.memberId && storeInfo && storeInfo.countryId) {
            this._commonService.getMemberRankLevelHistory(this.memberInfo.memberId, storeInfo.countryId)
                .subscribe(response => {
                    if (response) {
                        this.memberLevelHistory = response;
                        const memberLevelInfo = this.memberLevelHistory
                            .find((memberLevel: MemberLevelHistory) => memberLevel.memberTitleId === MemberTitleExtEnums.PreferredCustomer);
                        const isMemberFboUpgraded = memberLevelInfo ? true : false;
                        let enrollmentWindowDate: Date;
                        enrollmentWindowDate = this.memberInfo.enrolmentDate ? new Date(this.memberInfo.enrolmentDate)
                            : new Date(this.memberInfo.createdDate);
                        enrollmentWindowDate.setHours(0, 0, 0, 0);
                        enrollmentWindowDate.setDate(enrollmentWindowDate.getDate() + this.restrictedDays);
                        const currentDate = new Date();
                        currentDate.setHours(0, 0, 0, 0);
                        this.isFBOValidationPending = false;
                        if (isMemberFboUpgraded && (enrollmentWindowDate.getTime() > currentDate.getTime())) {
                            orderRulesRequest.optinFbo = true;
                            this.isMemberFboUpgraded = true;
                            this.getBusinessOrderRules(orderRulesRequest, userInfo, true);
                        } else {
                            this.isMemberFboUpgraded = false;
                            this.getBusinessOrderRules(orderRulesRequest);
                            this.getMemberOrderRules(userInfo, false);
                        }
                    } else {
                        this.memberLevelHistory = [];
                        this.isMemberFboUpgraded = false;
                        this.isFBOValidationPending = false;
                        this.getMemberOrderRules(userInfo, false);
                        this.getBusinessOrderRules(orderRulesRequest);
                    }
                });
        }
    }

    /**
     * @description
     * @date 2019-10-23
     * @private
     * @memberof OrderPromotionComponent
     */
    private loadMemberShoppingCart(storeInfo: StoreConfig): void {
        // get Member cart items when shopping bag clicked
        if (this.orderFormGroup.value.orderType === this.orderType.REGULAR && !this.memberCartSessionGuid
            && this.shoppingBagClicked && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId(storeInfo);
        }
        else if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.memberCart = null;
        } else {
            this.memberCart = null;
        }
    }

    /**
     * @description
     * @date 2019-10-21
     * @private
     * @memberof OrderPromotionComponent
     */
    private getMemberDiscountPercentages(storeInfo: StoreConfig): void {
        this.loadMemberShoppingCart(storeInfo);
        const optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        const wholeSaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false;
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status*/
        const memberTitleID = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        if (this.memberInfo) {
            this.memberInfo.transactionalWholesaleQualified = wholeSaleQualified;
            this.memberInfo.transactionalOptin = optin;
        }
        if (this.taxCalculationStatus) {
            this.updateTotalsAndShipMethod();
        }
        this._commonService.getDiscountPercentages(wholeSaleQualified, optin, memberTitleID, storeInfo.id).
            subscribe(response => {
                this.memberDiscountPercentage = response;
            });
    }

    /**
    * @description This method used to load default settings for guest flow
    * guestFlowSettings()
    * @returns void
    */
    guestFlowSettings(response: StoreConfig): void {
        this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this.getPaymentMethodsByStore(this.memberTypeId);
        this.loadPreferences(response);
        this.loadDeliveryOptions(response);
        if (this.isOrderSessionInfo) {
            this.rebindSponsorData = this.orderSession.rebindSponsorData;
            this.sponsorInformation = this.orderSession.sponsorInformation;
        }
        this.storeId = response.id;
        this.storeInfo = response;
        // if(this.storeInfo){
        // this.memberInfo = {...this.memberInfo, displayMiddleName : this.storeInfo.displayMiddleName};
        // }
        this._enrollmentMessageService.setStoreInfo(this.storeInfo);
        this.storeLanguages = response.languages;
        this.paymentComponentSettings.languageCode = this.languageCode;
        this.overrideMinimumLimitIsEnabled = this.getOverrideMinimumLimit();
        this.paymentComponentSettings.storeId = this.storeInfo.id;
        this.paymentComponentSettings.currencyCode = this.storeInfo.currencyCode;
        this.paymentComponentSettings.numberDecimals = this.storeInfo.numberDecimals;
        this.storeInfo.ccNumberDecimals = 3;
        this.storeInfo.ccNumberFormat = 'CR';
        this.storeInfo.ccSymbol = 'CC';
        if (this.appConfig && this.storeInfo && this.appConfig.enablePrivacyPreference) {
            this.storeInfo.enablePrivacyPreference = this.appConfig.enablePrivacyPreference;
            this.isPrivacyPreference = this.storeInfo.enablePrivacyPreference;
        } else {
            this.isPrivacyPreference = false;
        }

        if (this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
            this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
            this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
            this.constructSchemaFormUrl(this.countryCode);
            this.validationsOnDeliveryPreference();
        }
        if (response.languages && response.languages.length > 0) {
            this.storeDefaultLanguage = this.storeLanguages.find((languageCulture: Language) =>
                languageCulture.default).cultureName || this.storeLanguages[0].cultureName;
        }
        this.isOrderSessionInfo ?
            this.orderFormGroup.controls['language'].setValue(this.orderSession.language)
            : this.orderFormGroup.controls['language'].setValue(this.storeLanguages.find(item => item.default).cultureName);
        this.storeLangCultureId = this.orderFormGroup.get('language').value ? this.storeLanguages.
            find(language => language.cultureName.toLowerCase() == this.orderFormGroup.get('language').value.toLowerCase()).cultureId : ""
        this.orderFormGroup.controls['countryId'].enable();
        if (this.isOrderSessionInfo) {
            this.updateTotalsAndShipMethod();
        }
        if (this.orderSession && this.orderSession.deliveryPreference === this.deliveryPreference.DROPSHIP
            && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.getPudoLocations();
        }
        this.constructSchemaFormUrl(this.countryCode);
        if (this.isOrderSessionInfo) {
            this.loadGuestOrderSession();
        } else {
            this.documentsRequest = null;
            this.prepareAgreementDocumentsRequest();
        }
    }

    /**
    * @description This method used to load delivery options based on member type
    * loadDeliveryOptions()
    * @returns void
    */
    loadDeliveryOptions(response: StoreConfig): void {
        let memberType = '';
        let purchaseFlow = '';
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            memberType = MemberType.RETAIL;
            this.deliveryOptionPurchaseFlow = PurchaseFlows.ENROLLMENT;

        } else if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
            memberType = UserTitleType.GUEST;
            this.deliveryOptionPurchaseFlow = PurchaseFlows.ENROLLMENT;
        }
        const getDeliveryOptionsRequest: any = {
            memberTypeId: this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL ? MemberTypeEnum.RETAIL
                : MemberTypeEnum.GUEST,
            memberType: memberType.toUpperCase(),
            source: Source.CSP,
            countryCode: this.countryCode,
            purchaseFlow: this.deliveryOptionPurchaseFlow,
            storeId: this.storeId

        };
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this._orderService.getDeliveryOptions(this.countryCode, getDeliveryOptionsRequest).subscribe(res => {
            if (res) {
                this.dropShipDeliveryOptionDisabled = false;
                res.forEach(option => {
                    if (option.optionValue === DelivaryOptionType.Delivery) {
                        this.shippingDeliveryOptionAvailable = true;
                    }
                    if (option.optionValue === DelivaryOptionType.Pickup) {
                        this.pickupDeliveryOptionAvailable = true;
                    } if (option.optionValue === DelivaryOptionType.Dropship) {
                        if (option.optionDisabled) {
                            if (option.optionDisabled) {
                                this.dropShipDeliveryOptionDisabled = true;
                            }
                            this.dropShipDeliveryOptionDisabled = true;
                        } else if (this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                            this.dropShipOptionAvailable = true;
                        } else {
                            this.pickupDeliveryOptionAvailable = true;
                        }
                    }
                     // Dynamic Delivery option changes .
                     const isDropShip = res.find((x)=> x.optionValue == DelivaryOptionType.Dropship);
                     const isPickUp = res.find((x)=> x.optionValue == DelivaryOptionType.Pickup);
                     if (environment.scandinavianCountries && this.countryCode) {
                         let scandinavianCountries = environment.scandinavianCountries;
                         this.scandinavianCountry = scandinavianCountries.split(",").find(country => country === this.countryCode);
                     }
                     // For Scandian country checking for Pickup
                     if (this.scandinavianCountry && isPickUp) {
                        this.isPickUpOptionExist = true;
                    }
                    // For Non-Scandian country checking for DropShip
                    if (!this.scandinavianCountry && isDropShip && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && !this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                        this.isDropShipOptionExist = true;
                    }
                    // For Non-Scandian country checking for PickUp
                    if (!this.scandinavianCountry && isPickUp && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                        this.isPickUpOptionExist = true;
                    }
                    if (!this.scandinavianCountry && isPickUp && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                        this.isPickUpOptionExist = true;
                    }
                    this.loadSavedCardsForMemberId(0, this.selectedIsoCountryCode);
                });

            }
        });
    }

    //#endregion

    // region #Start Member Function Section
    /**
     * On Member Details Search
     */
    searchMember() {
        this.isWhosaleCheckNotCalculated = false;
        this.isMemberHasAccessToOrder = true;
        this.searchReqValues = this.orderFormGroup.getRawValue();
        const distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        let fboId = this.searchReqValues.memberInfo;
        if (new RegExp(distributorIdPattern).test(this.searchReqValues.memberInfo)) {
            fboId = fboId.replace(/-|\s/g, '');
        }
        this.memberSearchSubmitted = true;
        this.memberInfo = null;
        if (this.orderFormGroup.value.memberInfo && this.orderFormGroup.value.memberInfo.length > 0) {
            this.getMemberInfo(fboId);
        }
    }

    /**
     * Get Member Info by EmailID or FBOID
     */
    getMemberInfo(memberDetails: string) {
        let type = '';
        type = memberDetails.indexOf('@') > -1 ? 'email' : 'fboId';
        this.isActive = true;
        this._orderService.getMemberInfo(memberDetails, type).subscribe(response => {
            if (response && response.memberId) {
                this.memberInfo = response;
                this.isBWPEnabled = this.memberInfo.memberMetaData.find(x => x.customKey === MemberMetaDataEnum.BWPENABLED && x.customValue === '1');
                this.dateOfBirthMember = response.dateOfBirth;
                if (response.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
                    this.getMembergovernmentIdentificationsInfo(response.memberId);
                }
                this._commonService.getMemberStatus(this.memberInfo.fboId).subscribe(accountInfo => {
                    if (accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission) {
                        const memberlevel = this._commonService.getMemberLevel(this.memberInfo.memberLevelID);
                        const memberDetails = {
                            fboId: this.memberInfo.fboId,
                            firstName: this.memberInfo.firstName,
                            lastName: this.memberInfo.lastName,
                            memberLevel: memberlevel
                        };
                        this.accountRestriction = true;
                        this.memberDetails = memberDetails;
                        this.orderFormGroup.controls['countryId'].setValue('');
                    } else {
                        this.getMemberInformation(memberDetails, response);
                    }
                    this.bonusInfoAvailable = false;

                });
            } else {
                this.clearAllTheForms(true, true);
                const notification: any = this._translatePipe.get('order.Member Details Not Found');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, error => {
            const notification: any = this._translatePipe.get('order.Unable to retrieve Member Details');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    }

    getMemberInformation(memberDetails, response) {
        this.persistedMemberId = memberDetails;
        this.hasPersistedMemberId = true;
        this.storeInfo = null;
        if (response.memberTitleId && response.memberTypeId && (response.memberTitleId === MemberTitleExtEnums.Novus_Customer
            && +response.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
            response.memberTitleId = MemberTitleExtEnums.PreferredCustomer;
        }
        // Add Validation for Member Level
        this.getMemberLevelInfo(response);
    }

    getMemberLevelInfo(memberResponse): void {
        this.processMemberResponse(memberResponse);
        this.accountMemberInfo = Object.assign({}, memberResponse);
    }

    processMemberResponse(response): void {
        this.memberInfo = response;
        this.memberInfo.enrolmentDate = this.memberInfo.lastUpgradedDate;
        if (this.memberInfo && (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST)) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        } else if (+response.memberTypeId === MemberTypeEnum.FPC || this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        else if (this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR && this.memberInfo.memberTitleId === MemberLevel.NOVICCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if (+response.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        this.orderTaxResponse = null;
        this.isCalculateTax = false;
        this.memberStatus = response.memberStatus;
        if (this.memberStatus && this.memberStatus.id) {
            this.isActive = (this.memberStatus.id === +MemberStatus.Active);
        } else {
            this.isActive = false;
        }
        if (+response.memberTypeId === MemberTypeEnum.GUEST) {
            this.memberInfo.memberLevel = MemberType.GUEST;
            this.isGuestMemberType = true;
        }
        this.memberSearchSubmitted = false;
        this.memberTypeId = this.memberInfo.memberTypeId;
        this._translatePipe.get('order.Member Details Found').subscribe(response => {
            if (response) {
                this._commonService.createNotification('', response, NotificationType.SUCCESS);
            }
        });
        this.clearAllTheForms();
        this.orderSession != null && this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
        if (this.memberInfo.memberAllowedCountries) {
            this.populateCountries(this.memberInfo.memberAllowedCountries);
        }
        if (this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            const country = this.countries.filter(x => x.countryId === this.memberInfo.address.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        this.paymentComponentSettings.memberId = this.memberInfo.memberId;
        this.paymentComponentSettings.memberTypeId = this.memberInfo.memberTypeId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        this.paymentComponentSettings.distributorId = this.memberInfo.fboId;
        this.paymentComponentSettings.uniqueRefId = this.memberInfo.uniqueRefID ? this.memberInfo.uniqueRefID : '';
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status*/
        const memberTitleID = this._orderService.getMemberTitleId(this.memberInfo);
        this.personalDiscountPercentage = this._commonService.getPersonalDiscount(memberTitleID);
    }

    /**
     * Get wholesale qualified details for a FPC / FBO based on memberID and countryCode
     * @param memberID
     * @param countryCode
     */

    private getWholsesaleQualifiedDetails(fboId: string, memberHomeCountry: string, storeInfo: StoreConfig) {
        this._commonService.getWholsesaleQualifiedDetails(fboId, memberHomeCountry)
            .subscribe((res: WholesaleQualifiedResponse) => {
                try {
                    if (res) {
                        this.isWhosaleCheckNotCalculated = false;
                        if (res && res.error) {
                            this.wholesaleCheckErrorNotifications();
                        }
                        this.memberInfo.optin = res.optIn ? res.optIn : false;
                        this.memberInfo.wholeSaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                        // Member wholesale qualified eligibility check
                        this.memberInfo.transactionalWholesaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                        this.memberInfo.transactionalOptin = res.optIn ? res.optIn : false;

                        let balance;
                        try {
                            balance = Number(res.balance);
                        } catch {
                            balance = this.distributorMaxCC;
                        }
                        if (!balance) {
                            balance = this.distributorMaxCC;
                        }
                        this.existingCC = balance;
                        this.getMemberDiscountPercentages(storeInfo);
                    }
                } catch (error) {
                    this.getMemberDiscountPercentages(storeInfo);
                    this.wholesaleCheckErrorNotifications();
                }
            }, error => {
                this.getMemberDiscountPercentages(storeInfo);
                this.wholesaleCheckErrorNotifications();
            });
    }

    loadMemberBasicInfo(memberId: number) {
        if (memberId && !this.businessEntityId) {
            this._customerService.getMemberBasicInfoById(memberId)
                .subscribe((res) => {
                    if (res && res.businessEntities) {
                        const activeBusinessEntity: FBOBusinessEntity = res.businessEntities.find((entity: FBOBusinessEntity) => entity.status === RowStatus.Active && entity.countryCodeId);
                        const country = this.countries && this.countries.find((country) => country && activeBusinessEntity && country.countryId === activeBusinessEntity.countryCodeId);
                        if (activeBusinessEntity && country.isocodeThree.toLowerCase() === this.countryCode.toLowerCase()) {
                            if (this._orderService.isValidDate(activeBusinessEntity.startDate, activeBusinessEntity.endDate)) {
                                this.businessEntityId = activeBusinessEntity.id;
                            } else {
                                this.businessEntityId = null;
                            }
                        }
                    }
                },
                    (error) => { }
                );
        }
    }

    /**
     * @description to display Error Message If WholesaleCheck  are not calculated
     * @author Akhil
     * @date 2021-02-10
     * @memberof OrderPromotionComponent
     */
    wholesaleCheckErrorNotifications() {
        this.isWhosaleCheckNotCalculated = true;
        let notification: any = this._translatePipe.get('order.The order is not receiving the PC Wholesale response from Valence. Please try again later.');
        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
    }

    /**
 * Member Allowed Countries Filter
 * @param memberAllowedCountries
 */
    private populateCountries(memberAllowedCountries: any) {
        this.memberCountries = [];
        this.dropShipDeliveryOptionDisabled = false;
        const countries = this._cacheService.get(CacheKey.COUNTRIES);
        if (countries && !this.stores) {
            this.countries = countries;
            this.stores = countries.filter(country => country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled);
        }
        if (memberAllowedCountries && memberAllowedCountries.length > 0 && this.countries && this.countries.length > 0) {
            memberAllowedCountries.forEach((allowedCountry: any) => {
                const countryObj = this.stores
                    .filter((country: any) => country.titanPlatformEnabled && allowedCountry.isoCodeThree === country.isocodeThree)[0];
                if (countryObj) {
                    if (!(this.memberCountries.findIndex((country: any) => country.isoCodeThree === countryObj.isocodeThree) >= 0)) {
                        this.memberCountries.push({
                            id: countryObj.countryId, name: countryObj.name, isoCodeThree: countryObj.isocodeThree,
                            isoCodeTwo: countryObj.isocodeTwo, homeCountry: allowedCountry.homeCountry
                        });
                        if (allowedCountry.homeCountry) this.homeCountry = allowedCountry.isoCodeThree;
                    }
                }
            });
            this.sortTableByColumn('name');
            if (this.isOrderSessionInfo) {
                this.orderFormGroup.controls['countryId'].setValue(this.orderSession.countryId);
                this.selectedCountry();
            } else if (this.createOrderInfo && this.createOrderInfo.countryId && this.shoppingBagClicked) {
                //  When we click shoppingbag icon from memberinfo tab(not for homecountry)
                this.orderFormGroup.controls['countryId'].setValue(this.createOrderInfo.countryId);
                this.selectedCountry();
            } else if (this.memberCountries.length > 0) {
                const countryObj = this.memberCountries.find(country => country.homeCountry === true);
                if (countryObj) {
                    this.orderFormGroup.controls['countryId'].setValue(countryObj.id);
                    this.translateOptions.translateParams.countryName = countryObj.name;
                } else {
                    this.orderFormGroup.controls['countryId'].setValue(this.memberCountries[0].id);
                }
                this.selectedCountry();
            }
        }
    }

    sortTableByColumn(property: any) {
        const direction = 1;
        this.memberCountries.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1 * direction;
            } else if (a[property] > b[property]) {
                return 1 * direction;
            } else {
                return 0;
            }
        });
    }

    /**
    *
    * @param memberId get Member Addresses
    */
    getMemberAddressByMemberId(memberId: any, countryId: any) {
        this.shippingAddressInfo = null;
        this.billingAddressInfo = null;
        this._orderService.getMemberAddressByMemberId(memberId, countryId).subscribe(response => {
            this.memberAddressDetails = [];
            this.memberShippingDetails = [];
            if (response && response.length > 0) {
                this.memberAddressDetails = response.filter(x => x.addressTypeId === AddressType.SHIPPING);
                this.memberAddressDetails = this._commonService.sortMemberAddress(this.memberAddressDetails);
                this.addressSearchResult = this.memberAddressDetails;
                if (!this.isOrderSessionInfo && (this.orderSession === null || !this.orderSession.shippingAddressId)) {
                    this.address = this.memberAddressDetails.find(x => x.defaultAddress === true);
                    if (this.address) {
                        this.address.phone = this.address.phoneNumber;
                        this.address.email = this.address.email ? this.address.email : null;
                        this.address.isShowStateCode = this.checkoutConfig.showStateCode;
                        this.address.isSavedAddress = true;
                        this.shippingAddressInfo = this.address;
                        this.savedAddressId = this.address.id;
                        this.showShippingData = true;
                        this.constructSchemaFormUrl(this.countryCode);
                    } else {
                        if (this.memberAddressDetails && this.memberAddressDetails.length > 0) {
                            this.address = this.memberAddressDetails[0];
                            this.shippingAddressInfo = this.address;
                        }
                        this.constructSchemaFormUrl(this.countryCode);
                    }
                }
                this.memberShippingDetails = response.filter(x => x.addressTypeId === AddressType.SHIPPING);
                if (this.isOrderSessionInfo) {
                    this.storeInfo = this.orderSession.storeInfo;
                    if (this.storeInfo && this.memberInfo) {
                        this.memberInfo = { ...this.memberInfo, displayMiddleName: this.storeInfo.displayMiddleName };
                    }
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
                    // check for shpping address when order info is in cache
                    if (this.orderSession.shippingAddressId) {
                        this.address = this.memberShippingDetails.find((x: any) => x.id === this.orderSession.shippingAddressId);
                        this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId, { onlySelf: true });
                        if (this.address) {
                            this.address.phone = this.address.phoneNumber;
                            this.address.email = this.address.email ? this.address.email : null;
                            this.address.isSavedAddress = true;
                            this.shippingAddressInfo = this.address;
                            this.savedAddressId = this.address.id;
                            this.constructSchemaFormUrl(this.countryCode);
                            this.showShippingData = true;
                        } else {
                            this.mapShippingAddressDetailsFromSession();
                        }
                    } else {
                        this.mapShippingAddressDetailsFromSession();
                    }
                    if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP ||
                        this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                        this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                        this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
                        this.constructSchemaFormUrl(this.countryCode);
                        this.validationsOnDeliveryPreference();
                    }
                    this.loadproductsFromSession();
                }
            } else {
                if (this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
                    if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP ||
                        this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                        this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                        this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
                        this.constructSchemaFormUrl(this.countryCode);
                        this.validationsOnDeliveryPreference();
                    } else {
                        if (this.orderSession.shippingAddressId) {
                            this.address = this.orderSession.shippingAddressInfo;
                            this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId,
                                { onlySelf: true });
                            if (this.address) {
                                this.shippingAddressInfo = this.address;
                                this.savedAddressId = this.address.id;
                                this.constructSchemaFormUrl(this.countryCode);
                                this.address.isSavedAddress = this.orderSession.isSavedAddress;
                                this.showShippingData = true;
                                this.verifiedShippingAddressId = this.orderSession.verifiedShippingAddressId;
                                this.address.id = this.orderSession.shippingAddressId;
                            }
                        } else {
                            this.mapShippingAddressDetailsFromSession();
                        }
                    }
                    // check for shpping address when order info is in cache
                    this.loadproductsFromSession();
                } else {
                        if (this.countryCode === this.homeCountry && this.memberInfo && this.memberInfo.address && this.allowMemberInfoAddress()) {
                        this.address = this.memberInfo.address;
                        this.address.email = this.memberInfo.email ? this.memberInfo.email : null;
                        this.address.firstName = this.memberInfo.firstName;
                        this.address.middleName = this.memberInfo.middleName;
                        this.address.lastName = this.memberInfo.lastName;
                        this.address.stateCode = this.memberInfo.address.stateCode;
                        this.address.countryCode = this.countryCode;
                        if (!this.address.countryId) {
                            this.address.countryId = this.memberCountries.find(country => country.isoCodeThree === this.countryCode).id;
                        }
                        this.address.isShowStateCode = this.checkoutConfig.showStateCode;
                        this.shippingAddressInfo = this.address;
                        this.savedAddressId = this.address.id;
                        this.showShippingData = true;
                    } else if (this.memberInfo) {
                        this.address = {};
                        this.address.email = this.memberInfo.email ? this.memberInfo.email : null;
                        this.address.firstName = this.memberInfo.firstName;
                        this.address.middleName = this.memberInfo.middleName;
                        this.address.lastName = this.memberInfo.lastName;
                        this.address.countryCode = this.countryCode;
                        this.address.countryId = this.memberCountries.find(country => country.isoCodeThree === this.countryCode).id;
                        const notification: any = this._translatePipe.get('order.Address Information for this member is not available to populate');
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    if (this.memberInfo.memberContacts && this.memberInfo.memberContacts.length > 0) {
                        const memberContact = this.getPhoneNumber(this.memberInfo.memberContacts);
                        if (memberContact) {
                            this.address.phoneType = memberContact.contactTypeID;
                            this.address.phone = memberContact.value ? memberContact.value : null;
                        }
                    }
                   this.constructSchemaFormUrl(this.countryCode);
                }
            }
            if (this.memberAddressDetails && this.memberAddressDetails.length === 0) {
                this.orderFormGroup.controls['shippingAddressId'].setValue('');
            }
        }, error => {
            this.orderFormGroup.controls['countryId'].enable();
            const notification: any = this._translatePipe.get('order.Unable to retrieve Member Addresses');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.constructSchemaFormUrl(this.countryCode);
        });
    }

    allowMemberInfoAddress(): boolean {
        if (this.memberInfo.address.countryId && this.memberCountries) {
            let country = this.memberCountries.find(country => country.isoCodeThree === this.countryCode);
            return country.id === this.memberInfo.address.countryId;
        }
        return true;
    }

    getPhoneNumber(memberContacts): MemberContact {
        const phoneType = this.checkoutConfig.removeMobileField ? ContactTypeValue.PHONE :  this.checkoutConfig.removePhoneField ?  ContactTypeValue.MOBILE :ContactTypeValue.MOBILE;
        let phoneNumber = memberContacts.find(item => (item.contactTypeID == phoneType) && item.value);
        return phoneNumber;
    }

    /**
   * Mapping Shipping address from session
   */
    mapShippingAddressDetailsFromSession() {
        if (this.orderSession && this.orderSession.shippingAddressInfo) {
            this.address = this.orderSession.shippingAddressInfo;
            this.shippingAddressInfo = this.address;
            this.shippingAddressInfo.email = this.address.email ? this.address.email : null;
            this.shippingAddressInfo.phoneNumber = this.address.phoneNumber ? this.address.phoneNumber : this.address.phone ? this.address.phone : null;
            this.savedAddressId = this.address.id;
            this.verifiedShippingAddressId = this.orderSession.verifiedShippingAddressId;
            this.address.isSavedAddress = this.orderSession.isSavedAddress;
            this.showShippingData = true;
        }
        this.constructSchemaFormUrl(this.countryCode);
    }

    // endregion
    /**
    * Delivery Preference On Change
    * @param value delivery preference
    */
    deliveryPreferenceOnChange() {
        this.deliveryPreferenceType = this.orderFormGroup.value.deliveryPreference;
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.isCalculateTax = false;
        this.shippingAddressChanged = false;
        this.dropShipAddress = null;
        this.dropLoactionSelected = false;
        if (this.countryCode.toUpperCase() == IsoCodeThree.USA && this.deliveryPreferenceType === ShippingType.DELIVERY && this.enableNexioPaymentForPickUpCenter) {
            this.getDeliveryOptionsPayment();
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }

        if (this.shippingAddressInfoConfig && ((this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist) && !this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
        } else {
            this.showPudoPickupPersonAddressForm = false;
            this.displayPudoAddress = false;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
            this.showPudoPickupPersonAddressForm = true;
        } else {
            this.showDropShipPersonAddressForm = false;
            this.displayDropAddress = false;
        }
        this.getShipMethods();
        this.constructSchemaFormUrl(this.countryCode);
        this.validationsOnDeliveryPreference();
        this.clearPudoLocationSearchData();
        //this.updateTotalsAndShipMethod();
    }
    /**
     * update validations on delivery preference
     */
    validationsOnDeliveryPreference() {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.shippingAddressInfo = null;
            this.orderFormGroup.controls['shipMethodId'].setValue('');
            this.orderFormGroup.controls['shippingCostSelector'].disable();
            this.getShipMethods(true);
        } else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY) {
            this.selectedpickup = undefined;
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
                this.mailingAddress = null;
                this.liveFormAddress = null;
            }
            this.orderFormGroup.controls['shippingCostSelector'].enable();
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
            this.updateTotalsAndShipMethod();
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.pudoShippingMethod = this.orderSession && this.orderSession.pudoShippingMethod ? this.orderSession.pudoShippingMethod : this.pudoShippingMethod;
            if (this.orderSession && this.orderSession.buildPudoLocationSearchForm) {
                this.pudoLocationSearchForm.controls['zipCode'].setValue(this.orderSession.buildPudoLocationSearchForm.zipCode);
                this.pudoLocationSearchForm.controls['city'].setValue(this.orderSession.buildPudoLocationSearchForm.city);
                this.pudoLocationSearchForm.controls['externalId'].setValue(this.orderSession.buildPudoLocationSearchForm.externalId);
                this.pudoLocationSearchForm.controls['zipCode'].updateValueAndValidity();
                this.pudoLocationSearchForm.controls['city'].updateValueAndValidity();
                this.pudoLocationSearchForm.controls['externalId'].updateValueAndValidity();
                if (this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    this.showPudoPickupPersonAddressForm = true;
                    this.displayPudoAddress = true;
                } else if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                    this.showDropShipPersonAddressForm = true;
                    this.displayDropAddress = true;
                }
                this.pudoAddress = this.orderSession.pudoaddress ? this.orderSession.pudoaddress : this.pudoAddress;
                this.pudoShippingAddressInfo = this.orderSession.pudoShippingAddressInfo ? this.orderSession.pudoShippingAddressInfo : this.pudoAddress;
            }
            this.selectedPudoCollectionPoint = this.orderSession && this.orderSession.selectedPudoCollectionPoint ? this.orderSession.selectedPudoCollectionPoint : this.selectedPudoCollectionPoint;
            this.shippingAddressSelectionChange();
            this.updateTotalsAndShipMethod();
        }

    }

    /**
     * map the billing address fields
     */
    mapBillingAddress() {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
            && (this.shippingAddressInfo && this.shippingAddressInfo.countryId)
            || (this.memberInfo && this.memberInfo.address && this.memberInfo.address.countryId) || (this.mailingAddress)) {
            let country: Country;
            const address = (this.memberInfo && this.memberInfo.address) || this.mailingAddress || this.shippingAddressInfo;
            this.paymentComponentSettings.billingAddress = address;
            if (address && (address.stateCode === PaymentConstants.PuertoRico
                || address.stateCode === PaymentConstants.MarshallIslands
                || address.stateCode === PaymentConstants.VirginIslands)) {
                if (address.stateCode === PaymentConstants.MarshallIslands) {
                    country = this.countries.filter(x => x.isocodeThree.toLowerCase()
                        === address.stateCode.toLowerCase())[0];
                } else {
                    country = this.countries.filter(x => x.isocodeTwo.toLowerCase()
                        === address.stateCode.toLowerCase())[0];
                }
            } else {
                country = this.countries.filter(x => x.countryId === address.countryId)[0];
            }

            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = address.postalCode;
        }
        else if (this.memberInfo && this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            const country = this.countries.filter(x => x.countryId === this.memberInfo.address.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        } else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.paymentComponentSettings.billingAddress = this.pudoAddress;
            const country = this.countries.filter(x => x.countryId === this.pudoAddress.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.pudoAddress.postalCode;
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.pudoShippingAddressInfo) {
                const pudoShippingAddressInfo: any = this.pudoShippingAddressInfo;
                this.paymentComponentSettings.billingAddress = pudoShippingAddressInfo;
                const country = this.countries.filter(x => x.countryId === pudoShippingAddressInfo.countryId)[0];
                this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
                this.paymentComponentSettings.billingAddress.zipCode = pudoShippingAddressInfo.postalCode;

            }
        }

    }

    /**
     * On Shipping Address Selected
     */
    selectedShippingAddress(address: Address) {
        this.addressSearchResult = this.memberAddressDetails;
        const addressDetailId = address.id;
        address.isSavedAddress = true;
        if (addressDetailId && this.memberShippingDetails) {
            const shippingAddress = this.memberShippingDetails.filter((x: any) => x.id === addressDetailId);
            if (shippingAddress && shippingAddress[0]) {
                this.shippingAddressInfo = shippingAddress[0].shippingAddress;
            }
        }
        this.savedAddressId = address.id;
        address.isShowStateCode = this.checkoutConfig.showStateCode;
        this.shippingAddressInfo = address;
        this.address = address;
        this.address.phone = this.address.phoneNumber;
        this.address.email = this.address.email ? this.address.email : null;
        this.showSavedAddress = false;
        this.updateTotalsAndShipMethod();
    }

    prepareNewAddress(address: any): any {
        if (address) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(+address.countryId, null);
            const stateObj = this.getStateDetailsByStateIdOrCode(+address.stateId, null);

            const addressObj = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                phone: address.phone,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: stateObj.stateCode || '',
                stateId: address.stateId,
                postalCode: address.postalCode,
                country: countryObj.isocodeThree || '',
                countryCodeThree: countryObj.isocodeThree || '',
                countryId: address.countryId,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse
            };
            return addressObj;
        }
    }

    /**
    * This method used to map communication preference
    */
    checkContactSponsor(): void {
        const memberCommunicationPreferences: MemberCommunicationPreference = {
            email: this.orderFormGroup.value.isContactSponsor,
            phone: false
        };
        this.memberCommunicationPreferences = memberCommunicationPreferences;
    }

    /**
       * verified Address Mapping
       * @param  {any}  address
       * @returns any
       */
    private mapVerifiedAddressToFormFields(address: any): any {
        if (address) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.country);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, address.state,address.country );
            const mapAddressToFields = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3 ? address.addressLine3 : '',
                addressLine4: address.addressLine4 ? address.addressLine4 : '',
                postalCode: address.postalCode,
                city: address.city,
                stateId: stateObj ? stateObj.id : null,
                stateCode: stateObj ? stateObj.stateCode : null,
                countryCode: countryObj ? (countryObj.countryCode || countryObj.isocodeThree) : null,
                countryId: countryObj ? countryObj.countryId : null,
                phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, '') : null,
                addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
                latitude: address.latitude,
                longitude: address.longitude,
                id: address.id,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null,
                isShowStateCode: this.checkoutConfig.showStateCode
            };
            return mapAddressToFields;
        }
    }

    /**
    * Add new Shipping Address
    * @param shippingAddressForm
    */
    useNewShippingAddress(addressInfo: any) {
        if (addressInfo) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(addressInfo.countryId, null);
            const stateObj = this.getStateDetailsByStateIdOrCode(addressInfo.stateId, null);
            this.shippingAddressInfo = {
                shipToName: addressInfo.name,
                firstName: addressInfo.firstName,
                middleName: addressInfo.middleName,
                lastName: addressInfo.lastName,
                addressLine1: addressInfo.addressLine1,
                addressLine2: addressInfo.addressLine2,
                addressLine3: addressInfo.addressLine3,
                addressLine4: addressInfo.addressLine4,
                city: addressInfo.city,
                stateId: stateObj.id,
                stateName: stateObj.stateName || '',
                state: stateObj.stateCode || '',
                stateCode: stateObj.stateCode || '',
                countryId: countryObj.countryId,
                countryName: countryObj.name || '',
                country: countryObj.isocodeThree || '',
                countryCode: countryObj.isocodeThree || '',
                postalCode: addressInfo.postalCode || addressInfo.zip,
                zip: addressInfo.postalCode || addressInfo.zip,
                phone: addressInfo.phone,
                addressVerified: addressInfo.addressVerified,
                latitude: addressInfo.latitude,
                longitude: addressInfo.longitude,
                phoneType: addressInfo.phoneType,
                isShowStateCode: addressInfo.isShowStateCode,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                disableAddressBlock: addressInfo.disableAddressBlock,
                deliveryInstruction: addressInfo.deliveryInstruction,
                email: addressInfo.email ? addressInfo.email : null
            };
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                this.pudoShippingAddressInfo = this.shippingAddressInfo;
                this.showPudoPickupPersonAddressForm = false;
            } else {
                this.shippingAddressInfo = this.shippingAddressInfo;
            }
            this.isNewCard = false;
            this.updateTotalsAndShipMethod();
        } else {
            this.showAddressFormValidations = true;
        }
    }
    /**
     * save address method
     */
    private saveAddress(addressDetails: any) {
        const saveAddressRequest: any = {
            id: null,
            memberId: this.memberInfo ? this.memberInfo.memberId : (this.guestToRetailMember ? this.guestToRetailMember.memberId : null),
            addressLine1: addressDetails.addressLine1,
            addressLine2: addressDetails.addressLine2,
            addressLine3: addressDetails.addressLine3 ? addressDetails.addressLine3 : '',
            addressLine4: addressDetails.addressLine4 ? addressDetails.addressLine4 : '',
            shipToName: addressDetails.name,
            city: addressDetails.city,
            stateId: addressDetails.stateId,
            countryId: addressDetails.countryId,
            postalCode: addressDetails.postalCode || addressDetails.zip,
            contactTypeID: 1,
            defaultAddress: false,
            addressVerified: addressDetails.addressVerified,
            latitude: addressDetails.latitude,
            longitude: addressDetails.longitude,
            addressTypeId: 40,
            loggedInUserId: this.memberInfo ? this.memberInfo.userId : (this.guestToRetailMember ? this.guestToRetailMember.userId : null),
            responseCodes: addressDetails.responseCodes ? addressDetails.responseCodes : null,
            phone: addressDetails.phone,
            phoneNumber: addressDetails.phone,
            firstName: addressDetails.firstName,
            middleName: addressDetails.middleName,
            lastName: addressDetails.lastName,
            phoneType: addressDetails.phoneType,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
            disableAddressBlock: addressDetails.disableAddressBlock,
            deliveryInstruction: addressDetails.deliveryInstruction,
            email: addressDetails.email ? addressDetails.email : null
        };
        this._orderService.saveVerifiedAddress(saveAddressRequest).subscribe(response => {
            if (response && response.addressDetail) {
                if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                    this.pudoAddress = addressDetails;
                    this.pudoAddress.id = response.addressDetail.id;
                    this.savedPudoAddressId = response.addressDetail.id;
                } else {
                    this.verifiedShippingAddressId = response.addressDetail.id;
                    this.address = addressDetails;
                    this.address.id = response.addressDetail.id;
                    this.orderFormGroup.controls['shippingAddressId'].setValue(response.addressDetail.id, { onlySelf: true });
                    this.savedAddressId = response.addressDetail.id;
                    if (this.shipMethodId && this.shipMethodId.nativeElement) {
                        this.shipMethodId.nativeElement.focus();
                    }
                }
                if (saveAddressRequest.saveForFutureUse) {
                    this.messageService.setAddressSaved(true);
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(false);
                }
            }

        }, error => {
            const notification: any = this._translatePipe.get('order.Unable to Save Member Address');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    }
    reEnterShippingAddress() {
        this.orderFormGroup.get('shippingAddressForm').reset();
    }
    // region #Start ShipMethods Section
    /**
       * on Shipping Method Change
       */
    selectShippingMethod(shippingMethod: ShippingMethod, isDeliveryOptionChange: boolean = false) {
        if (shippingMethod) {
            if (this.countryCode == IsoCodeThree.USA && this.deliveryPreferenceType === ShippingType.PICKUP && this.enableNexioPaymentForPickUpCenter) {
                this.getPickupDetailsForUSA(shippingMethod);
            }
            if (shippingMethod && (shippingMethod.pickUpLocation && (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP))) {
                this.taxCalculationStatus = true;
                this.getProcuctRestrictions(shippingMethod, shippingMethod.pickUpLocation, isDeliveryOptionChange);
                if (this.orderFormGroup.value.shipMethodId) {
                    this.selectedpickup = this.orderFormGroup.value.shipMethodId;
                }
            } else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                this.shippingCost = this.isOrderSessionInfo && (this.orderSession.shippingCostValue > 0 || this.orderSession.isShippingDiscountApplied) ?
                    this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = shippingMethod.shippingTax || 0;
                this.orginalShippingCost = this.memberInfo && this.memberInfo.vatRegistered ? shippingMethod.shippingCharge
                    : shippingMethod.shippingCharge + this.shippingTax;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.orginalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());
                    this.shippingCostChange();
                } else {
                    this.getShippingCostInPercentage();
                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
        }
    }
    selectPudoCollectionPoint(collectionPoint: CollectionPoint) {
        this.dropShipAddress = null;
        this.selectedPudoCollectionPoint = collectionPoint;
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.getPudoDropShipPersonAddress(collectionPoint);
            this.dropLoactionSelected = true;
            this.getShipMethods();
        }
        this.dropLoactionSelected = false;
        this.calculateOrderTax();
    }

    getProcuctRestrictions(shippingMethod: ShippingMethod, pickupAddress: any, isDeliveryOptionChange: boolean = false): void {
        const productRestrictionModel: ProductRestrictionModel = this.prepareProductRestrictionModelRequest(pickupAddress);
        this._commonService.getProductRestrictions(productRestrictionModel).subscribe((response) => {
            if (response && response.success && response.productModels) {
                this.getRestrictedProducts(response.productModels);
                this.taxCalculationStatus = true;
            } else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                this.shippingCost = this.isOrderSessionInfo ? this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = shippingMethod.shippingTax || 0;
                this.orginalShippingCost = this.memberInfo && this.memberInfo.vatRegistered ? shippingMethod.shippingCharge
                    : shippingMethod.shippingCharge + this.shippingTax;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.orginalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());
                    this.shippingCostChange();
                } else {
                    this.getShippingCostInPercentage();
                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
        });
    }

    /**
     * @description this method used for preparing product restriction odel request for pickup
     * @memberof ShippingAddressNewComponent
     */
    prepareProductRestrictionModelRequest(pickupAddress: any): ProductRestrictionModel {
        let productRestrictionModel: ProductRestrictionModel;
        productRestrictionModel = {
            countryCode: pickupAddress.countryCode,
            stateCode: pickupAddress.stateCode
        };
        const productModel: ProductModel[] = [];
        if (this.products && this.products && this.products.length > 0) {
            this.products.forEach(item => {
                productModel.push({ itemNumber: item.itemNumber });
            });
        }
        productRestrictionModel.productModels = productModel;
        return productRestrictionModel;

    }

    getShippingCost() {
        this.calculateOrderTax();
    }

    /**
     * Get Ship Methods By Products and Store
     */
    getShipMethods(isDeliveryOptionChange: boolean = false) {
        let shippingOptions;
        let items;
        this.taxCalculationStatus = true;
        this.shippingMethods = [];
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.showSelectedShipMethod = false;
        this.shipMethodValidation = null;
        this.restrictedProducts = [];
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
        this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
        this.orderFormGroup.controls['shippingCost'].setValue('');
        if (!this.pudoShippingAddressInfo) {
            this.getPudoPickupPersonAddress();
        }
        if (this.storeInfo && this.products && this.products.length > 0
            && (this.shippingAddressInfo || this.shippingAddressInfoConfig)) {
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY || this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            }

            this._orderService.getShipmentService(shippingOptions).subscribe(response => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    if ((this.shippingAddressInfo || (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) || this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) || this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
                        this.shipMethods = response;
                        this.shippingMethods = response.shippingMethods;
                        //Process the free shipping based on promotions
                        items = this.orderFormGroup.get('items') ? this.orderFormGroup.get('items') : null;
                        this._commonService.applyPromotionFreeShipping(this.shippingMethods, this.promotionModels, items, this.totalCommissionableVolume);
                        this.importFeeEnabled = response.importFeeEnabled;
                        if (this.shippingMethods.length > 0) {
                            this.shippingMethods.forEach(shipMethod => {
                                if(shipMethod.shippingCharge && shipMethod.shippingCharge > shipMethod.shippingTax){
                                    shipMethod.shippingCharge = shipMethod.shippingCharge - shipMethod.shippingTax;
                                }
                                else{
                                    shipMethod.shippingCharge = 0;
                                }
                                shipMethod.shippingCharge = this._currencyPipe
                                    .getFormatedCurrency(shipMethod.shippingCharge, this.storeInfo);
                                shipMethod.importFeeEnabled = response.importFeeEnabled;
                            });
                            if (this.isOrderSessionInfo) {

                                this.orderFormGroup.patchValue({
                                    shippingCostSelector: this.orderSession.shippingCostSelector,
                                    originalShippingCost: this.orderSession.originalShippingCost,
                                    shipMethodId: this.orderSession.shipMethodId,
                                    shippingCost: this.orderSession.shippingCost,
                                    shippingCostPercentage: this.orderSession.shippingCostPercentage,
                                    isShippingDiscountApplied: this.orderSession.isShippingDiscountApplied
                                });

                                const shipMethodId = this.orderFormGroup.value.shipMethodId;
                                if (shipMethodId && this.shippingMethods) {
                                    const shippingObj =
                                        this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +shipMethodId)[0];
                                    if (shippingObj) {
                                        this.selectShippingMethod(shippingObj, isDeliveryOptionChange);
                                        this.getShippingCost();
                                    }
                                } else {
                                    this.orderFormGroup.patchValue({
                                        shippingCost: 0,
                                        originalShippingCost: 0,
                                        shippingCostPercentage: 0,
                                        isShippingDiscountApplied: false,
                                        originalShippingTax: 0
                                    });
                                    if (this.shippingMethods[0].shippingMethodId) {
                                        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            this.orderFormGroup.controls['shipMethodId']
                                                .setValue(this.shippingMethods[0].shippingMethodId);
                                        } else {
                                            this.orderFormGroup.controls['shipMethodId'].setValue(this.shippingMethods[0].shippingMethodId);
                                        }
                                        const isRetailFreeShippingObj = this.isRetailFreeShipping();
                                        let obj = isRetailFreeShippingObj ? isRetailFreeShippingObj : this.shippingMethods[0];
                                        this.selectShippingMethod(obj, isDeliveryOptionChange);
                                    }
                                }
                            } else {
                                this.orderFormGroup.patchValue({
                                    shippingCost: 0,
                                    originalShippingCost: 0,
                                    shippingCostPercentage: 0,
                                    isShippingDiscountApplied: false,
                                    originalShippingTax: 0
                                });
                                if (this.shippingMethods[0].shippingMethodId) {
                                    let shippingInfoObj: ShippingMethod;
                                    if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
                                            shippingInfoObj = response.shippingMethods.find((x) => !x.pudoEnabled);
                                        }
                                        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
                                            shippingInfoObj = response.shippingMethods.find((x) => x.pudoEnabled);
                                        }
                                        if (this.selectedpickup && this.isPickUpOptionExist && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +this.selectedpickup)[0];
                                        } else {
                                            if(!shippingInfoObj){
                                                shippingInfoObj = this.shippingMethods[0];
                                            }
                                        }
                                        this.pudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                                        if (!this.pudoShippingMethod) {
                                            this.getPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                                        } else {
                                        }
                                    } else {
                                        if (this.selectedpickup && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +this.selectedpickup)[0];
                                        } else {
                                            shippingInfoObj = this.shippingMethods[0];
                                        }
                                    }
                                    if (shippingInfoObj) {

                                        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            this.orderFormGroup.controls['shipMethodId']
                                                .setValue(shippingInfoObj.shippingMethodId);
                                        } else {
                                            this.orderFormGroup.controls['shipMethodId'].setValue(shippingInfoObj.shippingMethodId);
                                        }
                                        const isRetailFreeShippingObj = this.isRetailFreeShipping();
                                        let obj = isRetailFreeShippingObj ? isRetailFreeShippingObj : shippingInfoObj;
                                        this.selectShippingMethod(obj, isDeliveryOptionChange);

                                    }
                                }
                            }


                            setTimeout(() => {
                                this.orderSession = null;
                                this.isOrderSessionInfo = false;
                            }, 500);
                        }
                    }
                } else if (response && response.productModels && response.productModels.length > 0) {
                    this.getRestrictedProducts(response.productModels);
                } else if (response && response.validations.length > 0) {
                    this.shipMethodValidation = response.validations[0];
                } else if (response && !(response.success)) {
                    this.shippingMethods = [];
                    this.shippingCost = 0;
                    this.orderFormGroup.patchValue({
                        shippingCost: 0,
                        originalShippingCost: 0,
                        shippingCostPercentage: 0,
                        isShippingDiscountApplied: false,
                        originalShippingTax: 0
                    });
                }
                if(this.isDropShipOptionExist && !this.pudoShippingMethod){
                    this.getDropShipPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                }
            }, error => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Ship Methods');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        } else {
            this.orderFormGroup.patchValue({
                shippingCost: 0,
                originalShippingCost: 0,
                shippingCostPercentage: 0,
                isShippingDiscountApplied: false,
                originalShippingTax: 0
            });
        }

    }


    getPudoPickupPersonAddress(): Address {
        let address: Address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                const mailingAddress = this.memberInfo && this.memberInfo.address ? this.memberInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if (!address.phone) {
                            address.phone = this.userInfo.phone;
                            address.phoneNumber = this.userInfo.phone;
                        }
                        if (!address.email) {
                            address.phone = this.userInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        } else {
            address = this.pudoShippingAddressInfo;
        }
        this.pudoAddress = this.pudoShippingAddressInfo;
        return address;
    }
    preparePudoLocationRequest() {
        if (!this.countries) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
        }
        let request: PudoLocationRequest = null;
        if (this.pudoLocationSearchForm) {
            let pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            if (this.pudoAddress) {
                this.pudoAddress.zip = this.pudoAddress.zip ? this.pudoAddress.zip : this.pudoAddress.postalCode;
            }
            if (pudoLocationSearchFormData && pudoLocationSearchFormData.zipCode ? true : this.pudoAddress && this.pudoAddress.zip) {
                if (!pudoLocationSearchFormData.zipCode) {
                    this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
                }
                pudoLocationSearchFormData = this.pudoLocationSearchForm.value
                if (this.countries && this.storeInfo && this.storeInfo.homeIsocodeThree && pudoLocationSearchFormData.zipCode) {
                    const country: Country = this.countries.find((x: Country) => x.isocodeThree.toUpperCase() === this.storeInfo.homeIsocodeThree.toUpperCase());
                    request = {
                        countryIsoCode: country.isocodeTwo || '',
                        postalCode: pudoLocationSearchFormData.zipCode || '',
                        storeID: this.storeInfo && this.storeInfo.id || null,
                        // as per centiro api we need to send  . (period) if there is no city
                        city: pudoLocationSearchFormData.city || '.',
                        streetAddress: pudoLocationSearchFormData.addressLine1 || '',
                        languageCode: "en",
                    }
                }
            }
        }
        return request;
    }


    usePudoAddressAsShipAddress() {
        if (this.pudoLocationSearchForm) {
            const pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, pudoLocationSearchFormData.country);
            this._customerService.getStatesByCountryId(countryObj.countryId)
                .subscribe((states: State[]) => {
                    if (states && states.length) {
                        const defaultState = states[0];
                        this.shippingAddressInfo = {
                            addressId: null,
                            addressLine1: pudoLocationSearchFormData.addressLine1,
                            addressLine2: pudoLocationSearchFormData.addressLine2,
                            addressLine3: pudoLocationSearchFormData.addressLine3,
                            addressLine4: pudoLocationSearchFormData.addressLine4,
                            addressType: AddressType.MAILING,
                            addressVerified: pudoLocationSearchFormData.addressVerified,
                            city: pudoLocationSearchFormData.city,
                            country: pudoLocationSearchFormData.country,
                            countryCode: countryObj.isoCodeThree,
                            countryId: countryObj.countryId,
                            email: pudoLocationSearchFormData.email ? pudoLocationSearchFormData.email : null,
                            firstName: pudoLocationSearchFormData.firstName,
                            isSavedAddress: false,
                            isShowStateCode: pudoLocationSearchFormData.isShowStateCode,
                            lastName: pudoLocationSearchFormData.lastName,
                            latitude: pudoLocationSearchFormData.latitude,
                            longitude: pudoLocationSearchFormData.longitude,
                            middleName: pudoLocationSearchFormData.middleName,
                            phone: pudoLocationSearchFormData.phone,
                            phoneNumber: pudoLocationSearchFormData.phone,
                            phoneType: pudoLocationSearchFormData.phoneType,
                            postalCode: pudoLocationSearchFormData.postalCode || pudoLocationSearchFormData.zip,
                            state: defaultState.stateCode,
                            stateCode: defaultState.stateCode,
                            stateId: defaultState.id,
                            validAddress: true,
                            zip: pudoLocationSearchFormData.postalCode || pudoLocationSearchFormData.zip,
                        };
                        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                            this.pudoShippingAddressInfo = this.shippingAddressInfo;
                        }
                        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                            this.shippingAddressInfo = this.pudoShippingAddressInfo;
                        }

                    }
                }
                );
        }
    }


    getPudoLocationMap(geoPoint: GeoPoint) {
        if (geoPoint && geoPoint.latitude && geoPoint.longitude) {
            if(environment.restrictGoogleMapNavigation){
                return ApiUrlConstants.googleMapsUrl + geoPoint.latitude +
                ',' + geoPoint.longitude;
            }
            else {
                return null;
            }
        }
        return null;
    }
    loadPUDOLocations() {
        if (!this.skipAddressVerification) {
            this.messageService.setSubmitPudoPickupPersonAddress(true);
        } else {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                this.messageService.setSubmitPudoDropShipPersonAddress(true);
            }
            this.getPudoLocations();
        }
    }

    getPudoLocations() {
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
            this.usePudoAddressAsShipAddress();
        }
        let pudoLocationRequest: PudoLocationRequest = this.preparePudoLocationRequest();
        if (pudoLocationRequest) {
            this.pudoLocationsNotFound = false;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.loadingPudoPickupLocations = true;
            this._orderService.getPudoLocations(pudoLocationRequest).subscribe(
                (res) => {
                    this.loadingPudoPickupLocations = false;
                    if (res && res.collectionPoints && res.collectionPoints.length) {
                        this.pudoLocationsNotFound = false;
                        res.collectionPoints.sort((x, y) => x.distance - y.distance);
                        this.pudoCollectionPoints = res.collectionPoints;

                        this.calculateOrderTax();
                        this.prepareBusinessHours();
                        if (this.pudoLocationSearchForm && this.pudoLocationSearchForm.value && this.pudoLocationSearchForm.value.externalId) {
                            this.selectedPudoCollectionPoint = this.pudoCollectionPoints.find((x) => x.externalId == this.pudoLocationSearchForm.value.externalId);
                        }
                    } else {
                        this.pudoLocationsNotFound = true;
                    }
                }, (error) => {
                    this.loadingPudoPickupLocations = false;
                    this.pudoLocationsNotFound = true;
                }
            );
        }
    }


    prepareBusinessHours(): void {
        if (this.pudoCollectionPoints && this.pudoCollectionPoints.length) {
            this.pudoCollectionPoints.forEach((collectionPoint) => {
                if (collectionPoint && collectionPoint.openingHours) {
                    let businessHours: BusinessHour[] = [];
                    collectionPoint.openingHours.forEach((opening) => {
                        if (opening && opening.hours) {
                            let hours: SplitHour[] = [];
                            opening.hours.forEach((hour) => {
                                hours.push({ start: hour.opens, end: hour.closes })
                            });
                            const businessHour: BusinessHour = {
                                available: true,
                                day: opening.dayText,
                                hours: hours
                            }
                            businessHours.push(businessHour);
                        }
                    });
                    collectionPoint.businessHours = businessHours;
                }
            });
        }
    }

    getPudoShippingMethods(shippingOptions: ShippingOptionsRequest, shippingMethods: ShippingMethod[], mappingRequired: boolean = true) {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            } else {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;

            this._orderService.getShipmentService(shippingOptions).subscribe((response) => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    this.pudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                    if (mappingRequired) {
                        if (this.pudoShippingMethod) {
                            this.pudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                        this.getPudoLocations();
                    }
                }
            }, (error) => {
            });
        }
    }

    prepareShippingOptionsRequest(): ShippingOptionsRequest {
        const shippingOptions: ShippingOptionsRequest = {
            productModels: this.getProductModels(),
            orderSourceId: OrderSourceType.Web,
            languageCode: this.languageCode,
            orderTypeId: ShippingOrderType.Personal,
            fromAddress: this.getWarehouseAddress(),
            toAddress: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? this.getShippingAddress() : (this.shippingAddressInfoConfig.dropShipLocationsEnabled
                    && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) ? this.getPudoDropShipPersonAddress() : this.gtePudoPickupPersonAddress(),
            storeId: this.storeInfo.id,
            requestID: 2, // for now we are using two once config is done we will drive from enum
            memberTypeId: this.memberInfo && (this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR || this.memberInfo.memberTypeId === MemberTypeEnum.FPC)
                ? ShippingMemberType.DISTRIBUTOR : ShippingMemberType.RETAIL,   // retail (6) || distributor (4)
            priceTypeId: this.getPriceTypeId(),
            memberLevelId: this.memberInfo && (this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER)
                ? ShippingMemberTitle.NOVUS : ShippingMemberTitle.ASSISTANTMANAGER,
            orderSubTotal: this.subTotal ? this.subTotal : 0,
            orderTaxInclusiveSubTotal: this._commonService.getProductsTotalTax(this.products, this.subTotal, this.storeInfo),
            orderCaseCredits: this.totalCommissionableVolume,
            purchaseFlowId: this.getPurchaseFlowId(),
            shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY : (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP ? ShippingType.DROPSHIP : ShippingType.PICKUP),

            storeHomeCountryCode: this.selectedIsoCountryCode,
            vatInclusive: this.memberInfo && this.memberInfo.vatRegistered === true ? this.memberInfo.vatRegistered : false,
            initialOrder: false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? true : false,
            bwpEnabled: this.isBWPEnabled && this.isBWPEnabledProduct && this.storeInfo && this.storeInfo.bwpEnabled ? true : false
        };
        //order source only for AUT && DEU Country
        if (this.shippingAddressInfoConfig.sendSourceToShippingOptions) {
            shippingOptions.source = Source.CSP;
        }
        return shippingOptions;

    }
    gtePudoPickupPersonAddress(): Address {
        let address: Address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                const mailingAddress = this.memberInfo && this.memberInfo.address ? this.memberInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if (!address.phone) {
                            address.phone = this.userInfo.phone;
                            address.phoneNumber = this.userInfo.phone;
                        }
                        if (!address.email) {
                            address.phone = this.userInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        } else {
            address = this.pudoShippingAddressInfo;
        }
        this.pudoAddress = this.pudoShippingAddressInfo;
        return address;
    }


    /** Products
    * @returns Products
    */
    private getProductModels(): ShippingProductModel[] {
        const productModels: ShippingProductModel[] = [];
        if (this.products && this.products.length > 0) {

            for (let index = 0; index < this.products.length; index++) {

                const product = this.products[index];
                if (product) {
                    const productModel: ShippingProductModel = {
                        productID: product.id,
                        productHeight: product.shipping ? product.shipping.height : 0,
                        productWeight: product.shipping ? product.shipping.weight : 0,
                        productQuantity: product.quantity,
                        productLength: product.shipping ? product.shipping.length : 0,
                        productWidth: product.shipping ? product.shipping.width : 0,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping ? product.shipping.shippingRequired : 0,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);
                }

            }

        }
        return productModels;
    }

    // endregion

    // region #Start Products Section
    /**
    * @param  {any} data
    * @returns SafeHtml
    */
    autocompleListFormatter = (data: any): SafeHtml => {

        const html = `<span>${data.itemNumber} - ${this._titleCase.transform(data.displayName ? data.displayName : data.name)}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    /**
     * Auto Complete Product Search
     */
    observableSource = (keyword: any, fullSearch?: boolean): Observable<any[]> => {
        let fpc5PercentEnabled: boolean = false;
        if ((this.memberInfo || this.hasNewGuestOrderPermissions || this.hasNewRetailOrderPermissions) && this.storeInfo) {
            if (keyword && keyword.length > 1) {
                if (keyword.indexOf('#') == 0) {
                    keyword = keyword.replace(/#/, '');
                }
                if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
                    fpc5PercentEnabled = true;
                }
                let wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified ? true : false;
                if (wholesaleQualified == null) {
                    wholesaleQualified = false;
                }
                const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
                /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
                    Level, Opt-In, and Wholesale Qualified Status*/
                let memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
                const purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
                // HARD_DOWNGRADE CHECK FOR FPC USERS
                if (this.memberInfo) {
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
                }
                let _itemNumberURL = environment.productsUrl + '/stores/' + this.storeInfo.id + '/customerservice/products' +
                    '?languageCode=' + this.storeDefaultLanguage + '&memberTitleId=' + memberTitleId +
                    '&countryCode=' + this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified='
                    + wholesaleQualified + '&productWildSearch=' + keyword.trim() + '&source=' + ProductSource.ADMINISTRATION +
                    '&optin=' + optin + '&taxInclusive=' + this.storeInfo.taxInclusive;
                if (fullSearch) {
                    _itemNumberURL += '&searchType=FULL';
                }
                return this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(res => {
                    const results = res.json();
                    if (results && results.length > 0) {
                        return results;
                    } else {
                        return [];
                    }
                });
            } else {
                return Observable.of([]);
            }
        } else {
            let notification: any;
            if (!this.memberInfo) {
                notification = this._translatePipe.get('order.Member Details are Mandatory');
            }
            if (!this.storeInfo && !this.countryCode && !this.pickupDeliveryOptionAvailable && !this.shippingDeliveryOptionAvailable) {
                notification = this._translatePipe.get('Shipping options not available');
            } else if (!this.storeInfo && !this.countryCode &&
                (this.pickupDeliveryOptionAvailable || this.shippingDeliveryOptionAvailable)) {
                notification = this._translatePipe.get('order.Country Details are Mandatory');
            } else if (!this.storeInfo && this.showPOSOrderValidation) {
                notification = this._translatePipe.get('order.Member not eligible for POS orders');
            }
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
    }
    /**
     * Decrement the item Quantity
     * @returns void
     */
    decrementQuantity(index: number): void {
        this.taxCalculationStatus = true;
        const items: any = this.orderFormGroup.get('items');
        const product = items.controls[index].controls['productItem'].value;
        const previousProductQty = product.quantity;
        if (items && items.length > 0 && this.storeInfo) {

            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            if (items.controls[index].controls['quantity'].value === 1) {
                items.controls[index].controls['disableDecrement'].setValue(true);
            } else {
                items.controls[index].controls['disableDecrement'].setValue(false);
            }
            clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
            this.setFocusbyID('quantity-' + (index));
            if (this.productAssociationInfo) {
                const productid = items.value[index].productId;
                const associateProduct = this.productAssociationInfo.find(x => x.productId === productid);
                if (associateProduct) {
                    const sameProductIndex = items.controls.findIndex(item => item.controls['productId'].value === associateProduct.depositFeeProductId);
                    if (sameProductIndex >= 0) {
                        this.decrementQuantity(sameProductIndex);
                    }
                }
            }
            this.updateTotalsAndShipMethod(false);

            this.clickTimeout[items.controls[index].controls['productId'].value] =
                setTimeout(() => {
                    //New logic to bind promtoion product from promotion engine
                    const freeProductsInfo = this.validatePromotionCriteria(items);
                    const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                    this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
                    if (productIds && productIds.length) {
                        this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    } else {
                        this.updateTotalsAndShipMethod();
                    }
                }, 500);

        }
    }

    /**
    * Increment the item Quantity
    * @returns void
    */
    incrementQuantity(index: number): void {
        this.taxCalculationStatus = true;
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            const product = items.controls[index].controls['productItem'].value;
            if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock) && !(product.stockAvailable && !product.manageStock)) {
                items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);

                items.controls[index].controls['disableIncrement'].setValue(true);
            } else {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }

            const quantityFieldLength = items.controls[index].controls['quantity'].value ? items.controls[index].controls['quantity'].value.toString().length : 0;
            if (quantityFieldLength > 3) {
                items.controls[index].controls['disableIncrement'].setValue(true);
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
            }
            items.controls[index].controls['disableDecrement'].setValue(false);
            items.controls[index].controls['quantity'].updateValueAndValidity();
            clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
            this.setFocusbyID('quantity-' + (index));
            if (this.productAssociationInfo) {
                const productid = items.value[index].productId;
                const associateProduct = this.productAssociationInfo.find(x => x.productId === productid);
                if (associateProduct) {
                    const sameProductIndex = items.controls.findIndex(item => item.controls['productId'].value === associateProduct.depositFeeProductId);
                    if (sameProductIndex >= 0) {
                        this.incrementQuantity(sameProductIndex);
                    }
                }
            }
            this.updateTotalsAndShipMethod(false);
            this.clickTimeout[items.controls[index].controls['productId'].value] =
                setTimeout(() => {
                    //New logic to bind promtoion product from promotion engine
                    const freeProductsInfo = this.validatePromotionCriteria(items);
                    const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                    if (productIds && productIds.length) {
                        this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    } else {
                        this.updateTotalsAndShipMethod();
                    }
                }, 500);
        }
    }


    quantityChange(event: any, index: number) {
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    }
    /**
    * @param  {number} index
    * @returns void
    */
    updateQuantity(event: any, index: number): void {
        if (!this.isRestrictionPopupOpened && !this.addNewCardClicked) {
            const items: any = this.orderFormGroup.get('items');

            if (items && items.length > 0 && this.storeInfo) {
                let quantity = event.target ? +event.target.value : event;
                if (!items.controls[index].controls['quantity'].dirty && event.target) {
                    return;
                }
                items.controls[index].controls['quantity'].markAsPristine();
                const product = items.controls[index].controls['productItem'].value;
                const previousProductQty = product.quantity;
                if (items.controls[index].controls['quantity'].value > 1 ||
                    (quantity && parseInt(quantity, 10))) {
                    if (product && quantity > product.stockQuantity && product.manageStock) {
                        items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                        const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                        this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                        items.controls[index].controls['disableIncrement'].setValue(true);
                    } else {
                        items.controls[index].controls['quantity'].setValue(quantity);
                        items.controls[index].controls['disableIncrement'].setValue(false);
                    }
                    items.controls[index].controls['disableDecrement'].setValue(false);
                }

                if (items.controls[index].controls['quantity'].value === 0) {
                    items.controls[index].controls['quantity'].setValue(1);
                    quantity = 1;
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['disableDecrement'].setValue(true);
                }
                items.controls[index].controls['quantity'].updateValueAndValidity();
                clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
                let productid = items.value[index].productId;
                if (this.productAssociationInfo) {
                    const associateProduct = this.productAssociationInfo.find(x => x.productId === productid);
                    if (associateProduct) {
                        const sameProductIndex = items.controls.findIndex(item => item.controls['productId'].value === associateProduct.depositFeeProductId);
                        if (sameProductIndex >= 0) {
                            let depositFeeProductQuantity = +items.value[sameProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - previousProductQty;
                            depositFeeProductQuantity = depositFeeProductQuantity + quantity;
                            if (depositFeeProductQuantity > 0) {
                                this.updateQuantity(depositFeeProductQuantity, sameProductIndex);
                            }
                        }
                    }
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod(false);

                }
                this.isFocused = false;

                this.clickTimeout[items.controls[index].controls['productId'].value] =
                    setTimeout(() => {
                        //New logic to bind promtoion product from promotion engine
                        const freeProductsInfo = this.validatePromotionCriteria(items);
                        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
                        const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                        if (productIds && productIds.length) {
                            this.addPromotionEngineProducts(productIds, freeProductsInfo);
                        } else {
                            this.updateTotalsAndShipMethod();
                        }
                    }, 500);
               
            }
        }
    }

    /**
     * @description open/close when restricted products shown
     * @date 2019-08-07
     * @param {boolean} isOpen
     * @memberof OrderPromotionComponent
     */
    restrictionPopupOpen(isOpen: boolean): void {
        this.isRestrictionPopupOpened = isOpen;
    }

    /**
     * disabling Submit button
     */
    disableSubmitButton(): void {
        this.taxCalculationStatus = true;
    }

    /**
     * @returns void
     */
    deleteItem(index: number): void {
        const items = this.orderFormGroup.get('items') as any;
        const product = items.controls[index].controls['productItem'].value;
        const productQuantity = +items.controls[index].controls['quantity'].value;

        if (items && items.length > 0) {
            if (this.productAssociationInfo) {
                const depositFeeEnabledCount = this._commonService.depositFeeEnabledProducts(items);
                let productId = items.value[index].productId;
                const parentProduct = this.productAssociationInfo.find(x => x.productId === productId);
                if (parentProduct) {
                    // remove the parent product
                    items.removeAt(index);
                    const depositFeeProductIndex = items.controls.findIndex(item => item.controls['productId'].value === parentProduct.depositFeeProductId);
                    if (depositFeeEnabledCount > 1) {
                        if (depositFeeProductIndex > -1) {
                            let depositFeeProductQuantity = +items.value[depositFeeProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - productQuantity;
                            if (depositFeeProductQuantity > 0) {
                                items.value[depositFeeProductIndex].quantity = depositFeeProductQuantity
                                items.setValue(items.value);
                            } else {
                                items.removeAt(depositFeeProductIndex);
                            }
                        }
                    } else {
                        if (depositFeeProductIndex > -1) {
                            items.removeAt(depositFeeProductIndex);
                        }
                    }
                } else {
                    items.removeAt(index);
                }
            } else {
                items.removeAt(index);
            }
        }
        setTimeout(() => {
            if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                this.itemLevelSearch.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod(false);
        //New logic to bind promtoion product from promotion engine
        const freeProductsInfo = this.validatePromotionCriteria(items);
        const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
        if (productIds && productIds.length) {
            this.addPromotionEngineProducts(productIds, freeProductsInfo);
        } else {
            this.updateTotalsAndShipMethod();
        }

    }
    confirm(index: number) {
        if (index === 0 || index > 0) {
            this.deleteItem(index);
        }
    }


    addItemNumber(): void {
        this.items = this.orderFormGroup.get('items') as any;
        this.items.push(this.createItemNumberGroup());
    }

    // endregion

    // region #Start Common Methods Section
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    public clearAllTheForms(clearCountry: boolean = true, clearShippingAddress: boolean = true, clearMember: boolean = false) {
        this.showSelectedShipMethod = false;
        this.shippingAddressInfo = null;
        this.selectedpayvisionCardInfo = null;
        this.shipMethod = null;
        this.savedCards = [];
        this.bankDetailsList = [];
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        this.shippingCost = 0;
        this.shippingTax = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.isCalculateTax = false
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        this.verifiedShippingAddressId = 0;
        this.agreementDocuments = [];
        this.memberLevelHistory = [];
        this.isMemberFboUpgraded = false;
        this.isFBOValidationPending = false;
        this.personalInformation = null;
        this.mailingAddress = null;
        this.liveFormAddress = null;
        this.address = null;
        this.sponsorInformation = null;
        this.retuningGuestUser = null;
        this.isSubmitted = false;
        this.businessEntityId = null;
        this.isPaymentWithSavedCard = false;
        this.orderFormGroup.get('items').reset();
        const arr = <FormArray>this.orderFormGroup.controls.items;
        arr.controls = [];
        this.orderFormGroup.controls['isContactSponsor'].setValue(null);
        this.shippingCost = 0;
        this.memberCommunicationPreferences = {
            email: true,
            phone: false
        };
        this.orderFormGroup.patchValue({
            shippingCostSelector: this.selectEnum.firstOption.toString(),
            shippingCostPercentage: 0,
            originalShippingCost: 0,
            paymentSelector: this.selectEnum.firstOption.toString(),
            paymentInstrumentId: '',
            isShippingDiscountApplied: false,
            originalShippingTax: 0
        });
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (clearCountry) {
            this.orderFormGroup.controls['countryId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['countryId'].updateValueAndValidity();
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL && this.stores && this.stores.length > 0) {
                const countryId = this.stores.find(store => store.isocodeThree.toUpperCase() === IsoCodeThree.USA).id || this.stores[0].id;
                this.orderFormGroup.controls['countryId'].setValue(countryId);
                this._enrollmentMessageService.setClearGuestForm();
            } else {
                this.orderFormGroup.controls['countryId'].setValue('');
            }
            this.memberCountries = [];
            this.shippingAddressInfoConfig = null;
        }
        if (clearMember) {
            this.orderFormGroup.controls['memberInfo'].setValidators([Validators.required]);
            this.orderFormGroup.controls['memberInfo'].updateValueAndValidity();
            this.orderFormGroup.controls['memberInfo'].setValue('');
            this.memberInfo = null;
            this.shippingAddressInfoConfig = null;
        }

        if (clearShippingAddress) {
            this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
            this.orderFormGroup.controls['shippingAddressId'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingAddressId'].setValue('');
            this.shippingMethods = [];
            this.memberAddressDetails = [];
        }
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['backDateOrder'].setValue(false);
        this.orderFormGroup.controls['itemSearch'].setValue('');
        this.orderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.pudoShippingAddressInfo = null;
        this.showPudoPickupPersonAddressForm = false;
        this.showDropShipPersonAddressForm = false;
        this.pudoAddress = null;
        this.savedPudoAddressId = null;
        this.pudoAddressSubmitted = false;
        this.buildPudoLocationSearchForm();
        this.loadingPudoPickupLocations = false;
        this.displayPudoAddress = false;
        this.buildPayByLinkForm();
        this.isOverrideMinimumLimit = false;
        this.savedCards = [];
        this.productAssociationInfo = [];
        this.depsoitFeeProductsInfo = [];
    }

    /**
     * update Totals and ShipMethod
     */
    updateTotalsAndShipMethod(isShippingMethod: boolean = true) {
        /**   if(this.isPromotionEngineEnabled) {
              this.getPromotionProducts();
          }*/
        this.taxCalculationStatus = true;
        this.subTotal = 0;
        this.retailSubTotal = 0;
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        this.isCalculateTax = false;
        if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.itemCount = this.shoppingCartCount;
        }
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            for (let index = 0; index < items.length; index++) {
                const product = items.controls[index].controls['productItem'].value;
                const quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    const existProduct = this.products.filter(productObj => productObj.id === product.id)[0];
                    if (!existProduct) {
                        product.quantity = quantity;
                        this.products.push(product);
                    } else {
                        const productIndex = this.products.findIndex(item => item.id === existProduct.id);
                        this.products[productIndex].quantity = this.products[productIndex].quantity + quantity;
                    }
                    if (this.appConfig && this.appConfig.freeShippingFPCOrder) {
                        this.getMemberShippingDiscountOffer(this.memberInfo.memberId);
                    } else {
                        this.memberShippingDiscountOfferEligible = false;
                    }
                    const shippingAddress = this.getShippingAddress();
                    if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
                        const country = this.countries.find(x => x.countryId === shippingAddress.countryId);
                        this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
                    }
                    const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
                    const taxCalculated = (this.appConfig && (this.appConfig.displayTaxInclusivePrice || this.appConfig.enableVatItemizationForNonVat)) ? false : true;
                    this.displayPriceConfig = this._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this.storeInfo.taxInclusive,
                            this.memberInfo, taxCalculated, this.countryTaxInclusive, this.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    let retailPrice: number = product.retailPrice;
                    if (this.displayPriceConfig) {
                        retailPrice = this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            (this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice);
                    }

                    this.subTotal = this.subTotal + this.getItemTotalSum(product);

                    this.retailSubTotal = this.retailSubTotal + (retailPrice * +quantity);

                    this.totalCommissionableVolume = this.totalCommissionableVolume + (product.commissionableVolume * +quantity);
                    this.shoppingCartCount += +product.quantity;
                }
            }
            this.depositFeeProductCount = this.getDepositFeeProductCount();
            if (this.shoppingCartCount && this.depositFeeProductCount) {
                this.shoppingCartCount = this.shoppingCartCount - this.depositFeeProductCount;
            }

            if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                this.itemCount = this.shoppingCartCount - this.itemCount;
            } else {
                this.itemCount = this.shoppingCartCount;
            }
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && (!(this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) || !this.checkoutConfig.enableMinAndMaxLimitRules)) {
                const subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
                const literatureItems = this.getLiteratureItems(this.products);
                if (this.isMemberFboUpgraded) {
                    this.upgradeFboLimitExceeded = this.validateMemberMonthlyAmountLimit(subTotal);
                    if (this.upgradeFboLimitExceeded) {
                        this.checkMemberAccess();
                        if (isShippingMethod) {
                            this.getShipMethods();
                        }
                        return;
                    } else {
                        this.isMemberHasAccessToOrder = true;
                    }
                }
                if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                    || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                        && subTotal <= this.orderRules.maxValue))) {
                    const hasMinValueIgnoreProduct = this._enrollmentCommonService.checkMinValueProduct(this.products, this.orderRules);
                    if (this.appConfig.orderMinMaxPriceValidation) {
                        this.minMaxPriceValidation = true;
                    }
                    if (subTotal > this.orderRules.maxValue) {
                        clearTimeout(this.cartMessageID);
                        const cartValueExceeded: any = this._translatePipe.get('order.Your cart must not exceed');
                        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue,this.storeInfo);
                        const cartValueExceededNotification: any = cartValueExceeded.value + ' <b class="helvetica-bold">' +
                            maxValue + '</b>';
                        if (this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
                            this.cartMessageID = setTimeout(() => {
                                this._commonService.createNotification('', cartValueExceededNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                            }, 100);
                        }
                        this.cartLimitExceed = true;
                    } else if ((subTotal < this.orderRules.minValue && !hasMinValueIgnoreProduct) && !this.isOverrideMinimumLimit) {
                        clearTimeout(this.cartMessageID);
                        let cartMinimumLimit: any = this._translatePipe.get('order.Order must meet a minimum of');
                        if (this.products && this.products.length &&
                            this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
                            && this.appConfig.displayPurchaseLimitationMessage
                            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                            cartMinimumLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                        }
                        if (this.overrideMinimumLimitIsEnabled) {
                            let overrideLimitLink: any = this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                            let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                            const cartMinimumLimitNotification: any = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                                minValue + '</b>.<b>' + overrideLimitLink.value + '</b>';
                            this.cartMessageID = setTimeout(() => {
                                const toast = this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                                toast.click.subscribe((event) => {
                                    if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                        this.overrideMinimumLimit.open();
                                    }
                                });
                            }, 100);
                            this.cartLimitNotReach = false;
                        }
                        else {
                            let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                            const cartMinimumLimitNotification: any = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                                minValue + '</b>';
                            this.cartMessageID = setTimeout(() => {
                                this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                            }, 100);
                            this.cartLimitNotReach = true;
                        }
                    }
                    else {
                        this._commonService.removeNotification(Constants.MIN_LIMIT);
                        this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                    }

                } else {
                    this.cartLimitExceed = false;
                    this.cartLimitNotReach = false;
                    this.minMaxPriceValidation = false;
                }
            }
            else {
                this.itemCount = 0;
            }
            this.validateThreshold();
            this.validateOrderLimit(true);
            if (isShippingMethod) {
                this.getShipMethods();
            }
        } else if (this.isMemberFboUpgraded) {
            const subTotal = this.calculateItemsSubTotal(this.storeInfo);
            this.isMemberHasAccessToOrder = true;
            this.upgradeFboLimitExceeded = this.validateMemberMonthlyAmountLimit(subTotal);
        }
        this.getItemsTotals();
    }
    getDepositFeeProductCount(): number {
        let depositFeeProductCount = 0;
        this.products.forEach(item => {
            let depositFeeProduct: any = null;
            depositFeeProduct = this.productAssociationInfo.find(x => x.depositFeeProductId === item.id)!;
            depositFeeProductCount = depositFeeProduct ? (depositFeeProductCount + item.quantity) : depositFeeProductCount;
        });
        return depositFeeProductCount;
    }

    getOverrideMinimumLimit(): boolean {
        if (this.userInfo && this.userInfo.allowedOperatingCountries && this.storeInfo && this.storeInfo.operatingCountry && !this.userInfo.hasSystemRole && this.operatingCountry) {
            let isoCodeThree: any = this.storeInfo.operatingCountry;
            let allowedCountryIds: any = [];
            let operatingCountryId = this.operatingCountry.filter(operatingCountry => operatingCountry.value == isoCodeThree);
            allowedCountryIds = this.userInfo.allowedOperatingCountries.split(",");
            if (operatingCountryId && operatingCountryId.length > 0) {
                return allowedCountryIds.includes(operatingCountryId[0].id.toString()) && this.hasMinimumOverrideLimit;
            }
            else {
                return false;
            }
        }
        return this.userInfo && this.userInfo.hasSystemRole === true ? true : false;
    }

    getOperatingCountries(): void {
        this._customerService.getOperatingCountries().subscribe((response: any) => {
            if (response) {
                this.operatingCountry = response;
            }
        }, err => {
            console.log(err)
        });

    }


    closeOverrideMinimumLimit(): void {
        this.isOverrideMinimumLimit = false;
        this.overrideMinimumLimit.close();
    }

    overrideMinimumLimitValueCheck(event: any) {
        this.isOverrideMinimumLimit = event.currentTarget.checked;
    }

    closeNotification(): void {
        this._commonService.removeNotification(Constants.MIN_LIMIT);
        this.overrideMinimumLimit.close();
    }
    getItemsTotals(): void {

        this.taxInclusiveSubTotal = this.getTaxbasedSubtotal(true);
        this.taxExclusiveSubTotal = this.getTaxbasedSubtotal(false);
        this.restrictPaymentsByItemTotals();
    }

    restrictPaymentsByItemTotals() {
        if (this.paymentDroolsResponse && this.paymentDroolsResponse.length > 0) {
            this.paymentDroolsResponse.forEach(x => {
                if (x.taxInclusivePrice && this.taxInclusiveSubTotal > 0) {
                    if (!(x.minValue < this.taxInclusiveSubTotal && x.maxValue >= this.taxInclusiveSubTotal)) {
                        if (x.paymentMethod == PaymentMethodTypeConstants.DirectDebit) {
                            this.direct_debit_show = false;
                        }
                        if (x.paymentMethod == PaymentMethodTypeConstants.SingleDebit) {
                            this.single_debit_show = false;
                        }

                    } else {
                        if (this.initialPaymentMethods.find(pm => pm.paymentMethodName === PaymentMethodTypeConstants.DirectDebit)) {
                            this.direct_debit_show = true;
                        }
                        if (this.initialPaymentMethods.find(pm => pm.paymentMethodName === PaymentMethodTypeConstants.SingleDebit)) {
                            this.single_debit_show = true;
                        }

                    }
                }
                if (!x.taxInclusivePrice && this.taxExclusiveSubTotal > 0) {
                    if (!(x.minValue < this.taxExclusiveSubTotal && x.maxValue >= this.taxExclusiveSubTotal)) {
                        if (x.paymentMethod == PaymentMethodTypeConstants.DirectDebit) {
                            this.direct_debit_show = false;
                        }
                        if (x.paymentMethod == PaymentMethodTypeConstants.SingleDebit) {
                            this.single_debit_show = false;
                        }
                    } else {
                        if (this.initialPaymentMethods.find(pm => pm.paymentMethodName === PaymentMethodTypeConstants.DirectDebit)) {
                            this.direct_debit_show = true;
                        }
                        if (this.initialPaymentMethods.find(pm => pm.paymentMethodName === PaymentMethodTypeConstants.SingleDebit)) {
                            this.single_debit_show = true;
                        }

                    }
                }
            });
        }
    }

    getTaxbasedSubtotal(taxInclusive: boolean): number {
        let total: number = 0;
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0) {
            if (taxInclusive) {
                items.value.forEach(element => {
                    total = total + element.quantity * element.productItem.applicablePrice;
                });
            }
            if (!taxInclusive) {
                items.value.forEach(element => {
                    total = total + element.quantity * element.productItem.catalogPrice;
                });
            }

        }
        return total;

    }
    /**
     * calculateSubtotalWithWholesalePrice()
     * @param shoppingCart
     */
    calculateSubtotalWithWholesalePrice(orderSubTotal: number): number {
        let subTotal = orderSubTotal;
        if (this.products && this.products.length &&
            this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
            && this.appConfig.displayPurchaseLimitationMessage
            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
            subTotal = 0;
            this.products.forEach(item => {
                subTotal += ((this.countryTaxInclusive ? item.wholesalePrice : item.baseWholesalePrice) * item.quantity);
            });
            // Should not apply wholesale price when user exceeds limit,
            // Wholesale price calculation applicable for minimum limit restriction
            if (orderSubTotal > this.orderRules.maxValue) {
                subTotal = orderSubTotal;
            }
        }
        return subTotal;
    }


    /**
     * @description
     * @date 2019-09-03updateMemberOptin
     * @memberof OrderPromotionComponent
     */
    openMemberLevelChange(requestUrl: string) {
        this.fpcOrderGlobalUrl = requestUrl;
        this.setDefaultPickerDate();
        this.personalInfoConfig = this._personalInfoConfigService.getSettings(this.countryCode)
        this.createOptUpdateForm();
        this._configurationService.setEnrollCountry(this.countryCode);
        const operatingCompany = this.storeInfo && this.storeInfo.homeIsocodeThree ? this.storeInfo.homeIsocodeThree : null;
        const storeId = this.storeInfo && this.storeInfo.id ? this.storeInfo.id : null;
        this._customerService.getMemberBankDetails(this.memberInfo.memberId, storeId, operatingCompany).subscribe((bankDetailResponse) => {
            if (this.memberInfo.pcSponsorEligible && bankDetailResponse && bankDetailResponse.accountNumber) {
                this.bonusInfoAvailable = true;
            }
        });
        this.getFboDocuments();
        this.updateMemberLevelPopup.closeOnOutsideClick = false;
        this.updateMemberLevelPopup.closeOnEscape = false;
    }

    /**
     * @description
     * @date 2019-09-11
     * @memberof OrderPromotionComponent
     */
    createOptUpdateForm(): void {
        this.optInCheck = false;
        this.isFPCOptInEnabled = false;
        if (this.fboUpgradeForm) {
            this.fboUpgradeForm.controls['dateOfBirth'].clearValidators();
            this.fboUpgradeForm.controls['dateOfBirth'].setValue('');
            this.fboUpgradeForm.controls['governmentId'].clearValidators();
            this.fboUpgradeForm.controls['governmentId'].setValue('');
            this.fboUpgradeForm.patchValue({
                wholesaleQualified: true,
                fpcToFboOptIn: [],
                dateOfBirth: '',
                governmentId: ''
            });
        } else {
            this.fboUpgradeForm = this._formbuilder.group({
                wholesaleQualified: [true],
                fpcToFboOptIn: [],
                dateOfBirth: ['', [ValidateDateOfBirth.DOBFormat]],
                governmentId: ['']
            });
        }
        this.getGovermentIdentificationPatterns();
        this.showOptin = true;
    }

    /**
     * @description
     * @date 2019-09-11
     * @memberof OrderPromotionComponent
     */
    updateMemberOptin(legalRequirements: LegalRequirements, isValid: boolean): void {
        this.formSubmitted = true;
        this.isSubmitted = true;
        if (this.optInCheck) {
            if ((this.personalInfoConfig && this.personalInfoConfig.showBusinessInfoSection && !this.validateBusinessInformation()) || (this.personalInfoConfig.bonusInfoPaymentOptions && !this.bonusInfoAvailable && !this.isSelectedBonusPaymentOptionType)) {
                this.legalRequirements = legalRequirements;
                this.setBusinessInformation();
            } else {
                this.validateMemberUpdateInformation(legalRequirements);
            }

        } else {
            this.submitPlaceOrder(this.fpcOrderGlobalUrl);
            this.document.documentElement.classList.remove('optin-popup');
            this.updateMemberLevelPopup.close();
        }
    }

    validateMemberUpdateInformation(legalRequirements: LegalRequirements) {
        if (!this.bonusInfoAvailable) {
            if (this.beneluxCountry) {
                this.setBonusInformation();
                if (this.accountNumber !== undefined && this.accountNumber !== "") {
                    if (this.bonusInfoAgreements && this.bonusInfoAgreements.length > 0) {
                        const agreements = this.bonusInfoAgreements.filter(x => x.isSelected === false);
                        this.bonusInfoAgreementCheckError = agreements && agreements.length === 0 ? false : true;
                    }
                }
            }
            if (this.personalInfoConfig.showBonusInfoSection && this.personalInfoConfig.bonusInfoPaymentOptions
                && !this.bonusInformation && this.bonusPaymentOptionType !== BonusPaymentOption.DECIDE_LATER) {
                this.setBonusInformation();
            }
        }
        if (!this.governmentIdExist && !this.invalidGovernmentId
            && !this.governmentIdValidInProgress && !this.agreementCheckError && !this.bonusInfoAgreementCheckError) {
            if (!legalRequirements.dateOfBirth) {
                return;
            }
            this.legalRequirements = legalRequirements;
            if (this.beneluxCountry) {
                setTimeout(() => {
                    this.getSponsorInfoByReferralOrAutoSuggest(this.memberInfo.sponsorId);
                }, 2500)
            }
            else {
                this.getSponsorInfoByReferralOrAutoSuggest(this.memberInfo.sponsorId);
            }
        } else {
            return;
        }
    }

    validateBusinessInformation(): boolean {
        if (this.personalInfoConfig && this.personalInfoConfig.showBusinessInfoSection) {
            if (this.businessInformation && this.businessInformation.isBusinessInfoValid) {
                return true;
            } else return false;
        }
        return true
    }
    /**
 * @description formatting dob to the yyyy-mm-dd
 * @date 2019-09-12
 * @param {LegalRequirements} legalRequirements
 * @returns {LegalRequirements}
 * @memberof OrderPromotionComponent
 */
    dateOfBirthFormat(legalRequirements: LegalRequirements): LegalRequirements {
        const characterCheck = /[a-zA-z]/;
        if (typeof legalRequirements.dateOfBirth._i === DateConstants.Object) {
            legalRequirements.dateOfBirth = legalRequirements.dateOfBirth._d;
            legalRequirements.dateOfBirth = this.momentConstructor(new Date(legalRequirements.dateOfBirth))
                .format(DateConstants.DOBFormat);
        }
        if (typeof legalRequirements.dateOfBirth._i === DateConstants.String) {
            legalRequirements.dateOfBirth = legalRequirements.dateOfBirth._i;
            const dateParts = legalRequirements.dateOfBirth.split('-');
            if (characterCheck.test(dateParts[1])) {
                legalRequirements.dateOfBirth = this.momentConstructor(new Date(legalRequirements.dateOfBirth))
                    .format(DateConstants.DOBFormat);
            } else {
                legalRequirements.dateOfBirth = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                    .format(DateConstants.DOBFormat);
            }
        }
        return legalRequirements;
    }

    /**
    * Government ID changes
    * @memberof PersonalInfoComponent
    */
    governmentIdChanges(): void {
        this.invalidGovernmentId = false;
        this.governmentIdExist = false;
    }
    /**
     * @description
     * @date 2019-09-16
     * @memberof OrderPromotionComponent
     */
    getFboDocuments(selectedLanguage?: string, optInCheck?: boolean): void {
        const customerTypeId = (this.documentsRequest && this.documentsRequest.customerTypeId) ? this.documentsRequest.customerTypeId : DocumentLibraryMemberId.Distributor;
        const displaySetionId = (this.documentsRequest && this.documentsRequest.displaySectionId) ? this.documentsRequest.displaySectionId : DisplaySectionId.FBO_Checkout_Page;
        this._documentService.getDocuments(Portal.Csp, customerTypeId, displaySetionId, this.countryCode, selectedLanguage ? selectedLanguage : this.storeDefaultLanguage)
            .subscribe(response => {
                if (response && response[0].body) {
                    response[0].body = orderBy(response[0].body, ['documentUrl'], ['asc']);
                    this.agreementDocuments = response[0].body;
                    if (!optInCheck && this.agreementDocuments && this.agreementDocuments.length) {
                        this.agreementDocuments.forEach(item => {
                            item.isSelected = true;
                        });
                    }
                    if (environment.scandinavianCountries && this.countryCode) {
                        let scandinavianCountries = environment.scandinavianCountries;
                        this.scandinavianCountry = scandinavianCountries.split(",").find(country => country === this.countryCode);
                    }
                    this.fetchTermsConditionDocument(this.agreementDocuments);
                    this._configurationService.setEnrollCountry(this.countryCode)
                    if (this.personalInfoConfig && this.personalInfoConfig.showBusinessInfoSection) {
                        this.businessInfoSchemaUrl = this.countryCode.toLowerCase() + '-bonus-info.json?templateVersion='
                            + environment.templateVersion;
                    }
                    if (this.countryCode.toLowerCase() === IsoCodeThree.SWE.toLowerCase()) {
                        this.bonusInfoSchemaUrl = this.countryCode.toLowerCase() + '-bankgiro-bonus-info.json?templateVersion= '
                            + environment.templateVersion;
                    }
                    else {
                        this.bonusInfoSchemaUrl = this.countryCode.toLowerCase() + '-bonus-info.json?templateVersion='
                            + environment.templateVersion;
                    }
                    this.setFboBonusInformationPermissions(this.storeInfo.id);
                    this._configurationService.setBonusInfoSchemaUrl(this.bonusInfoSchemaUrl);
                    this._personalMessageService.setRebindBonusinfoForm(true);
                    this.beneluxCountry = (this.personalInfoConfig.showBonusInfoSection && this.personalInfoConfig.showBonusDebitInforMenu) ? true : false;
                    if (this.beneluxCountry) {
                        if (!this.optInCheck) {
                            this._personalMessageService.setDisableBonusInfoForm(true);
                        }
                        if (!this.scandinavianCountry) {
                            this.fetchBonusInfoTermsAndConditions(this.countryCode, this.storeDefaultLanguage);
                        }
                    }
                    this.document.documentElement.classList.add('optin-popup');
                    this.updateMemberLevelPopup.open();
                    setTimeout(() => {
                        this._personalMessageService.setDisableBonusInfoForm(true);
                    }, 1500);
                } else {
                    const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            }, (error: any) => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
    }

    /**
     * @description
     * @date 2019-09-16
     * @param {*} dateMomentObj
     * @memberof OrderPromotionComponent
     */
    convertToSpecificDateFormat(dateMomentObj: any) {
        const characterCheck = /[a-zA-z]/;
        const dateInputPattern = /^[a-zA-Z0-9\-]*$/;
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj._i === 'object') {
            dateMomentObj = dateMomentObj._d;
            this.fboUpgradeForm.patchValue({
                dateOfBirth: moment(dateMomentObj, 'DD-MMM-YYYY')
            });
        }
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj.value._i === DateConstants.String) {
            dateMomentObj = dateMomentObj.value._i;
            if (dateInputPattern.test(dateMomentObj)) {
                const dateParts = dateMomentObj.split('-');
                if (characterCheck.test(dateParts[1])) {
                    dateMomentObj = moment(dateMomentObj, DateConstants.DateFormat);
                } else {
                    dateMomentObj = moment(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                        .format(DateConstants.DateFormat);
                }
                this.fboUpgradeForm.patchValue({
                    dateOfBirth: moment(dateMomentObj, DateConstants.DateFormat)
                });
                this.datePickerStartDateAt = new Date(dateMomentObj);
            } else {
                this.datePickerStartDateAt = new Date();
            }
        }
    }

    setDefaultPickerDate(): void {
        this.datePickerStartDateAt.setFullYear(new Date().getFullYear() - 18);
    }
    /**
     * @description
     * @date 2019-09-09
     * @memberof OrderPromotionComponent
     */

    optInSelect(optin: boolean): void {
        this.isFPCOptInEnabled = true;
        this.isSubmitted = false;
        this.fboUpgradeForm.controls['fpcToFboOptIn'].setValue(optin);
        this.optInCheck = optin;
        this.agreementDocuments.forEach(x => {
            x.isSelected = optin;
        });
        if (!optin) {
            this.fboUpgradeForm.controls['dateOfBirth'].clearValidators();
            this.fboUpgradeForm.controls['governmentId'].clearValidators();
            this.fboUpgradeForm.controls['dateOfBirth'].setValue('');
            this.fboUpgradeForm.controls['governmentId'].setValue('');
            this.fboUpgradeForm.controls['governmentId'].updateValueAndValidity();
            this.agreementCheckError = false;
            this.bonusInfoAgreementCheckError = false;
            this.invalidGovernmentId = false;
            this.governmentIdExist = false;
            if (this.beneluxCountry) {
                this._personalMessageService.setDisableBonusInfoForm(true);
            }
        } else {
            const dateMomentObj = Utils.convertToSpecificDateFormat(this.dateOfBirthMember, DateConstants.DateFormat);
            if (dateMomentObj) {
                if (this.fboUpgradeForm.controls['dateOfBirth'].valid) {
                    this.fboUpgradeForm.controls['dateOfBirth'].clearValidators();
                    this.fboUpgradeForm.controls['dateOfBirth'].setValue(dateMomentObj);
                }

            } else {
                this.fboUpgradeForm.controls['dateOfBirth'].setValidators([Validators.required, ValidateDateOfBirth.DOBFormat]);
                this.fboUpgradeForm.controls['dateOfBirth'].updateValueAndValidity();
            }

            if (this.beneluxCountry || (this.appConfig && this.appConfig.hideGovernmentidFPCToFBOUpgrade)) {
                this._personalMessageService.setDisableBonusInfoForm(false);
                this.invalidGovernmentId = false;
                this.governmentIdExist = false;
                this.fboUpgradeForm.controls['governmentId'].clearValidators();
                this.fboUpgradeForm.controls['governmentId'].setValue('');
                this.fboUpgradeForm.controls['governmentId'].updateValueAndValidity();


            } else {
                this.getGovermentIdentificationPatterns();
            }
        }


    }

    /**
     * @description
     * @date 2019-09-16
     * @param {number} index
     * @memberof OrderPromotionComponent
     */
    checkFboOptIn(index: number): void {
        this.agreementDocuments[index].isSelected = !this.agreementDocuments[index].isSelected;
        this.checkDocumentsSelected();
    }

    checkPaymentTermsAndPolicies(index: number) {
        this.paymentTermsAndPoliciyDocuments[index].isSelected = !this.paymentTermsAndPoliciyDocuments[index].isSelected;
        this.checkPaymentDocumentsSelected();
    }

    /**
     * @description
     * @date 2019-09-16
     * @memberof OrderPromotionComponent
     */
    checkDocumentsSelected(): void {
        const selectedDocuments = this.agreementDocuments.filter(x => x.isSelected);
        if (selectedDocuments && selectedDocuments.length === this.agreementDocuments.length) {
            this.agreementCheckError = false;
            this.formSubmitted = false;
        } else {
            this.agreementCheckError = true;
            this.formSubmitted = false;
        }
    }

    checkPaymentDocumentsSelected(): void {
        if (this.paymentTermsAndPoliciyDocuments && !this.paymentTermsAndPoliciyDocuments.every(x => x.isSelected)) {
            this.agreementCheckError = true;
        } else {
            this.agreementCheckError = false;
        }
    }
    /**
     * @description
     * @date 2019-09-03
     * @memberof OrderPromotionComponent
     */
    closePopUpforMemberLevelChange() {
        this.formSubmitted = false;
        this.createOptUpdateForm();
        this.document.documentElement.classList.remove('optin-popup');
        this.updateMemberLevelPopup.close();
        this.isSubmitted = false;

    }
    /**
     * @description
     * @date 2019-09-16
     * @param {FormControl} governmentIdControl
     * @memberof OrderPromotionComponent
     */
    validateGovernmentId(governmentIdControl: FormControl): void {
        this.governmentIdExist = false;
        this.invalidGovernmentId = false;
        const governmentId = governmentIdControl.value;
        const isGovernmentIdValid = governmentIdControl.valid;
        if (governmentId && governmentId.length > 0 && isGovernmentIdValid) {

            this.governmentIdValidInProgress = true;
            this._documentService.validateGovernmentId(governmentId,
                this.countryCode, this.storeId, this.memberId)
                .subscribe((response: any) => {
                    this.invalidGovernmentId = false;
                    if (response && response._body === 'false') {
                        this.governmentIdExist = false;
                    } else {
                        this.governmentIdExist = true;
                    }
                    this.governmentIdValidInProgress = false;
                }, (errResponse: any) => {
                    if (errResponse) {
                        this.governmentIdExist = false;
                        this.governmentIdValidInProgress = false;
                        const response = JSON.parse(errResponse._body);
                        if (response && response.validations && !response.statusCode
                            && response.validations.length > 0) {
                            this.invalidGovernmentId = true;
                        } else {
                            this.invalidGovernmentId = false;
                        }
                    }
                });
        }
    }
    // endregion
    /**
     * Selected Shipping Address
     */
    getShippingAddress(): any {
        let shippingAddressdata = null;
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            shippingAddressdata = this.pudoShippingAddressInfo;
        } else if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            shippingAddressdata = this.pudoShippingAddressInfo;
        } else {
            shippingAddressdata = this.shippingAddressInfo;
        }
        if (shippingAddressdata) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, shippingAddressdata.countryCode);
            const shippingAddress: any = {
                addressLine1: shippingAddressdata.addressLine1,
                addressLine2: shippingAddressdata.addressLine2,
                addressLine3: shippingAddressdata.addressLine3,
                addressLine4: shippingAddressdata.addressLine4,
                addressVerified: shippingAddressdata.addressVerified,
                latitude: shippingAddressdata.latitude,
                longitude: shippingAddressdata.longitude,
                city: shippingAddressdata.city || null,
                state: shippingAddressdata.stateName,
                stateCode: shippingAddressdata.stateCode,
                countryCode: shippingAddressdata.countryCode ? shippingAddressdata.countryCode : shippingAddressdata.country,
                country: shippingAddressdata.countryName ? shippingAddressdata.countryName : countryObj && countryObj.name ? countryObj.name : shippingAddressdata.countryCode ? shippingAddressdata.countryCode : shippingAddressdata.country,
                postalCode: shippingAddressdata.postalCode ? shippingAddressdata.postalCode : null,
                zip: shippingAddressdata.postalCode ? shippingAddressdata.postalCode : null,
                countryId: shippingAddressdata.countryId,
                stateId: shippingAddressdata.stateId,
                name: shippingAddressdata.shipToName,
                firstName: shippingAddressdata.firstName,
                middleName: shippingAddressdata.middleName,
                lastName: shippingAddressdata.lastName,
                addressType: this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP ? AddressType.PICKUP_PERSON : AddressType.SHIPPING,
                isShowStateCode: shippingAddressdata.isShowStateCode,
                phone: shippingAddressdata.phone ? this.getValidPhoneNumber(shippingAddressdata.phone) : shippingAddressdata.phoneNumber ? this.getValidPhoneNumber(shippingAddressdata.phoneNumber) : null,
                phoneNumber: shippingAddressdata.phoneNumber ? this.getValidPhoneNumber(shippingAddressdata.phoneNumber) : shippingAddressdata.phone ? this.getValidPhoneNumber(shippingAddressdata.phone) : null,
                countryCodeTwo: this.selectedCountryCodeTwo,
                phoneType: shippingAddressdata.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction: shippingAddressdata.deliveryInstruction,
                email: shippingAddressdata.email ? shippingAddressdata.email : null

            };
            return shippingAddress;
        }
        return null;
    }

    getValidPhoneNumber(phoneNumber: string) {
        if (phoneNumber && this.storeDetails && this.storeDetails.foreverDirectEnabled) {
            phoneNumber = phoneNumber.replace(/[a-zA-Z ]/g, '');
            if (phoneNumber.substring(0, 1) !== '+' && phoneNumber.substring(0, 2) !== '00') {
                phoneNumber = '+' + phoneNumber;
            }
        }
        else {
            phoneNumber = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        }
        return phoneNumber;
    }
    /**
 * Selected Shipping Address
 */
    getBillingAddress(): any {
        let countryId = 0;
        if (!this.billingAddressInfo) {
            this.billingAddressInfo = this.paymentComponentSettings.billingAddress || (this.mailingAddress ? this.mailingAddress : (this.shippingAddressInfo ? this.shippingAddressInfo : null));
        }
        if (this.countries && this.billingAddressInfo && !this.billingAddressInfo.countryId) {
            let billingCountry: Country;
            if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length > 2) {
                billingCountry =
                    this.countries.find((x: any) => x.isocodeThree.toLowerCase()
                        === this.billingAddressInfo.countryCode.toLowerCase());
            } else if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length === 2) {
                billingCountry =
                    this.countries.find((x: any) => x.isocodeTwo.toLowerCase()
                        === this.billingAddressInfo.countryCode.toLowerCase());
            }
            if (billingCountry) {
                countryId = billingCountry.countryId;
            }
        }
        const stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        const billingAddress: any = {
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2,
            addressLine3: this.billingAddressInfo.addressLine3,
            addressLine4: this.billingAddressInfo.addressLine4,
            city: this.billingAddressInfo.city || null,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            countryCode: this.billingAddressInfo.countryCode ? this.billingAddressInfo.countryCode : this.selectedIsoCountryCode,
            country: this.billingAddressInfo.countryCode ? this.billingAddressInfo.countryCode : this.selectedIsoCountryCode,
            postalCode: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            zip: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            countryId: this.billingAddressInfo.countryId || countryId,
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            addressType: AddressType.BILLING,
            countryCodeTwo: this.selectedCountryCodeTwo
        };
        return billingAddress;
    }
    getPickUpAddress(): any {
        if (this.shipMethod && this.shipMethod.pickUpLocation
            && this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            this.shipMethod.pickUpLocation.addressType = AddressType.PICKUP;

            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, this.shipMethod.pickUpLocation.stateCode);

            if (countryObj) {
                this.shipMethod.pickUpLocation.countryId = countryObj.countryId;
                this.shipMethod.pickUpLocation.country = countryObj.isocodeThree ? countryObj.isocodeThree : '';
                this.shipMethod.pickUpLocation.countryCodeTwo = countryObj.isocodeTwo ? countryObj.isocodeTwo : '';
                this.shipMethod.pickUpLocation.countryCode = countryObj.isocodeThree ? countryObj.isocodeThree : '';
            }
            if (stateObj) {
                this.shipMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.shipMethod.pickUpLocation.name = this.shipMethod.pickUpLocation.pickupCenterName;
            this.shipMethod.pickUpLocation.postalCode = this.shipMethod.pickUpLocation.zip;
            this.setPickupAddress = this.shipMethod.pickUpLocation;
            return this.shipMethod.pickUpLocation;
        } else {
            return null;
        }
    }

    /**
 *
 * @param shippingMethod
 */
    getShippingMethodWarehouseAddress(): Address {
        if (this.shipMethod && this.shipMethod.warehouseAddress) {
            this.shipMethod.warehouseAddress.postalCode = this.shipMethod.warehouseAddress.zip;
            this.shipMethod.warehouseAddress.country = this.shipMethod.warehouseAddress.countryCode;
            return this.shipMethod.warehouseAddress;
        }
    }

    /**
     * Store Ware house Address
     */
    getWarehouseAddress(): Address {
        let warehouseAddress: Address = null;
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            warehouseAddress = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                addressLine3: this.storeInfo.warehouseAddress.addressLine3,
                addressLine4: this.storeInfo.warehouseAddress.addressLine4,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                country: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: this.storeInfo.warehouseAddress.name ? this.storeInfo.warehouseAddress.name : null
            };
        }
        return warehouseAddress;
    }


    private getPurchaseFlowId(): PurchaseFlowType {
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            return PurchaseFlowType.Retail;
        } else {
            return PurchaseFlowType.WholeSale;
        }
    }
    private getPriceTypeId(): PriceType {
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            return PriceType.RETAILPRICE;
        } else {
            return PriceType.WHOLESALEPRICE;
        }
    }

    /**
     * verifyOrderRules
     * @returns boolean
     */
    verifyOrderRules(isBackOrderDate: boolean): any {
        let valid: any;
        valid = { thresholdCrossed: false, monthlyCCValid: false, memberCCOverride: false, cartLimitExceed: false, cartLimitNotReach: false, purchaseLimitExceed: false };
        let monthlyCCValid = false;
        let thresholdCrossed = false;
        const totalPoints = this.calculateTotalPoints();
        let subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
        const literatureItems = this.getLiteratureItems(this.products);
        valid.purchaseLimitExceed = this.validateMemberMonthlyAmountLimit(totalPoints);
        // changes for order min/max for taxInclusive stores PS2022-1077
        if (this.storeInfo && this.storeInfo.taxInclusive && !this.appConfig.enableVATCalculation) {
            subTotal = this.itemTotal;
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints >= this.orderRules.minValue && totalPoints <= this.orderRules.maxValue)) {
            thresholdCrossed = false;
        } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
            if (this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                thresholdCrossed = this.validateSubTotalBasedOnType(this.products, subTotal);
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                } else if (subTotal < this.orderRules.minValue) {
                    this.isOverrideMinimumLimit === true ? valid.cartLimitNotReach = false : valid.cartLimitNotReach = true;
                }
            } else if ((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
            } else if ((this.isOverrideMinimumLimit && subTotal <= this.orderRules.maxValue) ||
                (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
                if (this.isOverrideMinimumLimit) {
                    valid.cartLimitNotReach = false;
                }
            }
            else {
                thresholdCrossed = true;
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                } else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        } else {
            thresholdCrossed = true;
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                } else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        }
        if (this.memberInfo && this.memberOrderCCInfo) {
            let maxValue;
            if (!this.appConfig.displayPurchaseLimitationMessage && (this.orderRules &&
                this.orderRules.valueType === ValueType.PRICE && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                maxValue = this.orderRules.maxCCValue > this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && this.orderRules.monthlyValueType === ValueType.CC) {
                maxValue = this.orderRules.maxCCValue >= this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                maxValue = this.orderRules.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            } else {
                maxValue = this.orderRules && this.orderRules.maxValue > this.memberOrderCCInfo.maxValue
                    ? this.orderRules.maxValue : this.memberOrderCCInfo.maxValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxValue;
            }

            if ((totalPoints + this.memberOrderCCInfo.actualCCValue) > maxValue) {
                monthlyCCValid = true;
                thresholdCrossed = false;
            }

            // Monthly CC override for member
            if (this.memberCCOverride && this.memberCCOverride.overrideFlag) {
                const currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
                const endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                    .format(DateConstants.DateFormat);
                if (!isBackOrderDate) {
                    if ((this.memberOrderCCInfo && (totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    } else if ((this.orderRules && this.orderRules.maxCCValue < this.memberCCOverride.cVLimit)
                        && ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                } else {
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    } else if ((this.orderRules.maxCCValue < this.memberCCOverride.cVLimit) &&
                        ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                }
            }
        }
        if (!totalPoints) {
            monthlyCCValid = false;
        }
        valid.thresholdCrossed = thresholdCrossed;
        valid.monthlyCCValid = monthlyCCValid;
        // for order rule value type: BOTH
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            let details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC
            );
            valid.cartLimitExceed = details.cartLimitExceed;
            valid.cartLimitNotReach = details.cartLimitNotReach;
            valid.monthlyCCValid = details.monthlyCCValid;
            valid.monthlyCCValue = details.monthlyCCValue;
            valid.thresholdCrossed = details.thresholdCrossed;
        }
        return valid;
    }

    getLiteratureItems(products: any[]): any[] {
        let literatureItems;
        if (products && products.length) {
            literatureItems = products.filter(item => item.literature);
            if (this.orderRules && this.orderRules.itemNumbers && this.orderRules.itemNumbers.length) {
                const tripackItems = products.filter(item => this.orderRules.itemNumbers.indexOf(+item.itemNumber) > -1);
                if (tripackItems && tripackItems.length) {
                    literatureItems.push(tripackItems);
                }
            }
        }
        return literatureItems;
    }

    validateMemberMonthlyAmountLimit(totalPoints): boolean {
        let purchaseLimitExceed = false;
        const memberOrderRules: MemberOrderCCInfo = this.memberOrderCCInfo;
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE
            && memberOrderRules && (totalPoints + memberOrderRules.actualTotalValue) > this.orderRules.maxValue) {
            purchaseLimitExceed = true;
        }
        return purchaseLimitExceed;
    }

    /**
     * Get total points
     */
    calculateTotalPoints(): number {
        let _totalCV = 0;
        for (let i = 0; i < this.products.length; i++) {
            if (!this.products[i].literature) {
                _totalCV += this.products[i].commissionableVolume * this.products[i].quantity;
            }
        }
        return _totalCV;
    }

    subscribeSaveAddress() {
        this.messageService.getAddressSaved().subscribe(data => {
            if (!this.address) {
                this.address = {};
            }
            this.address.isSavedAddress = data;
        });
    }

    /**
  * on click of checkout
  * @memberof CartComponent
  */
    createOrder(): void {
        this.checkMemberAccess();

        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP
            && !this.selectedPudoCollectionPoint) {
            return;
        }
        if (this.isWhosaleCheckNotCalculated) {
            this.wholesaleCheckErrorNotifications();
            return;
        }
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        this._cacheService.set(CacheKey.CARTUPDATED, 'true');
        if (this.isMemberHasAccessToOrder && !this.upgradeFboLimitExceeded) {
            this.isSubmitted = true;
            if (!this.chRef['destroyed']) {
                this.chRef.detectChanges();
            }
            if (this.products && this.products.length) {
                const productIds = this.products.map((item: Product) => item.id);
                if (productIds && productIds.length) {
                    const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
                        ? this.memberInfo.wholeSaleQualified : false;
                    const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
                    let memberTitleId = this.memberInfo && this.memberInfo.memberTitleId;
                    let purchaseFlowType = PurchaseFlows.PERSONAL;
                    if (this.memberTypeId === MemberTypeEnum.GUEST || this.memberTypeId === MemberTypeEnum.RETAIL) {
                        purchaseFlowType = PurchaseFlows.RETAIL;
                    }
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);

                    if ((this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DELIVERY || this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) || (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled)) {
                        this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id,
                            memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe((products: Product[]) => {
                                this.outOfStockItems = this.stockAvailabilityCheck(products);
                                if (this.outOfStockItems.length) {
                                    this.outOfStockModal.open();
                                    this.isSubmitted = false;
                                } else {
                                    this.submitOrder();
                                }
                            });
                    } else if (this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.PICKUP) {
                        // pickup products stock availability check
                        const shipMethodId = this.orderFormGroup.value.shipMethodId;
                        if (shipMethodId && this.shippingMethods) {
                            const shippingObj =
                                this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +shipMethodId)[0];
                            if (shippingObj && shippingObj.shippingMethodId) {
                                this.pickupStockAvailabilityCheck(productIds, shippingObj.shippingMethodId);
                            } else {
                                this.isSubmitted = false;
                            }
                        } else {
                            this.isSubmitted = false;
                            const notification = 'Pickup location not available, Please select.'
                            this._commonService.createNotification('', notification, NotificationType.ERROR);
                        }
                    }
                }

            }

        }
    }

    /**
     * @description To check stock available
     * @date 2019-09-20
     * @param {Product[]} products
     * @returns {Product[]}
     * @memberof OrderPromotionComponent
     */
    stockAvailabilityCheck(products: Product[]): Product[] {
        const cartProducts: Product[] = this.products;
        if (cartProducts && products && products.length) {
            const noStockItems: Product[] = [];
            products.forEach((product: Product) => {
                const cartItem = cartProducts.find((item: Product) => item.id === product.id);
                if (cartItem && !((product.stockAvailable && !product.manageStock) || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                    cartItem.stockQuantity = product.stockQuantity;
                    noStockItems.push(cartItem);
                }
            });
            return noStockItems;
        }
        return [];
    }

    validateThreshold(): void {
        const totalPoints = this.calculateTotalPoints();
        const subTotal = this.calculateItemsSubTotal(this.storeInfo);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0)) <= this.orderRules.maxValue) {
            this.thresholdCrossed = false;
        } else if (this.appConfig.displayMinValidation && this.orderRules && this.orderRules.valueType === ValueType.PRICE && 
            subTotal < this.orderRules.minValue){
            this.cartLimitExceed = false;
            this.cartLimitNotReach = true;
            this.thresholdCrossed = true;
        } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
            subTotal <= this.orderRules.maxValue) {
            if(this.appConfig.displayMinValidation){
                this.cartLimitNotReach = false;
            }
            this.thresholdCrossed = false;
        } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
            subTotal > this.orderRules.maxValue) {
            this.thresholdCrossed = true;
            this.cartLimitExceed = true;
        } else if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            let details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC
            );
            this.cartLimitExceed = details.cartLimitExceed;
            this.thresholdCrossed = details.thresholdCrossed;
            this.memberCCLimitExceeded = details.monthlyCCValid;
            this.monthlyCCValue = details.monthlyCCValue;
            this.cartLimitNotReach = details.cartLimitNotReach;
        } else {
            this.thresholdCrossed = (!this.orderRules && this.appConfig.disableRetailOrderRules && (this.memberTypeId === MemberTypeEnum.RETAIL || MemberTypeEnum.GUEST)) ? false : true;
        }
        // Monthly CC override for member
        if (this.memberCCOverride && this.memberCCOverride.overrideFlag) {
            const currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
            const endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                .format(DateConstants.DateFormat);
            if (this.memberOrderCCInfo) {
                if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                    && (new Date(currentDate) <= new Date(endDate))) {
                    this.thresholdCrossed = true;
                } else if ((this.orderRules.maxCCValue < this.memberCCOverride.cVLimit) &&
                    ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                    && (new Date(currentDate) <= new Date(endDate))) {
                    this.thresholdCrossed = false;
                }
            }
        }
    }

    pickupStockAvailabilityCheck(productIds: number[], pickUpLocationId?: number) {
        const noStockItems: Product[] = [];
        const cartProducts: Product[] = this.products;
        if (pickUpLocationId && pickUpLocationId > 0 && productIds && productIds.length > 0) {
            this._customerService.getProductsByLocation(pickUpLocationId, productIds).subscribe(
                (response: any) => {
                    const posProducts = response;
                    if (posProducts && posProducts.length > 0) {
                        posProducts.forEach((pickUpProduct) => {
                            const cartProduct = cartProducts.find((product) => product.id === pickUpProduct.productId);
                            if (cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity) {
                                cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                                noStockItems.push(cartProduct);
                            }
                        });
                    }
                    this.outOfStockItems = noStockItems;
                    if (this.outOfStockItems && this.outOfStockItems.length > 0) {
                        this.outOfStockModal.open();
                        this.isSubmitted = false;
                    } else {
                        this.submitOrder();
                    }
                },
                (error: any) => {
                    const notification: any = this._translatePipe.get('orderdetails.Sorry, Something Went Wrong: Please try again later.');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            );
        }
    }

    closeOutOfStockForm() {
        this.outOfStockModal.close();
        this.isSubmitted = false;
    }

    submitOrder(url?: string) {
        this.isSubmitted = true;
        if (this.address && !this.address.isSavedAddress && this.orderFormGroup.value.saveForFutureUse) {
            if (!(this.shippingAddressInfo && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.PICKUP)) {
                this.saveAddress(this.getShippingAddress());
            }
        }
        if (this.appConfig.enablePaymentReferenceNumber) {
            if (this.paymentReferenceNumber.value.referenceNumber) {
                this.paymentComponentSettings.authorizationCode = this.paymentReferenceNumber.value.referenceNumber;
            }
        }
        let requestUrl = '';
        this.isSubmitted = true;
        this.isnewcardAdded = false;
        requestUrl = url || ApiUrlConstants.orderApiUrl + '/V1/orders';
        if (this.orderFormGroup.valid) {
            if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                const isBackDateOrder: boolean = this.orderFormGroup.value.backDateOrder;
                this.getMemberOrderRules(this.memberInfo, isBackDateOrder, requestUrl);
            } else {
                this.validateThreshold();
                this.placeOrder(requestUrl);
            }
        }
    }
    /**
     * @description Clear the out of stock items and update the tax
     * @date 2019-09-25
     * @memberof OrderPromotionComponent
     */
    clearOutOfStockItems(): void {
        const items = this.orderFormGroup.get('items') as any;
        if (this.outOfStockItems && this.outOfStockItems.length) {
            const productIds = this.outOfStockItems.map((product: Product) => product.id);
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.isSubmitted = false;
            this.outOfStockModal.close();
        }
    }

    /**
     * @description Remove out of stock items from cart items
     * @date 2019-09-25
     * @param {FormArray} items
     * @param {number[]} productIds
     * @memberof OrderPromotionComponent
     */
    removeOutOfStockItems(items: FormArray, productIds: number[]) {
        productIds.forEach((id: number) => {
            const productIndex = items.value.findIndex((product) => product.productId === id);
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    }

    /**
     * @description submit enrollment
     * @date 2019-09-05
     * @param {string} requestUrl
     * @memberof OrderPromotionComponent
     */
    submitEnrollment(): void {
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
            this._enrollmentMessageService.setSubmitGuestForm(true);
        } else if (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            this._enrollmentMessageService.setSubmitPersonalInfoForm(true);
        }
        if (this.appConfig.enablePaymentReferenceNumber) {
            if (this.paymentReferenceNumber.value.referenceNumber) {
                this.paymentComponentSettings.authorizationCode = this.paymentReferenceNumber.value.referenceNumber;
            }
        }
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        this.isSubmitted = true;
        if (this.agreementCheck && ((this.guestFormValidated && this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL)
        )) {
            this.isnewcardAdded = false;
            this.processEnrollMember();
        } else if (this.personalInfoFormValid && this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL
            && this.agreementCheck && this.personalInformation && this.sponsorInformation
            && this.mailingAddress) {
            this.isnewcardAdded = false;
            this.placeEnrollRequest();
        }
    }

    /**
     * @description this method will load sponsor
     * based on sponsorid if we don't have sponsor info
     * @date 2019-09-10
     * @param {string} sponsorId
     * @memberof OrderPromotionComponent
     */
    processEnrollMember(): void {
        if (this.shippingAddressInfo || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP && this.selectedPudoCollectionPoint) || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP)) {
            if (this.rebindSponsorData && this.rebindSponsorData.selectedWizard === SponsorWizardSearchType.SearchByIKnowSponsor
                && !this.sponsorInformation) {
                this.isSubmitted = false;
                this._enrollmentMessageService.setIsSponsorInfoSelected(false);
            } else if (this.retuningGuestUser) {
                this.submitOrder();
            } else if ((this.sponsorConfig
                && this.sponsorConfig.loadSponsorWizardInGuestFlow && this.sponsorInformation) || (this.isEnableFboReferralId())) {
                this.placeEnrollRequest();
            } else {
                //if(this.appConfig.useAnonymousRetailFboId) {
                this.getBusinessEntityByHomeCountryCode(this.storeInfo.homeIsocodeThree);
                //} else {
                //this.getSponsorInfoByReferralOrAutoSuggest();
                //}
            }
        }
    }

    /**
     * @description this method is used
     * to get selected sponsorinfo from sposor component
     * @date 2019-09-18
     * @memberof PersonalInfoComponent
     */
    getSelectedSponserInfo(sponsorInformation: SponsorInformation): void {
        this.sponsorInformation = sponsorInformation;
        if(this.sponsorInformation)
        {
            this.isSubmitted=false;
        }
        else
        {
            this.isSubmitted=true;
        }
    }

    pudoAddressInputChange(address: Address): void {
        if (this.formPickupPersonAddressValid) {
            this.pudoAddress = address;
            this.pudoCollectionPoints = null;
            this.hidePudoPickupLocationsButton = true;
            this.pudoLocationsNotFound = false;
            if (this.pudoAddress) {
                this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
            }
        }
    }

    /**
     * @description this method will fire when we chaneg textbox value
     * in address block
     * @date 2018-08-20
     * @memberof PersonalInfoComponent
     */
    getAddressOnInputChange(address: Address): void {
        if (!this.sponsorInformation) {
            this.liveFormAddress = address;
            this._enrollmentMessageService.setSponsorPreference(this.liveFormAddress);
        }
        if (this.mailingAddress && !this.shippingAddressInfo) {
            this.prepopulateShippingAddress();
        }
    }

    addressChangedByUser(changed: boolean): void {
        this.shippingAddressChanged = changed;
        if (changed) {
            this.selectedPudoCollectionPoint = null;
        }
    }

    /**
     * @description this method will prepopulate shipping address
     * @date 2019-09-10
     * @param {string} sponsorId
     * @memberof OrderPromotionComponent
     */
    prepopulateShippingAddress(): void {
        if (this.appConfig && this.appConfig.skipAddressVerification && this.mailingAddress) {
            this.mailingAddress.addressVerified = true;
        }
        const address: Address = this.mailingAddress;
        if (this.liveFormPersonalInfo) {
            address.firstName = this.liveFormPersonalInfo.firstName;
            address.lastName = this.liveFormPersonalInfo.lastName;
            address.middleName = this.liveFormPersonalInfo.middleName;
            address.email = this.liveFormPersonalInfo.email;
            address.phoneNumber = this.liveFormPersonalInfo.phoneNumber;
            address.phoneType = this.liveFormPersonalInfo.phoneType;
        }
        this.address = address;
        this.showAddressForm = false;
        this.displayPudoAddress = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        /*this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;*/
        setTimeout(() => {
            this.address = this.address;
            this.showAddressForm = true;
            this.pudoAddress = this.address;
            this.pudoShippingAddressInfo = this.address;
            this.displayPudoAddress = true;
            if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                this.getPudoLocations();
            }
        }, 500);
    }

    /**
     * @description this method will load sponsor
     * based on sponsorid if we don't have sponsor info
     * @date 2019-09-10
     * @param {string} sponsorId
     * @memberof OrderPromotionComponent
     */
    getSponsorInfoByReferralOrAutoSuggest(sponsorId?: string, enableFboReferralId?: boolean, isSponsorsearch?: boolean): void {
        if ((this.personalInformation || this.memberInfo) || enableFboReferralId) {
            const sponsorSearchRequest: SponsorSearchRequest = this.searchSponsorRequest(sponsorId);
            if (sponsorSearchRequest) {
                this.sponsorPollCount = 0;
                this._commonService
                    .searchSponsors(sponsorSearchRequest)
                    .subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
                        if (this.sponsorPollCount < this.sponsorMaxPollCount) {
                            this.sponsorPollCount = this.sponsorPollCount + 1;
                            if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                                this.processSearchSponsorResponse(sponsorSearchResponse, sponsorId, isSponsorsearch,null,sponsorSearchRequest.Option);
                            } else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                                sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                                setTimeout(() => {
                                    this.searchSponsorByPolling(sponsorSearchResponse, sponsorId, isSponsorsearch,sponsorSearchRequest.Option);
                                }, 2000);
                            } else {
                                this.isSponsorFound = false;
                                this.displayErrorMessage(null);
                            }
                        } else {
                            this.isSponsorFound = false;
                            this.displayErrorMessage(null);
                        }
                    }, (errResponse) => {
                        this.displayErrorMessage(errResponse);
                        this.isSponsorFound = false;
                    });
            } else {
                this.isSponsorFound = false;
                this.displayErrorMessage(null);
            }
        } else {
            this.isSponsorFound = false;
            this.displayErrorMessage(null);
        }
    }

    /**
     * @description this method will help
     * to close progress bar once done with request
     * @date 2018-08-17
     * @private
     * @memberof CheckoutNewComponent
     */
    private displayErrorMessage(errResponse: any): void {
        this.isSubmitted = false;
        this.fieldErrors = [];
        if (!this.isSponsorFound && !this.sponsorInformation) {
            const notification: any = this._translatePipe.get('order.Sponsor not found');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
        if (errResponse && (errResponse.validations && errResponse.validations.length > 0
            || errResponse.length > 0)) {
            this.fieldErrors = errResponse.validations || errResponse;
        }
    }

    /**
     *  Generate Request for sponsor request
     *  generateSponsorRequest
     * @param {string} sponsorId
     * @memberof OrderPromotionComponent
     */
    searchSponsorRequest(sponsorId: string): SponsorSearchRequest {
        let sponsorSearchRequest: SponsorSearchRequest;
        if (sponsorId) {
            sponsorId = sponsorId.indexOf('@') > -1 ? sponsorId : sponsorId.split('-').join('');
            sponsorSearchRequest = {
                UserName: sponsorId.indexOf('@') > -1 ? '' : sponsorId.trim(),
                Email: sponsorId.indexOf('@') > -1 ? sponsorId.trim() : '',
                FirstName: '',
                LastName: '',
                CountryId: '',
                PreferenceValue: '',
                PostalCode: '',
                StateId: '',
                City: '',
                Option: SponsorSearchOption.SearchByIKnowSponsor,
                EnableLongPoll: environment.enableLongPoll,
                Store: this.countryCode
            };
        } else if (this.shippingAddressInfo) {
            const shippingAddress: Address = this.shippingAddressInfo;
            const language: Language = this.storeInfo.languages.find(x => x.cultureName.toLowerCase()
                === this.orderFormGroup.value.language.toLowerCase());
            sponsorSearchRequest = {
                UserName: '',
                Email: '',
                FirstName: '',
                LastName: '',
                StateId: shippingAddress && shippingAddress.stateId ? String(shippingAddress.stateId) : '',
                City: this.sponsorConfig && this.sponsorConfig.sponsorCityFieldRequired ? shippingAddress.city : '',
                CountryId: String(shippingAddress.countryId),
                CountryCode: shippingAddress.countryCode ? shippingAddress.countryCode : shippingAddress.country,
                PreferenceValue: language ? String(language.languageId) : '',
                PostalCode: shippingAddress.postalCode,
                Option: this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea ?
                    SponsorSearchOption.SearchByArea : SponsorSearchOption.SearchByIDontHaveSponsor,
                EnableLongPoll: environment.enableLongPoll,
                Store: this.countryCode
            };
        }
        return sponsorSearchRequest;
    }

    /**
   * @description we will load sponsor by pooling mechanism
   * @date 2019-09-10
   * @private
   * @param {SponsorSearchRequest} sponsorSearchRequest
   * @param {number} [searchOption]
   * @memberof OrderPromotionComponent
   */
    private searchSponsorByPolling(
        searchResponse: SponsorSearchResponse, sponsorId: string, isSponsorSearch?: boolean,searchOption?:number): void {
        this._commonService
            .getSearchSponsorsByUUID(searchResponse)
            .subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
                if (sponsorSearchResponse) {
                    if (this.sponsorPollCount < this.sponsorMaxPollCount) {
                        this.sponsorPollCount = this.sponsorPollCount + 1;
                        if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                            this.processSearchSponsorResponse(sponsorSearchResponse, sponsorId, isSponsorSearch,null,searchOption);
                        } else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                            sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                            setTimeout(() => {
                                this.searchSponsorByPolling(sponsorSearchResponse, sponsorId, isSponsorSearch,searchOption);
                            }, 2000);
                        } else {
                            this.isSponsorFound = false;
                            this.displayErrorMessage(null);
                        }
                    } else {
                        this.isSponsorFound = false;
                        this.displayErrorMessage(null);
                    }
                }
            }, (error) => {
                this.isSponsorFound = false;
                this.displayErrorMessage(null);
            });
    }

    /**
     * @description this method will process sponsor response
     * @date 2019-09-10
     * @private
     * @param {SponsorSearchResponse} sponsorSearchResponse
     * @memberof OrderPromotionComponent
     */
    private processSearchSponsorResponse(sponsorSearchResponse: SponsorSearchResponse, sponsorId: string, isSponsorSearch?: boolean, anonymousSponsorSearch?: SponsorInformation[],searchOption?:number): void {
        if ((sponsorSearchResponse && sponsorSearchResponse.sponsorSearchResultModels
            && sponsorSearchResponse.sponsorSearchResultModels.length > 0) || (anonymousSponsorSearch && anonymousSponsorSearch.length > 0)) {
            if (sponsorSearchResponse && sponsorSearchResponse.sponsorSearchResultModels
                && sponsorSearchResponse.sponsorSearchResultModels.length > 0) {
                if (sponsorId) {
                    this.sponsorInformation = sponsorSearchResponse.sponsorSearchResultModels
                        .find((x: SponsorInformation) => x.sponsorId === sponsorId);
                    if (!this.sponsorInformation) {
                        this.sponsorInformation = sponsorSearchResponse.sponsorSearchResultModels[0];
                    }
                } else {
                    this.sponsorInformation = sponsorSearchResponse.sponsorSearchResultModels[0];
                }
                if (this.businessEntityDetails && this.businessEntityDetails.anonymousRetailFboId) {
                    this.fboReferralId = this.businessEntityDetails.anonymousRetailFboId;
                }
                this.sponsorInformation.uuid = sponsorSearchResponse.uuid;
            } else if (anonymousSponsorSearch && anonymousSponsorSearch.length > 0) {
                if (sponsorId) {
                    this.sponsorInformation = anonymousSponsorSearch
                        .find((x: SponsorInformation) => x.sponsorId === sponsorId);
                    if (!this.sponsorInformation) {
                        this.sponsorInformation = anonymousSponsorSearch[0];
                    }
                } else {
                    this.sponsorInformation = anonymousSponsorSearch[0];
                }
                if (this.businessEntityDetails && this.businessEntityDetails.anonymousRetailFboId) {
                    this.fboReferralId = this.businessEntityDetails.anonymousRetailFboId;
                }
            }
            this.sponsorInformation
                .sponsorAssignedOptionId = SponsorSearchOption.SearchBySuggestSponsor;
            // Display 'sponsor not found' sponsorid is not empty and corresponding sponsor not found.
            if (this.sponsorInformation) {
                this.sponsorInformation.address = this._commonService
                    .mapAddressModel(this.sponsorInformation);
                this.isSponsorFound = true;
                if (!this.isEnableFboReferralId()) {
                    if (!isSponsorSearch) {
                        this.placeEnrollRequest();
                    }
                } else {
                    if (sponsorId) {
                        this._sponsorService.sponsorEligibilityCheck(this.fboReferralId,
                            this.storeInfo.operatingCountry,searchOption).subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
                                if (sponsorSearchResponse && (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                                    sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS)) {
                                    this.sponsorPollCount = 0;
                                    setTimeout(() => {
                                        this.getSponsorEligibilty(sponsorSearchResponse);
                                    }, 3000)
                                }
                                if (!isSponsorSearch) {
                                    this.placeEnrollRequest();
                                }
                            }, (error) => {
                                if (this.businessEntityDetails && this.businessEntityDetails.anonymousRetailFboId) {
                                    this.fboReferralId = null;
                                }
                                this.isSponsorFound = false;
                                this.displayErrorMessage(null);
                                this.sponsorInformation = null;

                            });
                    } else {
                        if (!isSponsorSearch) {
                            this.placeEnrollRequest();
                        }
                    }
                }
            } else {
                this.isSponsorFound = false;
                this.displayErrorMessage(null);
            }
        } else {
            this.isSponsorFound = false;
            this.displayErrorMessage(null);
        }
    }

    /**
     * @description this method will process member
     * enrollment request
     * @date 2019-09-10
     * @param {EnrollInfo} enrollRequest
     * @memberof OrderPromotionComponent
     */
    async placeEnrollRequest() {
        let itemNumber;
        let revisionNumber;
        let new_RevisionNumber;
        let subTotal = this.calculateItemsSubTotal(this.storeInfo);
        if (this.storeInfo && this.storeInfo.taxInclusive) {
            subTotal = this.itemTotal;
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
            subTotal > this.orderRules.maxValue && (!this.orderRules.validateProductTypes || this.orderRules.validateProductTypes === null)) {
            if (this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
                const maximumCartLimit: any = this._translatePipe.get('order.Cart must not exceed');
                let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue,this.storeInfo);
                const cartMaximumLimitNotification: any = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                    maxValue + '</b>';
                this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
            } else {
                const exceedPerOrderCC: any = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.',
                    { max: this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue + '.00' || '0' , this.storeInfo) });
                this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
            }
            this.isSubmitted = false;
            return;
        } else {
            this._commonService.removeNotification(Constants.MAX_EXCEEDED);
        }

        if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
            let isLiteratureValidation = this.isLiteratureValidation(this.products);
            let invalidProductPopup: any = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}',
                {
                    min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue, this.storeInfo),
                    max: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue, this.storeInfo)
                });
            if (this.validateSubTotalBasedOnType(this.products, subTotal)) {
                this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                this.isSubmitted = false;
                return;
            }
        } else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
        }
        const totalPoints = this.calculateTotalPoints();
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints > this.orderRules.maxValue) &&
            (this.memberTypeId === MemberTypeEnum.RETAIL ||
                this.memberTypeId === MemberTypeEnum.GUEST)) {
            const exceedPerOrderCC: any = this._translatePipe.get('order.Retail Max Order limit reached');
            this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.RETAIL_LIMIT);
            this.isSubmitted = false;
            return;
        } else {
            this._commonService.removeNotification(Constants.RETAIL_LIMIT);
        }
        const enrollRequest: EnrollSession = this.prepareEnrollSessionRequest();
        if (enrollRequest && enrollRequest.enrollInfo && enrollRequest.enrollInfo.orderInfo && (enrollRequest.enrollInfo.orderInfo.orderShippings[0].shipMethodId == null || enrollRequest.enrollInfo.orderInfo.orderShippings[0].shipMethodId == undefined) ){
            const notification: any = this._translatePipe.get('order.Please Select shipping method.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;

        }
        if (!enrollRequest.enrollInfo.orderInfo.taxMetaData && this.isTaxMetaDataAvailable) {
            const notification: any = this._translatePipe.get('order.Tax is not mapped. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
            return;
        }
        const compareTaxValues = this.appConfig && this.appConfig.ignoreCompareTax ? true : this.compareTax(enrollRequest.enrollInfo.orderInfo);
        if (compareTaxValues) {
            const isOptin = this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.FPC && this.optInCheck;
            if (this.retuningGuestUser || (this.personalInformation &&
                (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
                    || this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL)) || isOptin) {
                let recentlyViewedProducts = await this.getRecentlyviewedProducts(enrollRequest.enrollInfo.orderInfo);
                let isProductRevisionNumberMatch = true;
                if (recentlyViewedProducts) {
                    if (recentlyViewedProducts && recentlyViewedProducts.length > 0) {
                        recentlyViewedProducts.forEach(recentProduct => {
                            enrollRequest.enrollInfo.orderInfo.orderLineItems.forEach(product => {
                                if (product.revisionNumber === recentProduct.revisionNumber) {
                                } else {
                                    isProductRevisionNumberMatch = false;
                                    itemNumber = product.itemNumber;
                                    revisionNumber = product.revisionNumber;
                                    new_RevisionNumber = recentProduct.revisionNumber;
                                    return;
                                }
                            });
                        });
                    }
                }
                if (isProductRevisionNumberMatch) {
                    if ((isOptin) || (this.retuningGuestUser && this.personalInformation
                        && this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL)) {
                        const memberId = this.getEnrollmentMemberId();
                        const transliteratedProps = this._commonService.mapTransliterateProperties(this.storeDetails, this.orderFormGroup.get('language').value);
                        this._enrollService.updateEnrollment(enrollRequest.enrollInfo, memberId, transliteratedProps).subscribe(
                            (response: EnrollInfo) => {
                                if (response) {
                                    if (isOptin) {        
                                        this.updateAutoshipProfile(memberId);
                                        this.fboUpgradeSuccess(response);
                                    } else {
                                        this.enrollmentSuccess(response);
                                    }
                                }
                            });
                    }
                    else {
                        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                            enrollRequest.enrollInfo.orderInfo.addresses.forEach(
                                x => {
                                    if (!(x.addressType === AddressType.PICKUP_PERSON || x.addressType === AddressType.PUDO || x.addressType === AddressType.BILLING)) {
                                        this.verifyPudoAddress = false;
                                    }
                                }
                            )
                        }
                        const transliteratedProps = this._commonService.mapTransliterateProperties(this.storeDetails, this.orderFormGroup.get('language').value);
                        if (this.verifyPudoAddress) {
                            this._enrollService.createEnrollRequest(enrollRequest.enrollInfo, transliteratedProps).subscribe(
                                (retailResponse: EnrollInfo) => {
                                    if (retailResponse && retailResponse.validations && retailResponse.validations.length > 0) {
                                        if (retailResponse.personalInfo && retailResponse.personalInfo.memberId
                                            && retailResponse.personalInfo.distributorId
                                            && retailResponse.personalInfo.memberTypeId === MemberTypeEnum.GUEST && retailResponse.orderInfo
                                            && retailResponse.orderInfo.memberTypeId === retailResponse.personalInfo.memberTypeId) {
                                            const retuningGuestUser = this._enrollService.mapAccountResponseToUserInfo(retailResponse.personalInfo);
                                            this.retuningGuestUser = retuningGuestUser;
                                            this.submitOrder();
                                        } else if (retailResponse.personalInfo && retailResponse.personalInfo.memberId
                                            && retailResponse.personalInfo.distributorId
                                            && retailResponse.personalInfo.memberTypeId === MemberTypeEnum.GUEST && retailResponse.orderInfo
                                            && retailResponse.orderInfo.memberTypeId === MemberTypeEnum.RETAIL) {
                                            const retuningGuestUser = this._enrollService.mapAccountResponseToUserInfo(retailResponse.personalInfo);
                                            this.retuningGuestUser = retuningGuestUser;
                                            this.placeEnrollRequest();
                                        } else {
                                            this.isSubmitted = false;
                                            this.retuningGuestUser = null;
                                            this.mailAlreadyExist = true;
                                            this._enrollmentMessageService.setIsEmailAlreadyExists(true);
                                            this._commonService.createNotification('', retailResponse.validations[0].message, NotificationType.ERROR);
                                        }
                                    } else {
                                        this.enrollmentSuccess(retailResponse);
                                    }
                                }, (errorResponse: any) => {
                                    this.displayErrorMessage(errorResponse);
                                });
                        }
                        else {
                            const notification: any = this._translatePipe.get('order.Unable to Place the Order');
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            this.isSubmitted = false;
                        }
                    }
                }
                else {
                    const notification: any = this._translatePipe.get('order.Product revision number miss match, ' + 'Item : ' + itemNumber + ', Revision Number : ' + revisionNumber + ', New Revision Number : ' + new_RevisionNumber);
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }

            }
        } else {
            const notification: any = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
    }
    /**
     * @description To get update member Id
     * @date 2019-10-04
     * @returns {number}
     * @memberof OrderPromotionComponent
     */
    private getEnrollmentMemberId(): number {
        let memberId: number;
        if (this.retuningGuestUser) {
            memberId = this.retuningGuestUser.memberId;
        } else if (this.memberInfo) {
            memberId = this.memberInfo.memberId;
        }
        return memberId;
    }

    /**
     * @description To handle FBO Upgrade success response
     * @date 2019-10-04
     * @private
     * @param {EnrollInfo} response
     * @memberof OrderPromotionComponent
     */
    private fboUpgradeSuccess(response: EnrollInfo): void {
        this.document.documentElement.classList.remove('optin-popup');
        this.updateMemberLevelPopup.close();
        this.saveMemberUpgradeActivityLog(this.memberInfo.memberId,
            MemberActivityLogType.Upgraded_flag);
        this.displayOrderSuccessDetails(response);
    }
    /**
     * @description To Handle create/update enrollment success response
     * @date 2019-10-04
     * @private
     * @param {EnrollInfo} retailResponse
     * @memberof OrderPromotionComponent
     */
    private enrollmentSuccess(retailResponse: EnrollInfo): void {
        if (retailResponse && retailResponse.personalInfo && retailResponse.personalInfo.memberId) {
            const key = this.orderFormGroup.value.orderType === MemberActivityLogType.New_Guest_Retail_Created
                ? MemberActivityLogType.New_Guest_Retail_Created : MemberActivityLogType.New_Retail_Created;
            this.saveMemberUpgradeActivityLog(retailResponse.personalInfo.memberId, key);
        }
        setTimeout(() => {
            this.displayOrderSuccessDetails(retailResponse);
        }, 2000);
    }

    /**
     * @description This methos used to save member activity log
     * while upgrading from fpc to fbo
     * @date 2019-09-13
     * @memberof OrderPromotionComponent
     */
    saveMemberUpgradeActivityLog(memberId: number, key: MemberActivityLogType): void {
        const activityLogKeys: ActivityLogKey[] = [];
        if (key === MemberActivityLogType.Upgraded_flag) {
            activityLogKeys.push({
                key: MemberActivityLogType.MemberLevel_change,
                value: UserTitleType.ASSISTANTSUPERVISOR
            });
        }
        else if (key === MemberActivityLogType.Override_Minimum_Limit) {
            activityLogKeys.push({
                key: MemberActivityLogType.Override_Minimum_Limit,
                value: Constants.OVERRIDE_MINIMUM_LIMIT
            })
        }
        else {
            activityLogKeys.push({
                key: key,
                value: this.prepareMemberUpgradeActivityLogValue()
            });
        }
        this._commonService.saveMemberActivity(memberId, activityLogKeys).subscribe();
    }

    /**
     * @description This methos used for prepare activity log value
     * while creating from new guest/ fpc upgrade
     * @date 2019-09-13
     * @memberof OrderPromotionComponent
     */
    prepareMemberUpgradeActivityLogValue(): string {
        let logValue = '';
        if (this.agreementDocuments) {
            this.agreementDocuments.forEach((x) => {
                logValue = logValue + x.displayName + ', ';
            });
        }
        logValue = logValue ? logValue.substring(0, logValue.length - 2) + '.' : logValue;
        return logValue;
    }

    updatePrivacyPreference() {
        if ((!this.guestToRetailMember) && this.retuningGuestUser && this.retuningGuestUser.memberId && this.retuningGuestUser.memberPreferences && this.appConfig && this.appConfig.enablePrivacyPreference) {
            this._enrollService.updatePrivacyPreference(this.retuningGuestUser.memberPreferences, this.retuningGuestUser.memberId);
        }
    }


    /**
     * @description this method will display order details
     * @date 2019-09-10
     * @param {EnrollInfo} enrollRequest
     * @memberof OrderPromotionComponent
     */
    displayOrderSuccessDetails(retailResponse: EnrollInfo): void {

        const shippingLogInfo = this.getShippingLogInfo();
        if (retailResponse && retailResponse.orderInfo && retailResponse.orderInfo.webOrderId) {
            retailResponse.webOrderId = retailResponse.orderInfo.webOrderId;
            retailResponse.id = retailResponse.orderInfo.id;
            if (shippingLogInfo) {
            }
            this.orderSuccess(retailResponse);
            this.isSubmitted = false;
        }
    }

    /**
     * @description
     * @date 2019-09-10
     * @private
     * @returns {EnrollSession}
     * @memberof OrderPromotionComponent
     */
    private prepareEnrollSessionRequest(): EnrollSession {
        let memberMailingAddress: Address;
        if (this.optInCheck && this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
            this.personalInformation = this._enrollService.getOptInPersonalInfo(this.memberInfo, this.legalRequirements,
                this.memberInfo.memberContacts);
            memberMailingAddress = this.memberInfo.address;
        }
        if (this.sponsorInformation && this.orderFormGroup.value.orderType === OrderType.NEW_RETAIL) {
            this.sponsorInformation.memberCommunicationPreferences = this.memberCommunicationPreferences;
        }

        const enrollSession: EnrollSession = {
            enrollInfo: {
                personalInfo: this._enrollService.preparePersonalInfo(this.storeInfo,
                    this.orderFormGroup.value.language || this.storeDefaultLanguage,
                    this.personalInformation, this.shippingAddressInfo, this.countryCode, this.orderFormGroup.value.countryId,
                    this.sponsorInformation, this.bonusInfoAgreements, this.memberInfo, this.memberTypeId,
                    this.legalRequirements, this.mailingAddress, memberMailingAddress, null, this.bonusInformation, null, null, this.businessInformation),
                orderInfo: this.prepareOrderRequest(),
                shoppingCartInfo: null,
                sponsorId: this.sponsorInformation ? this.sponsorInformation.sponsorId : '',
                sponsorInfo: this.sponsorInformation
            },
            sponsorId: this.sponsorInformation ? this.sponsorInformation.sponsorId : ''
        };
        if (this.showOptin && enrollSession && enrollSession.enrollInfo.personalInfo &&
            enrollSession.enrollInfo.personalInfo.memberContacts && enrollSession.enrollInfo.personalInfo.memberContacts.length) {
            const mobile = enrollSession.enrollInfo.personalInfo.memberContacts.find(x => x.contactTypeID === ContactTypeValue.MOBILE);
            if (!mobile) {
                const homePhone = this.memberInfo.memberContacts.find(x => x.contactTypeID === ContactTypeValue.MOBILE);
                if (homePhone) {
                    enrollSession.enrollInfo.personalInfo.memberContacts.push(homePhone);
                }
            }
            const phone = enrollSession.enrollInfo.personalInfo.memberContacts.find(x => x.contactTypeID === ContactTypeValue.PHONE);
            if (!phone) {
                const homePhone = this.memberInfo.memberContacts.find(x => x.contactTypeID === ContactTypeValue.PHONE);
                if (homePhone) {
                    enrollSession.enrollInfo.personalInfo.memberContacts.push(homePhone);
                }
            }
        }
        const sessionGuid = this._cacheService.getSessionValue(CacheKey.SessionGuid);
        if (sessionGuid && enrollSession && enrollSession.enrollInfo.personalInfo) {
            enrollSession.enrollInfo.personalInfo.sessionGuid = sessionGuid;
        }
        return enrollSession;
    }


    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @date 2019-09-05
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderPromotionComponent
     */
    getGuestPersonalInfo(event): void {
        this.personalInformation = event.personalInformation;
        this.guestFormValidated = event.guestPersonalInfoFormValidated;
        this.retuningGuestUser = event.userInfo;
        this.mailAlreadyExist = event.personalInformation.mailAlreadyExist;
    }

    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @date 2019-09-05
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderPromotionComponent
     */
    getPersonalInfo(event): void {
        this.personalInformation = event.personalInformation;
        this.personalInfoFormValid = event.personalInfoFormValid;
        this.retuningGuestUser = event.userInfo;
    }

    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @date 2019-09-05
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderPromotionComponent
     */
    getGuestPersonalInfoFormStatus(personalInfo: Address): void {
        if (!this.shippingAddressInfo) {
            const address: Address = personalInfo;
            if (this.countryCode) {
                const countryCode = this.countries.find((x: any) => x.isocodeThree === this.countryCode);
                this.countryID = countryCode.countryId;
            }
            address.countryId = this.countryID;
            this.address = address;
            this.showAddressForm = false;
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
                this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                    + environment.templateVersion;
            } else {
                this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                    + environment.templateVersion;
            }
            /*     this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                     + environment.templateVersion;*/
            setTimeout(() => {
                this.address = address;
                this.showAddressForm = true;
            }, 200);
            this.emailForm.controls['payByLinkEmail'].setValue(address.email);
            if (this.emailForm.controls['payByLinkEmail'].value !== '') {
                this.isPayByLinkValid = true;
            } else {
                this.isPayByLinkValid = false;
            }
        }

    }

    /**
     * @description get mail already exists or not
     * @date 2019-10-14
     * @param {*} event
     * @memberof OrderPromotionComponent
     */
    getMailAlreadyExixts(event): void {
        this.mailAlreadyExist = event;
    }

    /**
     * @description get selected shipping method while
     * delivery type is pick up
     * @date 2019-09-05
     * @param {ShippingMethod} shippingMethod
     * @memberof OrderPromotionComponent
     */
    getPersonalInfoFormStatus(event): void {
        this.personalInfoFormValid = event.personalInfoFormValid;
        this.liveFormPersonalInfo = event.personalInformationForm.value;
    }

    /**
     * @description  this method is used to
     * get the verified or sugggested address
     * @date 2019-09-18
     * @param {Address} mailingAddress
     * @memberof PersonalInfoComponent
     */
    getMailingAddressInfo(address: Address): void {
        this.mailingAddress = address;
        this.getAddressOnInputChange(address);
    }

    /**
     * @description to rebind the selected sponsor wizard options and values
     * @date 2019-09-21
     * @param {string} requestUrl
     * @memberof OrderPromotionComponent
     */
    rebindSponsorOptions(rebindSponsorData: RebindSponsorData): void {
        this.rebindSponsorData = rebindSponsorData;
    }

    /**
     * @description
     * @date 2021-02-01
     */
    validateOrderLimit(quantityUpdate: boolean): void {
        if (!this.orderRules) {
            return;
        }
        const exceedMonthlyCCPopup: any = this._translatePipe
            .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
        const exceedMonthlyCCOverridePopup: any = this._translatePipe
            .get('order.Monthly CC limit reached');
        const orderRulesMaxValue = this.orderRules && this.orderRules.maxValue ? this.orderRules.maxValue : this.orderRules.literatureMaxValue;
        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(((this._commonService.validateNumberDecimalPoint(orderRulesMaxValue) ? orderRulesMaxValue : orderRulesMaxValue + '.00') || '0'),this.storeInfo);
        const exceedPerOrderCC: any = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.',
            { max: maxValue });
        let minimumCartLimit: any = this._translatePipe.get('order.Order must meet a minimum of');
        const maximumCartLimit: any = this._translatePipe.get('order.Cart must not exceed');
        if (this.thresholdCrossed && this.orderRules && this.orderRules.valueType !== ValueType.BOTH) {
            if (this.cartLimitExceed) {
                let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue,this.storeInfo);
                const cartMaximumLimitNotification: any = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                    maxValue + '</b>';
                if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberInfo && this.memberInfo.memberTypeId !== MemberTypeEnum.GUEST) {
                    this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
                if (this.appConfig.displayMinValidation && this.memberInfo && (this.memberTypeId === MemberTypeEnum.RETAIL || this.memberInfo.memberTypeId === MemberTypeEnum.GUEST)) {
                    this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
                this.isSubmitted = false;
            } else if (this.cartLimitNotReach && !quantityUpdate) {
                if (this.products && this.products.length &&
                    this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
                    && this.appConfig.displayPurchaseLimitationMessage
                    && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                    minimumCartLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                }
                if (this.overrideMinimumLimitIsEnabled) {
                    let overrideLimitLink: any = this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                    let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                    const cartMinimumLimitNotification: any = minimumCartLimit.value + ' <b class="helvetica-bold">' +
                        minValue + '</b>.<b>' + overrideLimitLink.value + '</b>';
                    this.cartMessageID = setTimeout(() => {
                        const toast = this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                        toast.click.subscribe((event) => {
                            if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                this.overrideMinimumLimit.open();
                            }
                        });
                    }, 100);
                }
                else {
                    let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                    const cartMinimumLimitNotification: any = minimumCartLimit.value + ' <b class="helvetica-bold">' +
                        minValue + '</b>';
                    this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                }
                this.isSubmitted = false;
            } else {
                this._commonService.removeNotification(Constants.MIN_LIMIT);
                this._commonService.removeNotification(Constants.MAX_EXCEEDED);
            }
        } else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
            this._commonService.removeNotification(Constants.MAX_EXCEEDED);
        }
        if ((this.memberCCLimitExceeded || this.thresholdCrossed) && !this.memberCCOverrideLimitExceeded) {
            const currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
            const endDate = this.memberCCOverride && this.memberCCOverride.effectiveEndDate ? this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
            .format(DateConstants.DateFormat): null;
            const monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                + ((this.memberCCOverride && this.memberCCOverride.cVLimit  && (new Date(currentDate) <= new Date(endDate))) ? this.memberCCOverride.cVLimit : this.monthlyCCValue) + '</b>';
            if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                if (this.memberCCLimitExceeded) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR);
                }
                if ((this.cartLimitExceed || this.cartLimitNotReach) && !quantityUpdate) {
                    let isLiteratureValidation = this.isLiteratureValidation(this.products);
                    let invalidProductPopup: any = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}',
                        {
                            min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue, this.storeInfo),
                            max: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue, this.storeInfo)
                        });
                    this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                } else {
                    this._commonService.removeNotification(Constants.ORDER_LIMIT);
                }
            } else if (!this.appConfig.displayPurchaseLimitationMessage) {
                if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                } else {
                    this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
            } else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
            this.isSubmitted = false;
        }
        if (this.memberCCOverrideLimitExceeded) {
            const monthlyCCOverrideContent = exceedMonthlyCCOverridePopup.value + ' <b class="helvetica-bold">'
                + this.memberCCOverride.cVLimit + ' CC</b>';
            this._commonService.createNotification('', monthlyCCOverrideContent, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
            this.isSubmitted = false;
        } else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
        }
        if (this.checkoutConfig.enableMonthlyCCLimitRules) {
            const totalPoints = this.calculateTotalPoints();
            const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));;
            if (this.orderRules && totalCC > this.orderRules.maxCCValue && this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                const exceedMonthlyCCPopup: any = this._translatePipe
                    .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                const monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">' + (this.memberCCOverride && this.memberCCOverride.cVLimit ? this.memberCCOverride.cVLimit : this.orderRules.maxCCValue) + '</b>';
                this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                this.isSubmitted = false;
            } else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
        }
    }

    /**
     * @description place order
     * @date 2019-05-21
     * @param {string} requestUrl
     * @memberof OrderPromotionComponent
     */
    placeOrder(requestUrl: string): void {
        this.validateOrderLimit(false);
        const currentCC = this.calculateTotalPoints();
        if ((((this.orderRules && !this.thresholdCrossed) || !this.orderRules) && (!this.memberCCOverrideLimitExceeded) &&
            ((this.memberOrderCCInfo && !this.memberCCLimitExceeded) || !this.memberOrderCCInfo))
            || (!currentCC && this.orderRules.valueType !== ValueType.BOTH)
        ) {
            const availableCC = this.existingCC ? this.existingCC - currentCC
                : this.distributorMaxCC - currentCC;
            const memberHomeCountry = this.memberInfo && this.memberInfo.memberAllowedCountries && this.memberInfo.memberAllowedCountries.length
                ? this.memberInfo.memberAllowedCountries.find((country: MemberAllowedCountries) => country.homeCountry === true) : null;
            const isMemberHomeCountry = memberHomeCountry && this.selectedIsoCountryCode === memberHomeCountry.isoCodeThree ? true : false;
            if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER && isMemberHomeCountry &&
                ((availableCC <= 0 || availableCC >= this.distributorMaxCC) || (this.memberInfo.wholeSaleQualified))
                && this.orderFormGroup.controls['paymentSelector'].value !== this.selectEnum.thirdOption.toString()
                && this.appConfig.fpcToFboUpgradeFlowEnable) {
                this.optInCheck = true;
                this.openMemberLevelChange(requestUrl);

            } else {
                this.submitPlaceOrder(requestUrl);
            }
        }
    }

    /**
     * @description
     * @date 2019-09-04
     * @memberof OrderPromotionComponent
     */
    submitPlaceOrder(requestUrl: string): void {
        const orderRequest: any = this.prepareOrderRequest();
        if (orderRequest && (orderRequest.orderShippings[0].shipMethodId == undefined || orderRequest.orderShippings[0].shipMethodId == null)) {
            const notification: any = this._translatePipe.get('order.Please Select shipping method.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;

        }
        else if ((orderRequest.taxMetaData && this.isTaxMetaDataAvailable) || (!orderRequest.taxMetaData && !this.isTaxMetaDataAvailable)) {
            this.getAcceptPaymentDocuments();
            const compareTaxValues = this.appConfig && this.appConfig.ignoreCompareTax ? true : this.compareTax(orderRequest);
            if (compareTaxValues) {
                this.comparePriceTier(orderRequest, requestUrl);
            } else {
                const notification: any = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
            }
        }
        else {
            const notification: any = this._translatePipe.get('order.Tax is not mapped. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }

    }

    /**
     * @description compare tax
     * @date 2019-10-31
     * @param {Order} orderRequest
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    compareTax(orderRequest: Order): boolean {
        if (orderRequest && orderRequest.taxMetaData && orderRequest.taxMetaData.orderTaxCharges
            && orderRequest.taxMetaData.orderTaxCharges.length > 0) {
            let totalTaxAmount = 0;
            orderRequest.taxMetaData.orderTaxCharges.forEach(tax => {
                totalTaxAmount = totalTaxAmount + parseFloat(tax.taxAmount.toFixed(2));
            });
            totalTaxAmount = this._currencyPipe.getFormatedCurrency(totalTaxAmount, this.storeInfo);
            if (orderRequest.orderTax.toFixed(2) === totalTaxAmount.toFixed(2)) {
                return true;
            } else {
                return false;
            }

        } else {
            return true;
        }
    }
    /**
     * create order log request parameter
     */
    createOrderLog(res, message?: string) {
        const orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': res.id,
            'webOrderId': res.webOrderId,
            'message': message ? message : 'Order Placed by the agent',
            'source': Constants.CUSTOMER_SERIVCE
        };
        this._orderService.createOrderLog(orderLogRequest).subscribe((response) => { },
            (error: any) => {
                this._commonService.createNotification('', 'Failed to Create order log', NotificationType.ERROR);
            });
    }


    private orderSuccess(response: any) {
        this.updatePrivacyPreference();
        const subTotal = this.calculateItemsSubTotal(this.storeInfo);
        this.isOverrideMinimumLimit && this.hasMinimumOverrideLimit && subTotal <= this.orderRules.minValue ? this.saveMemberUpgradeActivityLog(this.memberInfo !== null ? this.memberInfo.memberId : response.personalInfo.memberId, MemberActivityLogType.Override_Minimum_Limit) : false;
        this.showSelectedShipMethod = false;
        this.paymentComponentSettings.webOrderId = response.webOrderId;
        this.paymentComponentSettings.orderReferenceId = response.id;
        this.orderFromLookup = false;
        this.hasPersistedMemberId = false;
        this.persistedMemberId = '';
        this.fboid = '';
        this.showShippingData = false;
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
            || this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            this.clearGuestFormDetails();
        }
        this.clearAllTheForms(true, true, true);
        this.isSubmitted = false;
        this.openOrderViewTab(this.paymentComponentSettings.webOrderId);
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.removeSessionGuid();
    }

    /**
     * @description This method used to reset guest flow details
     * @method clearGuestDetails()
     * @memberof OrderPromotionComponent
     */
    clearGuestFormDetails() {
        this.orderFormGroup.controls['orderType'].setValue(this.orderType.REGULAR);
        this.orderTypePrevValue = this.orderType.REGULAR;
        this.personalInformation = null;
        this.sponsorInformation = null;
        this.retuningGuestUser = null;
        this.mailingAddress = null;
        this.liveFormAddress = null;
        this.agreementDocuments = [];
        this.isPrivacyPreference = null;
    }

    openOrderViewTab(weborderID: string) {
        const orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = weborderID;
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode;
        orderInfo.newOrder = true;
        orderInfo.acceptDocuments = this.acceptPaymentDocuments;
        this.messageService.setOrderHistoryTab(orderInfo);
    }

    getAcceptPaymentDocuments() {
        if (+this.orderFormGroup.controls['paymentSelector'].value == this.paymentTypeEnum.Direct_Debit) {
            this.acceptPaymentDocuments = {
                memberId: this.memberInfo.memberId,
                memberTypeId: this.memberInfo.memberTypeId,
                documents: this.paymentTermsAndPoliciyDocuments
            };
        } else {
            this.acceptPaymentDocuments = null
        }
    }

    private orderPending(response: any) {
        if ((response.json().status === 'IN-PROGRESS') || (response.json().status === 'QUEUED')) {
            if (this.pollCount < this.maxPollCount) {
                if (localStorage.getItem('appadmin.pollCount')) {
                    this.pollCount = +(localStorage.getItem('appadmin.pollCount'));
                } else {
                    localStorage.setItem('appadmin.pollCount', '1');
                }
                this.pollCount = this.pollCount + 1;
                localStorage.setItem('appadmin.pollCount', this.pollCount + '');
                this.submitOrder(response.json().location);
            }
        } else {
            localStorage.removeItem('appadmin.pollCount');
        }
        localStorage.removeItem('appadmin.pollCount');
    }

    prepareOrderRequest(): any {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        let shippingAddress;
        let orderTypeId = PurchaseFlow.Personal_Order;
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            orderTypeId = PurchaseFlow.Retail;
        }
        const shippingTax = this._enrollService.prepareShippingTax(this.orderTaxResponse) || this.shippingTax;
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            shippingAddress = this.getShippingAddress();
        } else {
            shippingAddress = this.getShippingAddress();
        }
        if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === shippingAddress.countryId);
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status */
        const memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        const shippingObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === this.orderFormGroup.value.shipMethodId)[0];
        let orderRequest: any = {
            backDateOrder: this.orderFormGroup.value.backDateOrder,
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: OrderStatus.Pending,
            memberId: this.memberInfo ? this.memberInfo.memberId : this.retuningGuestUser ? this.retuningGuestUser.memberId : null,
            email: this.memberInfo ? this.memberInfo.email : this.personalInformation ? this.personalInformation.email : null,
            languageCode: this.orderFormGroup.value.orderType === this.orderType.REGULAR ? this.storeDefaultLanguageShortCode : this._enrollmentCommonService.getLanguageCultureCode(this.storeLanguages, this.orderFormGroup),
            storeId: this.storeInfo.id,
            orderTypeId: orderTypeId,
            memberLevelId: memberTitleId,
            shippingCost: this.getTaxExclusiveShippingCost(),
            importFeeValue: this.importFeeValue,
            retailDeliveryFee: this.retailDeliveryFee,
            shippingTax: (this.appConfig && this.appConfig.enableVatItemizationForNonVat) ? shippingTax : ((this.memberShippingDiscountOfferEligible ||
                (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) || (this.appConfig && this.appConfig.displayTaxInclusivePrice)) && !this.isShippingTaxAddedToShippingCost) ? 0 : shippingTax,
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : this.retuningGuestUser
                ? this.retuningGuestUser.distributorId : null,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: OrderSourceTypes.CUSTOMERSERVICE,
            orderGroupId: this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
                ? this.orderType.REGULAR : this.orderFormGroup.value.orderType,
            orderNotes: null,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: this.getOrderPaymentInfo(),
            shippingAddressModel: shippingAddress,
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            loggedInUserId: this.userInfo ? this.userInfo.userId : null,
            loggedInUserName: this.userInfo ? this.userInfo.userName : null,
            taxMetaData: this.orderTaxResponse ? this.orderTaxResponse.taxMetaData : null,
            erpTaxMetaData: this.orderTaxResponse ? this.orderTaxResponse.erpTaxMetaData : null,
            priceTierName: this.getPriceTier(),
            wholesaleQualified: this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false,
            memberTypeId: this.memberTypeId,
            sponsorId: this.memberInfo ? this.getOrderSponsorId() : this.sponsorInformation
                ? this.sponsorInformation.sponsorId : this.retuningGuestUser ? this.retuningGuestUser.sponsorId : null,
            personalDiscountPercentage: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage)
                : this.personalDiscountPercentage,
            memberLevelDiscount: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage) : 0,
            // we have to send the wholesale discount percentage of the user,
            // how much discount he will get if he is an wholesaleQualified User
            wholesaleQualifiedDiscount: this.memberInfo ?
                this._commonService.getWholesaleQualifiedDisc(this._orderService
                    .getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId)) : 0,
            optIn: this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            vatID: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.governmentId : null,
            sessionGuid: this._enrollmentCommonService.getSessionGuid(),
            accountLevelId: this._commonService.getMemberAccountLevelId(this.memberInfo),
            coldProtection: shippingObj ? shippingObj.coldProtection : false,
            businessEntityId: this.businessEntityId,
            firstName: this.personalInformation && this.personalInformation.firstName ? this.personalInformation.firstName : this.memberInfo.firstName,
            lastName: this.personalInformation && this.personalInformation.lastName ? this.personalInformation.lastName : this.memberInfo.lastName,
            languageCulture: this.orderFormGroup.value.orderType === this.orderType.REGULAR ? this.storeLanguageCultureName : this.languageCulture,
            paymentLinkEmail: this.emailForm.value.payByLinkEmail,
            overrideMinimumLimit: this.isOverrideMinimumLimit,
            retailFreeShippingOrder: false,
            retailFreeShippingCost: 0,
            freeShippingPromotionOrder:shippingObj ? shippingObj.freeShippingEligible: false,
            orderLevelDiscount: this.orderLevelDiscount,
            sourceTypeId: 5
        };
        if (this.isOrderMeetsRFSCriteria() && shippingObj && shippingObj.shippingMethod.toLowerCase() == RetailFreeShippingConstants.FREE_SHIPPING.toLowerCase()) {
            orderRequest = { ...orderRequest, retailFreeShippingOrder: true, retailFreeShippingCost: this.storeDetails && this.storeDetails.retailFreeShippingCostDeduction ? +this.storeDetails.retailFreeShippingCostDeduction : 0 }
        }
        if(shippingObj && shippingObj.freeShippingEligible){
            orderRequest.shippingCost = 0;
            // setting actual shipping cost
            orderRequest.retailFreeShippingCost = shippingObj.originalShippingCost;
        }
        if (!orderRequest.freeShippingPromotionOrder) {
            if (!orderRequest.retailFreeShippingOrder) {
                const hasFDShippableProduct = orderRequest.orderLineItems.some((item) => item.shippableFulfillment);
                if (hasFDShippableProduct && this.shipMethod && this.shipMethod.retailFreeShippingCost) {
                    orderRequest.retailFreeShippingOrder = true;
                    orderRequest.retailFreeShippingCost = this.shipMethod.retailFreeShippingCost;
                }
            }
        }    
        return orderRequest;
    }

    /**
     *  @description thi smethod used for to get t the sponsor id
     *
     */
    getOrderSponsorId(): string {
        if (this.isEnableFboReferralId()) {
            return this.sponsorInformation.sponsorId
        }
        return this.memberInfo.sponsorId;
    }

    /**
   * @description
   * @memberof CommonService
   */
    getCountryTaxInclusiveInfo(country: Country): boolean {
        let countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    }
    /**
     * @description comapare price tier details for line items
     * @date 2019-10-16
     * @param {*} orderRequest
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    comparePriceTier(orderRequest: any, requestUrl: string): void {
        const memberDetails = this.memberInfo ? this.memberInfo : this.retuningGuestUser ? this.retuningGuestUser : null;
        if (orderRequest && orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0 && memberDetails) {
            const wholesaleQualified: boolean = memberDetails && memberDetails.wholeSaleQualified
                ? memberDetails.wholeSaleQualified : false;
            const optin: boolean = memberDetails && memberDetails.optin ? memberDetails.optin : false;
            let memberTitleId = memberDetails && memberDetails.memberLevelId
                ? this.memberInfo.memberLevelId : memberDetails && memberDetails.memberTitleId ? memberDetails.memberTitleId : null;
            const memberTypeId = memberDetails && memberDetails.memberTypeId ? memberDetails.memberTypeId : null;
            // HARD_DOWNGRADE CHECK FOR FPC USERS
            memberTitleId = this._orderService.getDowngradeTitleID(memberTypeId, memberTitleId);
            this._orderService.getPriceTierByMemberId(this.storeInfo.id, memberTitleId, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe((response: PriceTierResponse) => {
                if (response && response.priceTireName) {
                    const priceTierName = response.priceTireName;
                    let isPriceTierMatched = true;
                    orderRequest.orderLineItems.forEach(item => {
                        if (priceTierName !== item.priceTierName) {
                            isPriceTierMatched = false;
                        }
                    });
                    this.checkLineItemsPriceTier(isPriceTierMatched, orderRequest, requestUrl);
                } else {
                    this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
                }
            }, (error) => {
                this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
            });
        } else {
            this.checkLineItemsPriceTier(true, orderRequest, requestUrl);
        }
    }

    /**
     * @description check line items pricetier
     * @date 2019-10-16
     * @param {boolean} isPlaceOrder
     * @param {*} orderRequest
     * @returns {void}
     * @memberof OrderPromotionComponent
     */
    async checkLineItemsPriceTier(isPlaceOrder: boolean, orderRequest: any, requestUrl: string) {
        let itemNumber;
        let revisionNumber;
        let new_RevisionNumber;
        if (isPlaceOrder) {
            let recentlyViewedProducts = await this.getRecentlyviewedProducts(orderRequest);
            let isProductRevisionNumberMatch = true;
            if (recentlyViewedProducts) {
                if (recentlyViewedProducts && recentlyViewedProducts.length > 0) {
                    recentlyViewedProducts.forEach(recentProduct => {
                        orderRequest.orderLineItems.forEach(product => {
                            if (product.revisionNumber === recentProduct.revisionNumber) {
                            } else {
                                isProductRevisionNumberMatch = false;
                                itemNumber = product.itemNumber;
                                revisionNumber = product.revisionNumber;
                                new_RevisionNumber = recentProduct.revisionNumber;
                                return;
                            }
                        });
                    });
                }
            }
            if (isProductRevisionNumberMatch) {
                this.submitOrderBasedOnPriceTierCheck(orderRequest, requestUrl);
            }
            else {
                const notification: any = this._translatePipe.get('order.Product revision number mismatch,' + ' Item : ' + itemNumber + ', Revision Number : ' + revisionNumber + ', New Revision Number : ' + new_RevisionNumber);
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
            }
        } else {
            if (orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0) {
                const productIds = orderRequest.orderLineItems.map((item: Product) => item.productId);
                if (productIds && productIds.length) {
                    this.orderFormGroup.get('items').reset();
                    const arr = <FormArray>this.orderFormGroup.controls.items;
                    arr.controls = [];
                    this.getProductsByIds(productIds, this.storeInfo);
                    const notification: any = this._translatePipe.get('order.Product prices are updated. please verify and submit order');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            }
        }
    }
    getRecentlyviewedProducts(orderRequest: any): Promise<any> {
        const wholesaleQualified: boolean = orderRequest.wholesaleQualified;
        const optin: boolean = orderRequest.optin;
        const productIds = orderRequest.orderLineItems.map((item: Product) => item.productId);
        this.purchaseFlowType = this._commonService.getPurchaseFlowType(orderRequest.memberTitleId, orderRequest.wholesaleQualified, this.appConfig.fpc5PercentEnabled, false, orderRequest.memberTitleId);
        if (productIds && productIds.length > 0) {
            return this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id,
                orderRequest.memberLevelId, this.purchaseFlowType, this.selectedIsoCountryCode,
                wholesaleQualified ? true : false, optin ? true : false, this.storeInfo.taxInclusive).toPromise();
        } else {
            const notification: any = this._translatePipe.get('order.Products not added .');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }

    }

    /**
     * @description
     * frame content to be logged for shipping price change
     * @date 2020-03-18
     * @returns {string}
     * @memberof OrderPromotionComponent
     */
    getShippingLogInfo(): string {
        let shippingLogInfo: string;
        const shippingCost = this.getOrderShippingCost();
        if (this.appConfig && this.appConfig.freeShippingFPCOrder && this.memberShippingDiscountOfferEligible) {
            shippingLogInfo = 'Shipping Cost was discounted by ' + this._currencyPipe.
                transform(shippingCost, this.storeInfo, true);
        } else if (this.orderFormGroup && this.orderFormGroup.controls['shippingCostSelector']
            && this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
            && this.orderFormGroup.controls['shippingCostPercentage']
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0) {
            const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value;
            shippingLogInfo = discountPercentage > 0 ? 'Shipping Cost was discounted by ' +
                (discountPercentage + '%') + '.' : '';
        } else if (this.orginalShippingCost !== shippingCost && !this.appConfig.enableVatItemizationForNonVat) {
            const costDifference = shippingCost - this.orginalShippingCost;
            shippingLogInfo = costDifference > 0 ? 'Shipping Cost was increased by ' + this._currencyPipe.
                transform(costDifference, this.storeInfo, true) +
                '.' : 'Shipping Cost was discounted by ' + this._currencyPipe.
                    transform(-costDifference, this.storeInfo, true) + '.';
        }
        return shippingLogInfo;
    }

    /**
     * @description submit Order
     * @date 2019-10-17
     * @param {*} orderRequest
     * @memberof OrderPromotionComponent
     */
    submitOrderBasedOnPriceTierCheck(orderRequest: any, requestUrl: string): void {

        if (orderRequest) {
            let notification: any;
            this._orderService.createNewOrder(orderRequest, requestUrl).subscribe((response: any) => {
                if (response) {
                    if (response.json().status === 'COMPLETED' && response.json().responseModel
                        && response.json().responseModel.success) {
                        if (this.appConfig && this.appConfig.freeShippingFPCOrder && this.memberShippingDiscountOfferEligible) {
                            this.removeMemberDiscountOffer(this.memberInfo.memberId);
                        }
                        const shippingLogInfo = this.getShippingLogInfo();
                        if (shippingLogInfo) {
                        }
                        this.orderSuccess(response.json().responseModel);
                        const sessionGuid = ((this.memberCart && this.memberCart.sessionGuid) || this.memberCartSessionGuid);
                        if (sessionGuid && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST && this.shoppingBagClicked) {
                            this.deleteCart(sessionGuid);
                        }
                    } else if (response.json().responseModel && response.json().status === 'VALIDATION-ERROR'
                        && response.json().responseModel.validations.length > 0) {
                        const exceedLimitNotification = response.json().responseModel.validations[0].message;
                        response.json().responseModel.validations.forEach(x => {
                            if (x.message === StatusConstants.MONTHLY_CC_EXCEEDED) {
                                notification = this._translatePipe.get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                                const errorMessage = notification.value + ' <b class="helvetica-bold">'
                                    + (this.memberCCOverride && this.memberCCOverride.cVLimit ? this.memberCCOverride.cVLimit : this.memberOrderCCInfo.maxCCValue) + '</b>';
                                this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
                            } else if (x.field === 'VAT REGITSTER') {
                                const notification: any = this._translatePipe.get('order.VAT Registered Price Error');
                                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }else {
                                notification = this._translatePipe.get('order.Unable to Process the Order');
                                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                        });
                    } else {
                        this.orderPending(response);
                    }
                    this.isSubmitted = false;
                }
            }, (error: Response) => {
                this.orderSessionGuid = orderRequest.sessionGuid;
                this.getOrderDetailsByUuid(this.orderSessionGuid, orderRequest.distrubutorId);
            });
        }
    }

    /**
* @returns OrderLineItem
*/
    private getOrderLineItems(countryTaxInclusive: boolean): any[] {
        const lineItems: any[] = [];
        if (this.products && this.products.length > 0) {
            let itemLineNumber = 0;
            let lineItemTax: any;
            this.products.sort((x, y) => {
                return (x.comboBOMEnabled === y.comboBOMEnabled) ? 0 : x.comboBOMEnabled ? 1 : -1;
            });
            this.products.forEach((product: any) => {
                if (product) {
                    let unitPrice: number = countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    let retailPrice: number = countryTaxInclusive ? product.retailPrice : product.baseRetailPrice;
                    let wholesalePrice: number = countryTaxInclusive ? product.wholesalePrice : product.baseWholesalePrice;
                    if (this.displayPriceConfig) {
                        unitPrice = this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice :
                                (this.displayPriceConfig.displayCatalogPrice ? product.catalogPrice : product.applicablePrice));
                        retailPrice = this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice;
                        wholesalePrice = this.displayPriceConfig.displayWholesalePrice ? product.wholesalePrice :
                            this.displayPriceConfig.displayBaseWholesalePrice ? product.baseWholesalePrice : product.wholesalePrice;
                    }
                    if (this.orderTaxResponse && this.orderTaxResponse.cart && this.orderTaxResponse.cart.orderLineItems
                        && this.orderTaxResponse.cart.orderLineItems.length > 0) {
                        lineItemTax = this.orderTaxResponse.cart.orderLineItems.find(y => y.itemNumber === product.itemNumber);
                    }
                    const unitDiscountPrice = this.memberInfo && this.memberInfo.transactionalWholesaleQualified ?
                        (product.baseWholesalePrice - product.catalogPrice) : 0;
                    const bondedProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && x.metaKeyWords === '1');
                    const lineItem: any = {
                        discountPercentage: product.discountPercentage,
                        literature: product.literature,
                        orderLineNumber: ++itemLineNumber,
                        productId: product.id,
                        itemNumber: product.itemNumber,
                        productName: product.displayName ? product.displayName : product.name,
                        unitRetailPrice: retailPrice,
                        unitWholeSalePrice: wholesalePrice,
                        unitBaseWholeSalePrice: product.baseWholesalePrice,
                        unitPaidPrice: unitPrice,
                        taxInclusive: (this.checkoutConfig && this.checkoutConfig.storeTaxExclusivePrice) ? false : countryTaxInclusive,
                        unitTaxExclusiveRetailPrice: product.baseRetailPrice,
                        unitTaxExclusivePaidPrice: product.catalogPrice,
                        unitCommissionablePrice: 0,
                        importedMeasurementUnit: product.importedMeasurementUnit,
                        revisionNumber: product.revisionNumber,
                        taxRate: product.taxRate || 0,
                        unitTax: lineItemTax ? lineItemTax.salesTax : 0,
                        unitTaxablePrice: lineItemTax && lineItemTax.taxablePrice ? lineItemTax.taxablePrice : 0,
                        unitQualificationValue: product.commissionableVolume || 0,
                        quantity: product.quantity,
                        freeshipping: false,
                        shippable: product.shipping ? product.shipping.shippingRequired : null,
                        fboEligible: this.getFBOEigibleProduct(product),
                        downloadActivated: product.downloadableProduct,
                        weight: product.shipping ? product.shipping.weight : null,
                        height: product.shipping ? product.shipping.height : null,
                        length: product.shipping ? product.shipping.length : null,
                        width: product.shipping ? product.shipping.width : null,
                        totalAmount: this._currencyPipe.getFormatedCurrency(this.getItemTotalSum(product), this.storeInfo),
                        discountAmount: this._currencyPipe.getFormatedCurrency
                            (this.calculateDiscountAmount(product, this.displayPriceConfig), this.storeInfo),
                        personalDiscount: this._currencyPipe.getFormatedCurrency(((
                            parseFloat(product.retailPrice.toFixed(2)) * product.quantity
                            * this.personalDiscountPercentage) / 100), this.storeInfo),
                        priceTierName: product.priceTierName,
                        netUnitPrice: this.appConfig && this.appConfig.calculateNetUnitPrice
                            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
                            && this.memberInfo.transactionalOptin ? this.calculateNetUnitPrice(product) : 0,
                        unitDiscount: unitDiscountPrice,
                        lineDiscount: unitDiscountPrice * product.quantity,
                        comboBOMEnabledProduct: product.display ? (product.display.comboBOMEnabled ? true : false) : false,
                        depositFeeProduct: product.display ? (product.display.depositFeeProduct ? true : false) : false,
                        depositFeeEnabledProduct: product.productMetaData ? (product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1') ? true : false) : false,
                        orderPromotionTrackings: product.orderPromotionTrackings ? product.orderPromotionTrackings : null,
                        bondedProduct: bondedProduct ? true : false,
                        shippableFulfillment: product.shipping ? (product.shipping.shippableFulfillment ? true : false) : false,

                    };
                    lineItems.push(lineItem);
                }
            });
        }
        return lineItems;
    }

    /**
     * @description get FBO eligible product
     * @date 2019-07-04
     * @private
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    private getFBOEigibleProduct(product: Product): boolean {
        if (product.productMetaData) {
            const fboEligibilty = product.productMetaData.
                find(x => x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE);
            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                return true;
            }
        }
    }

    private getOrderShippings(): any[] {
        const orderShippings: any[] = [];
        let shippingAddressId = null;
        const guestToRetailAddressId = this.guestToRetailShippingId;
        if (this.savedAddressId) {
            shippingAddressId = this.savedAddressId;
        } else if (this.verifiedShippingAddressId) {
            shippingAddressId = this.verifiedShippingAddressId;
        } else if (guestToRetailAddressId) {
            shippingAddressId = guestToRetailAddressId;
        }
        const discountPercentage = this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0
            ? this.orderFormGroup.controls['shippingCostPercentage'].value : 0;
        const orderShipping: any = {
            deliveryPreferenceId: this.orderFormGroup.value.deliveryPreference,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingAddressId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) ?
                shippingAddressId : null,
            shortCode: this.shipMethod ? this.shipMethod.shortCode : '',
            preferredTime: null,
            notes: null,
            shipmentDate: null,
            shippingWaived: this.memberShippingDiscountOfferEligible ? true :
                ((+this.orginalShippingCost) - (+this.getOrderShippingCost())) === 0 ? false : true,
            shippingWaiverPercentage: this.memberShippingDiscountOfferEligible ? 100 :
                discountPercentage > 0 ? discountPercentage : null,
            distributionCenter: this.shipMethods.distributionCenterName
        };
        const shippingObj = this.shippingMethods.find((shipMethod: any) => shipMethod.shippingMethodId == this.orderFormGroup.value.shipMethodId);
        if (shippingObj && shippingObj.freeShippingEligible && shippingObj.promotionId) {
            const orderPromotionTrackingList = [{
                promotionID: shippingObj.promotionId
            }];
            orderShipping.orderPromotionTrackingList = orderPromotionTrackingList;
        }

        if (orderShipping.deliveryPreferenceId === ShippingType.PICKUP) {
            orderShipping.distributionCenter = (this.shipMethod.pickUpLocation.pickupCenterName) ? this.shipMethod.pickUpLocation.pickupCenterName : '';
        }
        orderShippings.push(orderShipping);
        return orderShippings;
    }
    /**
      * @returns payment method
      */
    private getPaymentMethodById(paymentMethodId: number): any {
        let paymentType: string;
        switch (paymentMethodId) {
            case this.paymentTypeEnum.Credit_Card:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;

            case this.paymentTypeEnum.Money_order:
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case this.paymentTypeEnum.Cash:
                paymentType = PaymentMethodTypes.Cash;
                break;
            case this.paymentTypeEnum.Ideal:
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case this.paymentTypeEnum.PayPal:
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case this.paymentTypeEnum.Cash_On_Delivery:
                paymentType = PaymentMethodTypes.Cash_On_Delivery;
                break;
            case this.paymentTypeEnum.Orange_Money:
                paymentType = PaymentMethodTypes.Orange_Money;
                break;
            case this.paymentTypeEnum.Bank_Transfer:
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case this.paymentTypeEnum.eCheck:
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case this.paymentTypeEnum.BanContact_MisterCash_and_Maestro:
                paymentType = PaymentMethodTypes.BanContact_MisterCash_and_Maestro;
                break;
            case this.paymentTypeEnum.MisterCash_and_Maestro:
                paymentType = PaymentMethodTypes.MisterCash_and_Maestro;
                break;
            case this.paymentTypeEnum.Single_Debit:
                paymentType = PaymentMethodTypes.Single_Debit;
                break;
            case this.paymentTypeEnum.Direct_Debit:
                paymentType = PaymentMethodTypes.Direct_Debit;
                break;
            case this.paymentTypeEnum.Pay_By_Link:
                paymentType = PaymentMethodTypes.Pay_By_Link;
                break;
            case this.paymentTypeEnum.Wire_Transfer:
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;

        }
        return paymentType;
    }

    /*
*/
    private getPaymentMethod(paymentMethod: string): any {
        let paymentType: PaymentMethodTypes;
        switch (paymentMethod) {
            case 'Credit_Card':
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case 'eCheck':
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case 'Money_Order':
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case 'Bank_Transfer':
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case 'Ideal':
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case 'PayPal':
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case 'Wire_Transfer':
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;

        }
        return paymentType;
    }

    getAddresses(): any {

        const addresses: any[] = [];
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            const pickupAddress = this.getPickUpAddress();
            if (pickupAddress) {
                pickupAddress.deliveryInstruction = pickupAddress && pickupAddress.instruction ? pickupAddress.instruction : '';
                pickupAddress.email = pickupAddress.email ? pickupAddress.email : null;
                addresses.push(pickupAddress);
            }
        }
        else {
            const shipAddress = this.getShippingAddress();
            if (shipAddress) {
                addresses.push(shipAddress);
            }
        }

        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            const pudoPickUpAddress = this.getPudoPickUpAddress(this.pudoShippingAddressInfo, this.pudoShippingMethod);
            if (pudoPickUpAddress) {
                pudoPickUpAddress.deliveryInstruction = pudoPickUpAddress && pudoPickUpAddress.instruction ? pudoPickUpAddress.instruction : '';
                pudoPickUpAddress.email = pudoPickUpAddress.email ? pudoPickUpAddress.email : null;
                addresses.push(pudoPickUpAddress);
            }

        }
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {

            const pudoDropAddress = this.getPudoDropAddress(this.pudoShippingAddressInfo, this.shipMethod);
            if (pudoDropAddress) {
                pudoDropAddress.deliveryInstruction = pudoDropAddress && pudoDropAddress.instruction ? pudoDropAddress.instruction : '';
                pudoDropAddress.email = pudoDropAddress.email ? pudoDropAddress.email : null;
                addresses.push(pudoDropAddress);
            }

        }
        if ((this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()) || (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString())) {
            const billingAddress = this.getBillingAddress();
            if (billingAddress) {
                addresses.push(billingAddress);
            }
        }
        return addresses;
    }

    getPudoPickUpAddress(address: Address, shippingMethod: ShippingMethod): any {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled &&
            this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {

            const pudoCollectionPoint = this.selectedPudoCollectionPoint;
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoAddress.stateCode);
            const pudoPickUpAddress: any = {
                addressLine1: pudoCollectionPoint.street ? (pudoCollectionPoint.street + ' ' + pudoCollectionPoint.houseNumber) : '',
                addressLine2: pudoCollectionPoint.address2 ? pudoCollectionPoint.address2 : '',
                addressLine3: pudoCollectionPoint.address3 ? pudoCollectionPoint.address3 : '',
                addressLine4: null,
                city: pudoCollectionPoint.city,
                state: pudoCollectionPoint.state,
                stateCode: address.stateCode,
                countryCode: address.countryCode,
                country: countryObj.name,
                county: null,
                zip: pudoCollectionPoint.zipCode,
                company: null,
                name: pudoCollectionPoint.name,
                pickupCenterName: pudoCollectionPoint.name,
                instruction: '',
                optionName: DelivaryOptionType.Dropship,
                pickUpCenterId: shippingMethod && shippingMethod.pickUpLocation &&
                    shippingMethod.pickUpLocation.pickUpCenterId ? shippingMethod.pickUpLocation.pickUpCenterId : null,
                latitude: pudoCollectionPoint.geoPoint.latitude + '',
                longitude: pudoCollectionPoint.geoPoint.longitude + '',
                countryId: countryObj.countryId,
                stateId: stateObj.id,
                businessInformation: [],
                residential: false,
                validAddress: false,
                addressType: AddressType.PUDO,
                postalCode: pudoCollectionPoint.zipCode,
                pudoNetwork: pudoCollectionPoint.network,
                pudoExternalId: pudoCollectionPoint.externalId,
                pudoIdentifier: pudoCollectionPoint.identifier
            };
            return pudoPickUpAddress;
        }
    }

    getPudoDropAddress(address: Address, shippingMethod: ShippingMethod): any {
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled &&
            this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            const pudoCollectionPoint = this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint : this.dropShipAddress ? this.dropShipAddress : address;

            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoAddress.stateCode);
            const pudoDropShipAddress: any = {
                addressLine1: this.selectedPudoCollectionPoint ? (pudoCollectionPoint.street + ' ' + pudoCollectionPoint.houseNumber) :
                    pudoCollectionPoint.addressLine1 ? pudoCollectionPoint.addressLine1 : address.addressLine1,
                addressLine2: this.selectedPudoCollectionPoint ? pudoCollectionPoint.address2 : pudoCollectionPoint.addressLine2,
                addressLine3: this.selectedPudoCollectionPoint ? pudoCollectionPoint.address3 : pudoCollectionPoint.addressLine3,
                addressLine4: null,
                city: pudoCollectionPoint.city || address.city,
                state: pudoCollectionPoint.state || address.state,
                stateCode: address.stateCode || pudoCollectionPoint.stateCode,
                countryCode: address.countryCode,
                country: countryObj.name,
                county: null,
                zip: pudoCollectionPoint.zipCode || address.zipCode,
                company: null,
                firstName: address.firstName,
                lastName: address.lastName,
                phoneNumer: address.phoneNumber,
                email: address.email,
                name: pudoCollectionPoint.name || address.name,
                instruction: '',
                optionName: DelivaryOptionType.Dropship,
                pickUpCenterId: shippingMethod && shippingMethod.pickUpLocation &&
                    shippingMethod.pickUpLocation.pickUpCenterId ? shippingMethod.pickUpLocation.pickUpCenterId : null,
                latitude: this.selectedPudoCollectionPoint ? pudoCollectionPoint.geoPoint.latitude + '' : '',
                longitude: this.selectedPudoCollectionPoint ? pudoCollectionPoint.geoPoint.longitude + '' : '',
                countryId: countryObj.countryId,
                stateId: stateObj.id,
                businessInformation: [],
                residential: false,
                validAddress: false,
                addressType: AddressType.PUDO,
                postalCode: pudoCollectionPoint.postalCode || address.postalCode,
                pudoNetwork: pudoCollectionPoint.network,
                pudoExternalId: pudoCollectionPoint.externalId,
                pudoIdentifier: pudoCollectionPoint.identifier
            };
            return pudoDropShipAddress;
        }
    }



    calculateOrderTotal(): number {
        let totalCost = 0;
        let itemsTotalTax = 0;
        let calculateVatTax = true;
        if (this.orderSession) {
            this.taxableAmount = this.orderSession.taxableAmount;
        }
        for (let i = 0; i < this.products.length; i++) {
            if (!this.countryTaxInclusive) {
                itemsTotalTax += this.products[i].tax;
            }
        }
        if (this.memberInfo && this.memberInfo.vatRegistered
            && this.countryTaxInclusive) {
            if ((this.appConfig && this.appConfig.enableVatItemizationForNonVat) || this.appConfig.displayTaxInclusivePrice) {
                if (this.appConfig && this.appConfig.calculateVatForVatRegisterUser) {
                    calculateVatTax = true;
                } else {
                    calculateVatTax = false;
                }
            }
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) +
                (this.memberShippingDiscountOfferEligible ? 0 : this.getShippingCostForOrderSummary() || 0) + (calculateVatTax ? this.taxableAmount || 0 : 0);
        } else {
            if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
                calculateVatTax = this.memberInfo && (!this.memberInfo.vatRegistered && this.memberInfo.memberTypeId === MemberTypeId.DISTRIBUTOR) ? true : false;
            }
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) +
                (this.memberShippingDiscountOfferEligible ? 0 : this.getShippingCostForOrderSummary() || 0) +
                ((this.countryTaxInclusive === false || isCalculateTaxExclusivePrice) ? (calculateVatTax ? this.taxableAmount || 0 : 0) : 0);
        }
        if (this.isBWPEnabled && this.isBWPEnabledProduct && this.storeInfo && this.storeInfo.bwpEnabled) {
            this.orderLevelDiscount = Number((this.orderLevelDiscount).toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
            totalCost = totalCost - this.orderLevelDiscount;
        }
        if (this.storeInfo) {
            totalCost = Number(totalCost.toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        this.itemTotal = totalCost - this.itemShippingCost;
        return totalCost;
    }



    /**
   * @param  {any} shippingInfo
   * @returns void
   */
    calculateOrderTax(): void {
        this.taxCalculationStatus = true;
        this.orderTaxResponse = null;
        if (this.storeInfo && this.products && this.products.length > 0 && this.orderFormGroup.value.shipMethodId) {
            const taxRequest: TaxRequest = this.prepareTaxRequest();
            if (taxRequest && taxRequest.fromAddress && taxRequest.toAddress) {
                this._orderService.calculateOrderTax(taxRequest)
                    .subscribe((taxResponse: any) => {
                        if (taxResponse && taxResponse.success) {
                            this.isTaxMetaDataAvailable = taxResponse.taxMetaData ? true : false;
                            if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
                                taxResponse.cart.totalTax = this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, this.storeInfo);
                                this.orderTaxResponse = taxResponse;
                                this.taxableAmount = taxResponse.cart.totalTax;
                                this.retailDeliveryFee = taxResponse.cart.retailDeliveryFee ? taxResponse.cart.retailDeliveryFee : 0;
                                this.isCalculateTax = this.appConfig.displayTaxInclusivePrice ? false : true;
                                if (this.orderTaxResponse && this.orderTaxResponse.taxMetaData
                                    && this.orderTaxResponse.taxMetaData.orderTaxCharges
                                    && this.orderTaxResponse.taxMetaData.orderTaxCharges.length > 0) {
                                    const gst = this.orderTaxResponse.taxMetaData
                                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.GST_TAX);
                                    const pst = this.orderTaxResponse.taxMetaData
                                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.PST_TAX);
                                    this.gstTax = gst ? gst.taxAmount : 0;
                                    this.pstTax = pst ? pst.taxAmount : 0;
                                    if (this.countryTaxInclusive) {
                                        const shippingLineItem = this.orderTaxResponse.taxMetaData
                                            .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.NOR && tax.lineNo === 0);
                                        if (shippingLineItem && this.orderFormGroup.controls['shippingCostSelector'].value != this.selectEnum.secondOption.toString() && this.orderFormGroup.controls['shippingCostSelector'].value != this.selectEnum.thirdOption.toString()) {
                                           // this.shippingTax = shippingLineItem.taxAmount;
                                        }
                                    }

                                }
                            }

                            setTimeout(() => {
                                this.taxCalculationStatus = false;
                            }, 500);
                            const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
                            const taxCalculated = this.appConfig.displayTaxInclusivePrice ? false : true;
                            this.displayPriceConfig = this._memberDisplayPriceConfigService
                                .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this.storeInfo.taxInclusive,
                                    this.memberInfo, taxCalculated, this.countryTaxInclusive, this.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                        }
                    },
                        (error: any) => {
                            if (error) {
                                const taxResponse = error;
                                if (taxResponse && taxResponse.validations && taxResponse.validations.length > 0) {
                                    if ((taxResponse.validations.map(validation => validation.name).indexOf(CommonConstant.Order_Tax)) > -1) {
                                        const notification: any = this._translatePipe.get('order.Tax cannot be calculated now. Please try again later.');
                                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                    }
                                    else {
                                        const notification: any = this._translatePipe.get('order.' + taxResponse.validations[0].message);
                                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                    }
                                }
                            }
                        });
            }

        }
    }

    private prepareTaxRequest(): TaxRequest {
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status*/
        const memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        const countryCode = this.countries.find((x: any) => x.isocodeThree === this.countryCode);
        this.countryID = countryCode.countryId;
        const taxRequest: TaxRequest = {
            orderID: 0,
            memberID: this.memberInfo ? this.memberInfo.memberId : null,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                this.getPickUpAddress() : this.getShippingMethodWarehouseAddress(),
            toAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP)
                ? this.getPickUpAddress() : (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) ? this.getPodiCollectPointAddress() : this.getShippingAddress(),
            memberNumber: this.memberInfo ? this.memberInfo.fboId : null,
            orderNumber: 0,
            storeID: this.storeInfo.id,
            priceTierName: this.getPriceTier(),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.selectedIsoCountryCode.toLowerCase(),
            deliveryTypeId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                ShippingType.PICKUP : ShippingType.DELIVERY,
            orderSource: 'CUSTOMER SERVICE',
            orderTypeId: 2,
            conversionRate: 1,
            memberLevelId: memberTitleId,
            wholesaleQualified: this.memberInfo ? this.memberInfo.wholeSaleQualified : null,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            isDiscountedShipping: this.orderFormGroup.value.isShippingDiscountApplied,
            memberType: MemberTypeEnum[this.memberTypeId]
        };
        return taxRequest;
    }
    /**
      * @returns TaxCart
      */
    private mapCartToTaxCart(): any {
        const taxCart: any = {
            shippingTax: 0,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingCost: this.getTaxExclusiveShippingCost(),
            importFeeValue: this.importFeeValue || 0,
            importFeeEnabled: this.importFeeEnabled,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    }

    /**
     * @returns CartItems
     */
    private mapItemstoTaxItems(): any[] {
        // PS2020-496 PR applicable tax issue
        const address = (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod && this.shipMethod.pickUpLocation) ?
            this.getPickUpAddress() : this.getShippingAddress();
        /*
             TASK : HOTFIX PS2020-387
             TO:DO : taxablePrice price coloumn mapping should be based on Provider. We will adopt this changes as part of R7 release
         */
        const taxItems: any[] = [];
        if (this.products && this.products.length > 0) {
            let itemLineNumber = 0;
            if (address && address.countryId && this.countries && this.countries.length > 0) {
                const country = this.countries.find(x => x.countryId === address.countryId);
                this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
            }
            this.products.forEach((x: any) => {
                let taxablePrice: any;
                let paidPrice: any;
                if (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) {
                    taxablePrice = x.catalogPrice;
                    paidPrice = x.applicablePrice;
                } else {
                    taxablePrice = ((this.checkoutConfig.catalogPriceAsTaxablePrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.catalogPrice : x.retailPrice);
                    paidPrice = ((this.checkoutConfig.applicablePriceAspaidPrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.applicablePrice : x.retailPrice);
                }
                const bondedProduct = x.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && x.metaKeyWords === '1');
                const taxItem: any = {
                    lineNumber: ++itemLineNumber,
                    itemNumber: x.itemNumber,
                    taxablePrice: this.getTaxablePrice(taxablePrice, x),
                    quantity: +x.quantity,
                    taxCode: null,
                    description: '',//x.shortDescription,
                    taxInclusive: this.countryTaxInclusive ? true : false,
                    resale: false,
                    resalePrice: 0,
                    taxBreakDown: x.taxBreakDown,
                    productIdentifier: null,
                    retailPrice: x.retailPrice,
                    paidPrice: this.getPaidPrice(paidPrice, x),
                    wholeSalePrice: x.wholesalePrice,
                    salesTax: 0,
                    revisionNumber: x.revisionNumber,
                    itemWeight: x.shipping && x.shipping.weight ? x.shipping.weight : 0,
                    importedMeasurementUnit: x.importedMeasurementUnit,
                    unitTaxExclusiveRetailPrice: x.baseRetailPrice,
                    computedTaxInclusivePrice: x.computedTaxInclusivePrice,
                    comboBOMEnabled: x.display ? (x.display.comboBOMEnabled ? x.display.comboBOMEnabled : false) : false,
                    computedComboTaxTotals: x.computedComboTaxTotals && x.computedComboTaxTotals.length > 0 ? x.computedComboTaxTotals : [],
                    bondedProduct: (bondedProduct && this.isBWPEnabled) ? true : false
                };
                taxItems.push(taxItem);
            });
        }

        return taxItems;
    }
    getTaxablePrice(taxablePrice: number, item: any): number {
        const enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.selectedIsoCountryCode);
        if (this.appConfig && this.appConfig.calculateNetUnitPrice
            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
            && this.memberInfo.transactionalOptin && !this.memberInfo.vatRegistered &&
            (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                ||(this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                && enableWHLSAL00ForAsstSupervisor))) {
            return this.calculateNetUnitPrice(item);
        } else if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
            && !enableWHLSAL00ForAsstSupervisor) {
            return item.catalogPrice;
        } else if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === PriceTier.NEWDST || item.priceTierName === PriceTier.WHLSAL)) {
            return item.applicablePrice;
        } else {
            return taxablePrice;
        }

    }

    getPaidPrice(paidPrice: number, item: any): number {
        if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === PriceTier.NEWDST || item.priceTierName === PriceTier.WHLSAL)) {
            return item.applicablePrice;
        } else {
            return paidPrice;
        }
    }

    getPriceTier() {
        let priceTierName = '';
        if (this.products && this.products.length > 0) {
            priceTierName = this.products[0].priceTierName;
        }
        return priceTierName;
    }

    addNewProductItem(items, index, product) {
        const itemValue = product.itemNumber + ' - ' + product.name;
        items.controls[index].controls['itemNumber'].setValue(itemValue);
        const itemImage = (product.imageModelList && product.imageModelList.length > 0)
            ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
        const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
        const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
        const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
        items.controls[index].controls['productImage'].setValue(imageUrl);
        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
        items.controls[index].controls['productId'].setValue(product.id);
        items.controls[index].controls['productItem'].setValue(product);
        items.controls[index].controls['disableIncrement'].setValue(false);
        items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
        items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
        return items;
    }

    setFocusbyID(id) {
        setTimeout(() => {
            const element = document.getElementById(id) as HTMLInputElement;
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    }
    moveToItemLevelSearchBlock(event: any) {
        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
            this.itemLevelSearch.nativeElement.focus();
        }
    }

    /**
     * @description item number search in table
     * @date 2019-09-25
     * @param {*} event
     * @memberof OrderPromotionComponent
     */
    itemLevelSearchEvent(event: any) {
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe((products) => {
                const responseproducts = products;
                if (responseproducts.length > 0) {
                    const product = responseproducts[0];
                    const isStockAvailable = this.stockAvailable(product);
                    if (isStockAvailable) {
                        let items: any = this.orderFormGroup.get('items');
                        if (items && items.length >= 0) {
                            const sameProductIndex = items.controls.findIndex(item =>
                                item.controls['productNumber'].value === product.itemNumber);
                            if (sameProductIndex >= 0) {
                                items.controls[sameProductIndex].controls['quantity']
                                    .setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                this.setFocusbyID('quantity-' + (sameProductIndex));
                            } else {
                                this.addItemNumber();
                                const index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(1);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                items = this.addNewProductItem(items, index, product);
                                this.setFocusbyID('quantity-' + (items.length - 1));
                            }
                        }
                        /*if(this.isPromotionEngineEnabled) {
                            this.getPromotionProducts();
                        }*/
                        const isDepositFeeProductEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                        if (isDepositFeeProductEnabled) {
                            this.getDepositFeeProduct(product);
                        }
                        this.updateTotalsAndShipMethod(false);

                        //New logic to bind promtoion product from promotion engine
                        const freeProductsInfo = this.validatePromotionCriteria(items);
                        const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                        //const productIds: number[] = freeProductsInfo.map((product) => product = product.productId);
                        if (productIds && productIds.length) {
                            this.addPromotionEngineProducts(productIds, freeProductsInfo);
                        } else {
                            this.updateTotalsAndShipMethod();
                        }
                        if (this.orderFormGroup.controls['orderType'].value === OrderType.POS
                            || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                            this.deliveryPreferenceOnChange();
                        }
                    } else {
                        this._commonService.createNotification('', 'Out of stock - '
                            + (product.name || ''), NotificationType.ERROR);
                        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                            this.itemLevelSearch.nativeElement.focus();
                        }
                        this.taxCalculationStatus = false;
                    }
                } else {
                    if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                        this.itemLevelSearch.nativeElement.focus();
                    }
                    const notification: any = this._translatePipe.get('order.Invalid Item Number');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                this.itemLevelSearch.nativeElement.value = '';
            });
        }
    }

    getDepositFeeProduct(searchProduct: Product, loadProducts?: boolean) {
        let depositFeeProduct: Product = null;
        const memberTitleId = this.memberInfo && this.memberInfo.memberTitleId ? this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId) : MemberLevel.RETAIL;
        const purchaseFlowType = (this.memberTypeId === MemberTypeEnum.GUEST || this.memberTypeId === MemberTypeEnum.RETAIL) ?
            PurchaseFlows.RETAIL : this.getPurchaseFlowType();
        const productAssociation = this.productAssociationInfo.find(x => x.productId === searchProduct.id);
        if (productAssociation) {
            depositFeeProduct = this.depsoitFeeProductsInfo.find(x => x.id === productAssociation.depositFeeProductId);
            if (depositFeeProduct) {
                depositFeeProduct.productQuantity = 1;
                if (!loadProducts) {
                    this.onItemSelect(depositFeeProduct);
                }
            }
        } else {
            const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
                ? this.memberInfo.wholeSaleQualified : false;
            const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
            const taxInclusive = this.storeInfo && this.storeInfo.taxInclusive ? this.storeInfo.taxInclusive : this.orderSession && this.orderSession.storeInfo && this.orderSession.storeInfo.taxInclusive ? this.orderSession.storeInfo.taxInclusive : false;
            this._customerService.getRelatedProducts(this.storeId, searchProduct.id, 2, memberTitleId, this.countryCode, this.storeDefaultLanguage, purchaseFlowType, taxInclusive, wholesaleQualified, optin)
                .subscribe(response => {
                    if (response && response.length) {
                        depositFeeProduct = response[0];
                        const depositFeeProductInfo = this.depsoitFeeProductsInfo.find(x => x.id === depositFeeProduct.id);
                        this.productAssociationInfo.push({
                            productId: searchProduct.id,
                            depositFeeProductId: depositFeeProduct.id
                        });

                        if (!depositFeeProductInfo) {
                            this.depsoitFeeProductsInfo.push(depositFeeProduct);
                        }
                        if (!loadProducts) {
                            this.onItemSelect(depositFeeProduct);
                        }
                    }
                });
        }
    }

    getPurchaseFlowType(): any {
        let fpc5PercentEnabled: boolean = false;
        const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        let memberTitleId = this.memberInfo && this.memberInfo.memberLevelId
            ? this.memberInfo.memberLevelId : this.memberInfo.memberTitleId;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        return this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
    }

    /**
     * @description Check stock available or not
     * @date 2019-09-25
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    stockAvailable(product: Product): boolean {
        return (product.manageStock && product.stockQuantity > 0) || (product.stockAvailable && !product.manageStock);
    }
    /**
     * @description auto complete search
     * @date 2019-09-25
     * @memberof OrderPromotionComponent
     */
    onItemSelect(depositFeeProduct?: Product) {
        const searchProduct = depositFeeProduct ? depositFeeProduct : this.orderFormGroup.controls['itemSearch'].value;
        if (searchProduct && searchProduct.id) {
            const isStockAvailable = this.stockAvailable(searchProduct);
            if (isStockAvailable) {
                let items: any = this.orderFormGroup.get('items');
                if (items && items.length >= 0) {
                    this.taxCalculationStatus = true;
                    const sameProductIndex = items.controls.findIndex(item => item.controls['productNumber'].value === searchProduct.itemNumber);
                    if (sameProductIndex >= 0) {
                        items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                        this.orderFormGroup.controls['itemSearch'].setValue('');
                        this.setFocusbyID('quantity-' + (sameProductIndex));
                        items.controls[sameProductIndex].controls['disableDecrement'].setValue(false);
                    } else {
                        this.addItemNumber();
                        const index = (items.length - 1);

                        items.controls[index].controls['quantity'].setValidators([Validators.required]);
                        if (!items.controls[index].controls['quantity'].value) {
                            items.controls[index].controls['quantity'].setValue(1);
                        }
                        items.controls[index].controls['quantity'].updateValueAndValidity();
                        if (this.orderFormGroup.controls['itemSearch'].value) {
                            const typHeadItem = this.orderFormGroup.controls['itemSearch'].value;
                            this.orderFormGroup.controls['itemSearch'].setValue('');
                            items = this.addNewProductItem(items, index, typHeadItem);
                        } else {
                            items = this.addNewProductItem(items, index, searchProduct);
                        }
                        this.isFocused = true;
                        this.setFocusbyID('quantity-' + (items.length - 1));
                    }
                }
                /*if(this.isPromotionEngineEnabled) {
                    this.getPromotionProducts();
                }*/
                const isDepositFeeProductEnabled = searchProduct.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                if (isDepositFeeProductEnabled) {
                    this.getDepositFeeProduct(searchProduct);
                }
                this.updateTotalsAndShipMethod(false);

                //New logic to bind promtoion product from promotion engine
                const freeProductsInfo = this.validatePromotionCriteria(items);
                const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
                //const productIds: number[] = freeProductsInfo.map((product) => product = product.productId);
                if (productIds && productIds.length) {
                    this.addPromotionEngineProducts(productIds, freeProductsInfo);
                } else {
                    this.updateTotalsAndShipMethod();
                }
                if (this.orderFormGroup.controls['orderType'].value === OrderType.POS
                    || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.deliveryPreferenceOnChange();
                }

            } else {
                this._commonService.createNotification('', 'Out of stock - '
                    + (this.orderFormGroup.controls['itemSearch'].value.name || ''), NotificationType.ERROR);
                this.orderFormGroup.controls['itemSearch'].setValue('');
                setTimeout(() => {
                    if (this.seachItemElement && this.seachItemElement.nativeElement) {
                        this.seachItemElement.nativeElement.focus();
                    }
                }, 500);
            }
        }
    }

    shippingAddressSelectionChange() {
        this.shippingAddressInfo = this.address && this.address.isSavedAddress ? this.address : null;
        this.address = this.address && this.address.isSavedAddress ? this.address : null;
        this.getShipMethods();

    }

    /**
     * get shipping cost in percentage
     */
    getShippingCostInPercentage() {
        let shippingOriginalCost = this.orginalShippingCost;
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                ? this.orderFormGroup.controls['originalShippingCost'].value
                : this.orderFormGroup.controls['originalShippingCost'].value - this.orderFormGroup.controls['originalShippingTax'].value;
            this.shippingTax = this.orderFormGroup.controls['originalShippingTax'].value;
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()) {
            const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;

            shippingOriginalCost = this.memberInfo && this.memberInfo.vatRegistered ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            const shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            } else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.getShippingCost();
    }
    /**
     * on chnage on shipping charge selector
     */
    shippingCostChange(isRetailFreeShipping?) {
        const shippingObj = this.shippingMethods.find((shipMethod: any) => shipMethod.shippingMethodId == this.orderFormGroup.value.shipMethodId);
        if (this.isOrderMeetsRFSCriteria() && shippingObj && shippingObj.shippingMethod && shippingObj.shippingMethod.toLowerCase() == RetailFreeShippingConstants.FREE_SHIPPING.toLowerCase()) {
            this.orderFormGroup.get('shippingCostSelector').setValue(this.selectEnum.firstOption.toString());
            const notification: any = this._translatePipe.get('order.Free shipping is already available for this order, No more discounts allowed');
            isRetailFreeShipping ? this._commonService.createNotification('', notification.value, NotificationType.ERROR) : '';
        } else if (shippingObj && shippingObj.freeShippingEligible && (this.orderFormGroup.controls['shippingCostSelector'].value !== this.selectEnum.firstOption.toString())) {
            this.orderFormGroup.get('shippingCostSelector').setValue(this.selectEnum.firstOption.toString());
            const notification: any = this._translatePipe.get('order.Free shipping is already available for this order, No more discounts allowed');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }

        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            if (this.showSelectedShipMethod) {
                this.orderFormGroup.controls['originalShippingCost'].setValue(this._currencyPipe.getFormatedCurrency(this.orginalShippingCost || 0, this.storeInfo));  
                this.orderFormGroup.controls['originalShippingTax'].setValue(this.originalShippingTax);
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            } else {
                this.orderFormGroup.controls['originalShippingCost'].setValue(0);
                this.orderFormGroup.controls['originalShippingTax'].setValue(0);
            }
            this.orderFormGroup.controls['originalShippingCost'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(false);
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
        } else {
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            let shippingOriginalCost = this.orginalShippingCost;
            const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            shippingOriginalCost = this.memberInfo && this.memberInfo.vatRegistered ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            const shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            } else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.calculateOrderTax();
    }

    shippingPercentChange(event: any) {
        if (event.keyCode !== 8) {
            const value: any = (this.orderFormGroup.controls['shippingCostPercentage'].value
                ? this.orderFormGroup.controls['shippingCostPercentage'].value : '') + (event.key ? event.key : '');
            const pattern = /^(?:100|[1-9]?[0-9])$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }
    allowOnlyNumbers(event: any) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            const value: any = (event.key ? event.key : '');
            const pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }

    /**
     * Save Shipping Address
     */
    saveShippingAddress(address: Address) {
        address = this.mapVerifiedAddressToFormFields(address);
        const guestToRetailUser: Member = this.guestToRetailMember;
        if ((this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) || guestToRetailUser) {
            this.saveAddress(address);
        } else if (this.address && this.address.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === address.countryId);
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.useNewShippingAddress(address);
        setTimeout(function () {
            const addtoSavedAddressesElement = document.getElementById('addtoSavedAddresses');
            if (addtoSavedAddressesElement) {
                addtoSavedAddressesElement.focus();
            }
        }, 200);
    }
    savePudoShippingAddress(address: Address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        } else if (this.pudoAddress && this.pudoAddress.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === address.countryId);
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.pudoShippingAddressInfo = address;
        this.pudoAddress = address;
        this.pudoAddressSubmitted = true;

    }

    /**
     * @description save billing address
     * @date 2018-11-19
     * @param {Address} address
     * @memberof OrderPromotionComponent
     */
    saveBillingAddress(address: Address) {
        if (address) {
            this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
            if (this.saveEcheckFormBtn) {
                this.saveEcheckFormBtn.nativeElement.click();
            }
        }
    }

    // *************************payvision payment section*******************************/
    /**
     * @description Load Member Saved Cards
     * @date 2018-08-30
     * @memberof PaymentComponent
     */
    loadSavedCardsForMemberId(memberId: number, countryCode: string): void {
        let paymentStatus = this._cacheService.get(CacheKey.PaymentStatus);
        if (paymentStatus) {
            const newCardError: any = this._translatePipe.get('order.Payment gateway not responding');
            this._commonService.createNotification('', newCardError.value, NotificationType.ERROR);
            this._cacheService.remove(CacheKey.PaymentStatus);
        }
        const paymentInstrumentId: number = this._cacheService.get(CacheKey.PaymentInstrumentId);
        this._payvisionService.getSavedPayvisonCards(memberId, countryCode,
            paymentInstrumentId).subscribe((savedCardResponse: PayvisionSavedCardResponse) => {
                if (savedCardResponse && savedCardResponse.savedCards && savedCardResponse.savedCards.length > 0) {
                    this.paymentComponentSettings.savedCards = savedCardResponse.savedCards;
                    this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                        card.notes = card.defaultCard ? PaymentConstants.default : '';
                    });
                    if (paymentInstrumentId) {
                        const selectedCard = this.paymentComponentSettings.savedCards.find(x => x.id === paymentInstrumentId);
                        if (selectedCard) {
                            const indexPostion = this.paymentComponentSettings.savedCards.findIndex(x => x.id === paymentInstrumentId);
                            this.paymentComponentSettings.savedCards.splice(indexPostion, 1);
                            this.paymentComponentSettings.savedCards.unshift(selectedCard);
                            this.selectedpayvisionCardInfo = selectedCard;
                        }
                        this.orderFormGroup.controls['paymentInstrumentId'].setValue(paymentInstrumentId);
                        this._cacheService.remove(CacheKey.PaymentInstrumentId);
                    } else {
                        if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length > 0) {
                            const defaultCard = this.paymentComponentSettings.savedCards.find(card => card.expired === false && card.defaultCard === true);
                            if (defaultCard) {
                                this.orderFormGroup.controls['paymentInstrumentId'].setValue(defaultCard.id);
                                this.selectSavedCard(defaultCard);
                            }
                            else {
                                let isDefaultCard = false;
                                let isCardAdded = false;
                                this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                                    if (card.expired === false && isDefaultCard === false) {
                                        isDefaultCard = true;
                                        isCardAdded = true;
                                        this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                                        this.selectSavedCard(card);
                                    }
                                });
                                if (!isCardAdded) {
                                    this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                                    this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                                }
                            }
                        } else {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
                            this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                        }
                    }
                } else {
                    this.paymentComponentSettings.savedCards = [];
                }
                this.getPaymentMethodsByStore();
            }, (error: Response) => {
                this.paymentComponentSettings.isAddNewCard = false;
            });
    }
    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    getImagePath(cardType: any): string {
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    this.paymentComponentSettings.cardTypeImage = null;
                    break;
            }
        }
        return this.paymentComponentSettings.cardTypeImage;
    }

    /**
     * On change of card
     */
    selectSavedCard(cardDetails: any, isNewCard?: boolean) {

        this._cacheService.set(CacheKey.IsRefreshed, true);
        this.addNewCardClicked = false;
        this.mapBillingAddress();
        this.mapShippingAddress()
        if (isNewCard) {
            if (this.shippingAddressChanged) {
                this.showVerifyAddressMessage();
                return;
            }
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
                this._enrollmentMessageService.setSubmitGuestForm(true);
            }
            if (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
                this._enrollmentMessageService.setSubmitPersonalInfoForm(true);
            }
            this.addOrderInfoToSession();
            if (this.isWorldpayPayment) {
                this.showWorldpayXml = true;
                this.showWorldPayXMLPopup.open();
            } else if (this.isAdyenPayment) {
                this.showAdyenPayment = true;
                this.showAdyenPaymentPopup.open();
            } else if (this.isNIPayment) {
                this.showNIPayment = true;
                this.showNIPopup.open();
            } else if (this.isNexioPayment) {
                this.showNexioPayment = true;
                this.showNexioPopup.open();
            } else {
                this.addNewpayvisionCard = true;
                this.payvisionPayment.open();
            }
        } else {
            this.selectedpayvisionCardInfo = cardDetails;
            this.addNewpayvisionCard = false;
            this.showWorldpayXml = false;
            this.showNIPayment = false;
            this.showAdyenPayment = false;
        }

    }

    showVerifyAddressMessage(): void {
        const verifyAddressError: any = this._translatePipe.get('order.Shipping Address must be verified. Please click on VERIFY ADDRESS');
        this._commonService.createNotification('', verifyAddressError.value, NotificationType.ERROR);
    }

    addOrderInfoToSession() {
        sessionStorage.removeItem(CacheKey.OrderInfo);
        const formValues = this.orderFormGroup.value;
        const pudoformvalues = this.pudoLocationSearchForm.value;
        const OrderInfo = {
            products: this.products,
            countryId: formValues.countryId,
            deliveryPreference: formValues.deliveryPreference,
            memberInfo: formValues.memberInfo,
            orderType: formValues.orderType,
            paymentSelector: formValues.paymentSelector,
            shippingAddressId: this.shippingAddressInfo && this.shippingAddressInfo.id ? this.shippingAddressInfo.id : 0,
            shippingAddressInfo: this.shippingAddressInfo ? this.shippingAddressInfo : this.pudoAddress,
            shipMethodId: formValues.shipMethodId,
            shipMethods: this.shipMethods,
            shippingTax: this.shippingTax,
            shippingCost: this.memberShippingDiscountOfferEligible ? 0 : formValues.shippingCost,
            shippingCostPercentage: this.memberShippingDiscountOfferEligible ? 0 : formValues.shippingCostPercentage,
            shippingCostSelector: formValues.shippingCostSelector,
            verifiedShippingAddressId: this.verifiedShippingAddressId,
            shippingCostValue: this.memberShippingDiscountOfferEligible ? 0 : this.shippingCost,
            orderFromLookup: this.orderFromLookup,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
            isSavedAddress: this.address ? this.address.isSavedAddress : null,
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            shoppingBagClicked: this.shoppingBagClicked ? true : false,
            memberCartSessionGuid: this.shoppingBagClicked && this.memberCart
                && this.memberCart.sessionGuid ? this.memberCart.sessionGuid :
                this.shoppingBagClicked && this.memberCartSessionGuid ? this.memberCartSessionGuid : null,
            personalInformation: this.personalInformation,
            retuningGuestUser: this.retuningGuestUser,
            documents: this.agreementDocuments,
            language: this.orderFormGroup.value.language,
            mailingAddress: this.mailingAddress,
            rebindSponsorData: this.rebindSponsorData,
            sponsorInformation: this.sponsorInformation,
            memberCommunicationPreferences: this.memberCommunicationPreferences,
            liveFormAddress: this.liveFormAddress,
            mailAlreadyExist: this.mailAlreadyExist,
            isShippingDiscountApplied: this.orderFormGroup.value.isShippingDiscountApplied,
            minMaxPriceValidation: this.minMaxPriceValidation,
            businessEntityId: this.businessEntityId,
            selectPudoCollectionPoint: this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint : null,
            buildPudoLocationSearchForm: this.pudoLocationSearchForm.value,
            pudoShippingMethod: this.pudoShippingMethod ? this.pudoShippingMethod : null,
            pudoaddress: this.pudoAddress ? this.pudoAddress : null,
            buildPayByLinkForm: this.emailForm.value,
            languageCulture: this.orderFormGroup.value.orderType === this.orderType.REGULAR ? this.storeLanguageCultureName : this.languageCulture,
            isOverrideMinimumLimit: this.isOverrideMinimumLimit,
            taxCalculationStatus: this.taxCalculationStatus,
            orderTaxResponse: this.orderTaxResponse,
            storeInfo: this.storeInfo,
            appConfig: this.appConfig,
            countryTaxInclusive: this.countryTaxInclusive,
            taxableAmount: this.taxableAmount,
            importFeeValue: this.importFeeValue,
            originalShippingCost: formValues.originalShippingCost,
            pudoShippingAddressInfo: this.pudoShippingAddressInfo && this.shippingAddressInfoConfig.dropShipLocationsEnabled ? this.pudoShippingAddressInfo : null
        };
        sessionStorage.setItem(CacheKey.OrderInfo, JSON.stringify(OrderInfo));
    }
    /**
     *load procducts from session
     */
    loadproductsFromSession() {
        this.orderSession.products.forEach((product: any) => {
            this.addItemNumber();
            const items: any = this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                const index = (items.length - 1);
                if (product) {
                    const itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                    const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
                    const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);

                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['quantity'].setValue(product.quantity);
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (product.promoProduct) {
                        items.controls[index].controls['disableIncrement'].setValue(true);
                        items.controls[index].controls['disableDecrement'].setValue(true);
                        items.controls[index].controls['disableDelete'].setValue(true);
                    } else {
                        items.controls[index].controls['disableIncrement'].setValue(false);
                        items.controls[index].controls['disableDelete'].setValue(false);
                        if (product.quantity == 1) {
                            items.controls[index].controls['disableDecrement'].setValue(true);
                        } else {
                            items.controls[index].controls['disableDecrement'].setValue(false);
                        }
                    }
                    if (depositFeeEnabled) {
                        this.getDepositFeeProduct(product, true);
                    }
                }
            }
            if (this.orderSession) {
                this.orderFormGroup.patchValue({
                    shipMethodId: this.orderSession.shipMethodId,
                    originalShippingCost: this.orderSession.originalShippingCost,
                });
            }
        });
        this.updateTotalsAndShipMethod();
    }
    /**
     * map shipping Info with the shipping form
     */
    mapShippingAddressToShippingInfo() {
        const formAddress = this.orderSession.shippingAddressForm;
        const shippingAddressForm: any = this.orderFormGroup.get('shippingAddressForm');
        shippingAddressForm.controls[0].controls['name'].setValue(formAddress.name);
        shippingAddressForm.controls[0].controls['addressLine1'].setValue(formAddress.addressLine1);
        shippingAddressForm.controls[0].controls['addressLine2'].setValue(formAddress.addressLine2 || '');
        shippingAddressForm.controls[0].controls['addressLine3'].setValue(formAddress.addressLine3 || '');
        shippingAddressForm.controls[0].controls['addressLine4'].setValue(formAddress.addressLine4 || '');
        shippingAddressForm.controls[0].controls['city'].setValue(formAddress.city);
        shippingAddressForm.controls[0].controls['stateId'].setValue(formAddress.stateId);
        shippingAddressForm.controls[0].controls['countryId'].setValue(formAddress.countryId);
        shippingAddressForm.controls[0].controls['postalCode'].setValue(formAddress.postalCode);
        shippingAddressForm.controls[0].controls['phone'].setValue(formAddress.phone || '');
        shippingAddressForm.comtrols[0].controls['email'].setValue(formAddress.email || '');
        if (this.orderSession.shipVerificationProcessDone) {
            this.shippingAddressInfo = this.orderSession.shippingAddressInfo;
        }
    }

    /**
     * on close of payvision form popup
     */
    onPayvisionFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.addNewpayvisionCard = false;
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.payvisionPayment.close();
        this.paymentComponentSettings.payvisionFormLoaded = false;
        // To remove payvision Configurations
        this._commonService.unloadPayvisionWidget();
    }

    /**
* @returns any
*/
    private getOrderPaymentInfo(): any[] {
        const payments: any[] = [];
        let paymentMethodType: string;

        paymentMethodType = this.getPaymentMethodById(+this.orderFormGroup.controls['paymentSelector'].value);

        const orderPayment: any = {
            savePaymentMethod: this.savePaymentMethod && this.orderFormGroup.value.orderType !== this.orderType.NEW_GUEST_RETAIL
                ? this.savePaymentMethod : false,
            paymentAmount: this.calculateOrderTotal(),
            priceTier: this.getStorePriceTierName(),
            redirect: false,
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
            memberPaymentMethodId: +this.orderFormGroup.controls['paymentSelector'].value,
            authorizationCode: this.paymentComponentSettings && this.paymentComponentSettings.authorizationCode ? this.paymentComponentSettings.authorizationCode : null,
            paymentMode: paymentMethodType && paymentMethodType == PaymentMethodTypes.Pay_By_Link ? paymentMethodType : null,
            creditCardModel: {
                currencyCode: this.storeInfo.currencyCode,
                paymentToken: this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                    ? this.selectedpayvisionCardInfo.token : null,
                paymentMethodType: paymentMethodType,
                maskedCreditCardNumber: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.maskedCard : null,
                cardHolderName: this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                    ? this.selectedpayvisionCardInfo.nameOnTheCard : null,
                expMonth: this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                    ? this.selectedpayvisionCardInfo.expiryMonth : null,
                expYear: this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                    ? this.selectedpayvisionCardInfo.expiryYear : null
            },
            paymentECheck: (this.orderFormGroup.controls['paymentSelector'].value === this.paymentTypeEnum.eCheck) ? this.getAchInfo() : null
        };
        payments.push(orderPayment);
        return payments;
    }

    /**
         * get controls of items
         */
    getItemsControl() {
        return <FormArray>this.orderFormGroup.get('items');
    }
    /**
     * prevent +, -, e entering in shipping cost
     */

    keyEventShippingCost(event: any) {
        if (event.keyCode === 43 || event.keyCode === 45 || event.keyCode === 101) {
            event.preventDefault();
        }
    }
    /**
     * On paste event for member Info
     */
    onPasteEvent() {
        setTimeout(() => {
            this.orderFormGroup.controls['memberInfo'].setValue(this.orderFormGroup.controls['memberInfo'].value.trim());
        }, 0);
    }

    /**
* @description submit ach payment information
* @memberof ACHComponent
*/
    submitAchPaymentInformation(achPaymentInfo) {
        if (achPaymentInfo) {
            this.achPaymentInfo = achPaymentInfo;
            this.achToken = this.achPaymentInfo.personalCheckId;
            this.getSavedAchs();
            this.achPaymentPopup.close();
        }
    }
    /**
     * Get ACH payment
     */
    getSavedAchs(): void {
        const memberId = this.getUserMemberId();
        if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
            this._achService.getSavedEchecks(memberId, this.selectedIsoCountryCode, PaymentMethodTypeConstants.eCheck, this.achToken, true, SecType.Tel)
                .subscribe((response: PersonalAch[]) => {
                    if (response && response.length) {
                        this.paymentComponentSettings.savedAchs = response;
                        if (this.achRequest && this.achRequest.reusable) {
                            const selectedCard = this.paymentComponentSettings.savedAchs.find(x => x.id === this.achRequest.id);
                            if (selectedCard) {
                                const indexPostion = this.paymentComponentSettings.savedAchs
                                    .findIndex(x => x.id === this.achRequest.id);
                                this.paymentComponentSettings.savedAchs.splice(indexPostion, 1);
                                this.paymentComponentSettings.savedAchs.unshift(selectedCard);
                                this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[0].id);
                            } else {
                                const index = this.paymentComponentSettings.savedAchs.length - 1;
                                this.orderFormGroup.controls['paymentInstrumentId']
                                    .setValue(this.paymentComponentSettings.savedAchs[index].id);
                            }
                            const index = this.paymentComponentSettings.savedAchs.length - 1;
                            this.selectAch(this.paymentComponentSettings.savedAchs[index], false);
                        } else {
                            const index = this.paymentComponentSettings.savedAchs.length - 1;
                            this.selectAch(this.paymentComponentSettings.savedAchs[index], false);
                        }
                        this.savedAch = JSON.stringify(this.paymentComponentSettings.savedAchs);
                    }

                });
        }
    }

    /**
     * on change of payment method
     */
    onPaymentMethodChnage() {
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.selectedpayvisionCardInfo = null;
        this.echeckRequest = null;
        const options: any[] = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Bank_Transfer,
        this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Orange_Money, this.paymentTypeEnum.MisterCash_and_Maestro, this.paymentTypeEnum.BanContact_MisterCash_and_Maestro,
        this.paymentTypeEnum.Single_Debit, this.paymentTypeEnum.Direct_Debit, this.paymentTypeEnum.Pay_By_Link, this.paymentTypeEnum.Wire_Transfer];
        const paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        if (options.some(x => x == paymentSelectorValue)) {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([]);
        } else {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
        }
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (paymentSelectorValue === this.paymentTypeEnum.Credit_Card) {
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length > 0) {
                let isDefaultCard = false;
                let isCardAdded = false;
                this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                    if (card.expired === false && isDefaultCard === false) {
                        isDefaultCard = true;
                        isCardAdded = true;
                        this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                        this.selectSavedCard(card);
                    }
                });
                if (!isCardAdded) {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                    this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                }
            }
        }
        if (paymentSelectorValue === this.paymentTypeEnum.eCheck) {
            if (this.paymentComponentSettings.savedAchs && this.paymentComponentSettings.savedAchs.length > 0) {
                this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[0].id);
            }
        }
        if (paymentSelectorValue === this.paymentTypeEnum.Pay_By_Link) {
            const email = this.paymentComponentSettings && this.paymentComponentSettings.memberEmail ? this.paymentComponentSettings.memberEmail : this.liveFormPersonalInfo && this.liveFormPersonalInfo.email ? this.liveFormPersonalInfo.email : this.address && this.address.email ? this.address.email : null;
            if (email != null) {
                this.emailForm.controls['payByLinkEmail'].setValue(email);
            } else {
                this.emailForm.controls['payByLinkEmail'].setValue('');
            }
            this.emailForm.controls['payByLinkEmail'].updateValueAndValidity();
            if (this.emailForm.controls['payByLinkEmail'].value !== '') {
                this.isPayByLinkValid = true;
            } else {
                this.isPayByLinkValid = false;
            }
        }
        else {
            this.isPayByLinkValid = true;
        }
        if (this.appConfig.enablePaymentReferenceNumber) {
            this.paymentReferenceNumber.reset();
            this.paymentReferenceNumberFormValidations();
        }
    }

    /**
     * on change of Echeck
     */
    selectECheck(echeckDetails: PersonalCheck, isNewEcheck: boolean) {
        if (isNewEcheck) {
            this.buildEcheckForm();
            this.echeckSubmitted = false;
            this.eCheckValidationMessages = [];
            this.eCheckPaymentPopup.open();
            this.addNeweCheck = true;
        } else {
            this.selectedECheckInfo = echeckDetails;
            this.billingAddressInfo = echeckDetails.billingAddress;
            this.addNeweCheck = false;
            this.echeckRequest = {
                portalCsp: true,
                id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
                portalType: EcheckPortalTypes.CustomerCare,
                accountNumber: this.selectedECheckInfo.accountNumber,
                routingNumber: this.selectedECheckInfo.routingNumber,
                bankName: this.selectedECheckInfo.bankName,
                accountType: this.selectedECheckInfo.accountType,
                nameOnBankAccount: this.selectedECheckInfo.nameOnBankAccount,
                reusable: this.selectedECheckInfo.reusable,
                defaultECheck: this.selectedECheckInfo.defaultECheck,
                customerId: this.memberInfo.memberId,
                billingAddress: this.getBillingAddressForECheck(),
                billingAddressId: null,
                billingAddressRequired: true,
                customMessage: '',
                storeId: this.storeInfo.id,
                email: this.selectedECheckInfo.email,
                phone: this.selectedECheckInfo.phone
            };
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    }

    buildAchForm() {
        let phone = '';
        let email = '';
        let checkNumber = "";
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            } else {
                phone = this.memberInfo.phone;
            }
        }
        this.paymentAchForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            dlNumber: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            dlState: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            secType: ['', [Validators.required, CustomValidator.checkIfAccountSelected()],
            ],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]],
            checkNumber: [checkNumber, [Validators.required, CustomValidators.requiredNotEmpty]],
            reuse: [false],
            billingAddressId: [''],
        });
    }

    /**
    * on change of Ach
    */
    selectAch(achDetails: PersonalAch, isNewAch: boolean) {
        if (isNewAch) {
            this.buildAchForm();
            this.eCheckValidationMessages = [];
            this.addNewAchCard = true;
            this.achPaymentPopup.open();
        } else {
            this.selectedAchInfo = achDetails;
            this.billingAddressInfo = achDetails.billingAddress;
            this.addNewAchCard = false;
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    }
    /**
     * when Echeck form is closed
     */
    onECheckFormClose() {
        this.eCheckPaymentPopup.close();
        this.addNeweCheck = false;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedEcheckDdl && this.savedEcheckDdl.nativeElement) {
            this.savedEcheckDdl.nativeElement.focus();
        }
    }

    /**
     * buildEcheckForm
     */
    buildEcheckForm() {
        let phone = '';
        let email = '';
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            } else {
                phone = this.memberInfo.phone;
            }
        }
        this.echeckForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            accountType: ['', [Validators.required]],
            bankName: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            nameOnBankAccount: ['', [Validators.required, CustomValidators.requiredNotEmpty, Utils.alphaNumericCharacterValidation, Validators.maxLength(25)]],
            reuse: [false],
            billingAddressId: [''],
            customMessage: [''],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]]
        });
    }

    validateNewECheck() {
        this.echeckSubmitted = true;
        if (this.echeckForm.valid) {
            const echeckFormValue = this._commonService.trimObjectValues(this.echeckForm.value);
            if (echeckFormValue.phone) {
                const phoneCode = PhoneCodesConstants.phoneCodes.find(x => echeckFormValue.phone.toUpperCase().indexOf(x.name) > -1);
                if (phoneCode) {
                    echeckFormValue.phone = echeckFormValue.phone;
                } else {
                    if (this.phoneNumberFormat) {
                        echeckFormValue.phone = this._maskPipe.transform(echeckFormValue.phone, this.phoneNumberFormat);
                    } else {
                        echeckFormValue.phone = echeckFormValue.phone;
                    }
                }
            }
            const validateECheckReq: ValidateEcheckRequest = {
                accountNumber: echeckFormValue.accountNumber,
                accountType: echeckFormValue.accountType,
                bankName: echeckFormValue.bankName,
                routingNumber: echeckFormValue.routerNumber,
                addressOne: this.billingAddressInfo.addressLine1,
                addressTwo: this.billingAddressInfo.addressLine2,
                city: this.billingAddressInfo.city,
                country: this.paymentComponentSettings.isoTwoletterCountryCode,
                state: this.billingAddressInfo.stateCode,
                zip: this.billingAddressInfo.postalCode,
                email: echeckFormValue.email,
                phone: echeckFormValue.phone,
                paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.eCheck
            };
            this.validateECheck(validateECheckReq);
        }
    }

    validateECheck(validateECheckReq: ValidateEcheckRequest) {
        this.eCheckValidationMessages = [];
        this._echeckService.validateEcheck(validateECheckReq)
            .subscribe((response: ValidateEcheckResponse) => {
                if (response && response.success) {
                    this.savePersonalEcheck(validateECheckReq);
                } else if (response && !response.success && response.validations.length > 0) {
                    this.eCheckValidationMessages = response.validations.map(validation => validation.message);
                } else {
                    this.eCheckValidationMessages.push('Echeck validation failed.');
                }
            }, error => {
                this.eCheckValidationMessages.push('Echeck validation failed.');
            });
    }
    /**
     * save personal echecks
     */
    savePersonalEcheck(eCheckInfo: ValidateEcheckRequest) {
        this.echeckRequest = {
            portalCsp: true,
            id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
            portalType: EcheckPortalTypes.CustomerCare,
            accountNumber: eCheckInfo.accountNumber,
            routingNumber: eCheckInfo.routingNumber,
            bankName: eCheckInfo.bankName,
            accountType: eCheckInfo.accountType,
            nameOnBankAccount: this.addNeweCheck ? eCheckInfo.name : this.selectedECheckInfo.nameOnBankAccount,
            reusable: this.addNeweCheck ? this.echeckForm.value.reuse : this.selectedECheckInfo.reusable,
            defaultECheck: this.addNeweCheck ? false : this.selectedECheckInfo.defaultECheck,
            customerId: this.memberInfo.memberId,
            billingAddress: this.getBillingAddressForECheck(),
            billingAddressId: null,
            billingAddressRequired: true,
            customMessage: '',
            storeId: this.storeInfo.id,
            email: eCheckInfo.email,
            phone: eCheckInfo.phone
        };
        this._echeckService.savePersonalCheck(this.memberInfo.memberId, this.echeckRequest)
            .subscribe((response: any) => {
                if (response) {
                    this.eCheckTokenRes = response;
                    this.echeckSubmitted = false;
                    if (this.addNeweCheck) {
                        this.eCheckPaymentPopup.close();
                        const savedEChecks = JSON.parse(this.savedEChecks);
                        this.paymentComponentSettings.savedEChecks = savedEChecks;
                        if (this.echeckRequest) {
                            this.echeckRequest.id = +(atob(this.eCheckTokenRes));
                        }
                        if (this.echeckRequest && this.echeckRequest.reusable) {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(this.eCheckTokenRes)));
                            //this.getSavedEchecks();
                        } else {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(this.eCheckTokenRes)));
                        }
                    }
                    if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                        this.paymentFormBtn.nativeElement.focus();
                    }
                } else {
                    this.eCheckValidationMessages.push('Echeck validation failed.');
                }
            }, (error: any) => {
                this.eCheckValidationMessages.push('Echeck validation failed.');
            });
    }
    /**
     * map billing address for e-Check
     */
    getBillingAddressForECheck() {
        const stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        const billingAddress = {
            id: null,
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2 || '',
            addressLine3: this.billingAddressInfo.addressLine3 || '',
            addressLine4: this.billingAddressInfo.addressLine4 || '',
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            countryId: this.billingAddressInfo.countryId,
            city: this.billingAddressInfo.city,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            country: this.billingAddressInfo.countryCode,
            countryCode: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            firstName: this.billingAddressInfo.shipToName || this.billingAddressInfo.name,
            phone: ''
        };
        return billingAddress;
    }

    /**
     * map Echeck Info for payment
     */
    getEcheckInfo() {
        const eCheckInfo = {
            bankName: this.echeckRequest.bankName,
            accountNumber: this.echeckRequest.accountNumber,
            routingNumber: this.echeckRequest.routingNumber,
            accountType: this.echeckRequest.accountType,
            mecTransactionID: '',
            nameOnBankAccount: this.echeckRequest.nameOnBankAccount,
            customMessage: '',
            reusable: this.echeckRequest.reusable,
            eCheckID: this.eCheckTokenRes ? parseInt(atob(this.eCheckTokenRes), 10) : this.echeckRequest ? this.echeckRequest.id : 0,
            email: this.echeckRequest.email,
            phone: this.echeckRequest.phone
        };
        return eCheckInfo;
    }

    /**
     * @description add mask while chnaging phone number
     *
     * @memberof EcheckComponent
     */
    onChangeEcheckPhone($event: any) {
        const value = this.echeckForm.controls['phone'].value;
        let updatedValue = value;
        const alphaNumericValue = value.replace(/[^a-z0-9]/gi, '');
        if (value.match(/[a-zA-Z]/)) {
            if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
                updatedValue = value.replace(/[^a-z0-9]/gi, '');
            } else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) AAAAAAA');
            } else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) 000-AAAA');
            }
        } else {
            if (alphaNumericValue.length !== 3) {
                if (this.phoneNumberFormat) {
                    updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
                } else {
                    updatedValue = value;
                }

            }
        }
        this.echeckForm.controls['phone'].setValue(updatedValue);
    }

    onWorldpayXMLFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showWorldpayXml = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showWorldPayXMLPopup.close();
    }
    // ======================Worldpay End===================================================
    onAdyenPaymentFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showAdyenPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showAdyenPaymentPopup.close();
    }
    // ======================Adyen payment End===================================================
    onNIFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNIPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNIPopup.close();
    }

    onNexioFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNexioPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNexioPopup.close();
    }
    onPaymentAchFormClose() {
        this.addNewAchCard = false;
        this.achPaymentPopup.close();
    }

    /**
   * clear form...
   */
    clearOrderForm(isClearRetailForm?: boolean) {
        this.clearAllTheForms(true, true, true);
        const memberInfoElement = document.getElementById('memberInfo');
        if (memberInfoElement) {
            memberInfoElement.focus();
        }
        else {
            const countryElement = document.getElementById('country');
            if (countryElement) {
                countryElement.focus();
            }
        }
        if (isClearRetailForm) {
            this.clearGuestAndRetailForm();
        }
        if (this.orderFromLookup) {
            this.getDistributorInfo();
        }
    }

    /**
     * To clear guest or retail form when clicking on cancel
     */
    clearGuestAndRetailForm(): void {
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
            || this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            this.liveFormPersonalInfo = null;
            this.paymentComponentSettings.savedCards = [];
            this.address = null;
            this.liveFormAddress = null;
            this.mailingAddress = null;
            this.storeInfo = null;
            this._enrollmentMessageService.setStoreInfo(this.storeInfo);
            this.orderSession = null;
            this.savePaymentMethod = false;
            this.orderFormGroup.controls['isContactSponsor'].setValue(null);
            this.memberCommunicationPreferences.email = false;
            this.checkContactSponsor();
            this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
            this.orderTypeChange(this.orderFormGroup.value.orderType);
        }
    }

    /**
     * get restricted products
     */
    getRestrictedProducts(productModels: RestrictedProduct[]) {
        this.getShippingRestrictionError();
        this.restrictedProducts = [];
        productModels.forEach((product: RestrictedProduct) => {
            const itemNumber = product.itemNumber.substring(product.itemNumber.indexOf('#') + 1);
            const item = this.products.find((productItem: any) => productItem.itemNumber === itemNumber);
            if (item) {
                this.restrictedProducts.push(item.name + ' - #' + itemNumber);
            }
        });
        this.showRestrictedProducts.open();
    }

    /**
         * @description To Show Shipping Restriction Error message
         * @date 2019-08-01
         * @private
         * @returns {string}
         * @memberof OrderEditComponent
         */
    private getShippingRestrictionError(): string {
        if (this.shippingAddressInfo
            && this.shippingAddressInfo.stateCode && this.shippingAddressInfo.countryId && this.states && this.states.length > 0) {
            const stateName: string = this.states.find(x => x.stateCode === this.shippingAddressInfo.stateCode).stateName;
            const error: any = this._translatePipe.get('order.' + Translations.SHIPPING_RESTRICTION_ERROR, { stateName: stateName });
            this.productErrorMsg = error.value;
        } else {
            const error: any = this._translatePipe.get('order.Following products are not allowed for selected shipping address.');
            this.productErrorMsg = error.value;
        }
        return this.productErrorMsg;
    }

    /**
     * @description sip to different address click
     * @date 2018-11-16
     * @memberof OrderPromotionComponent
     */
    shipToDifferentAddress(): void {
        this.showSavedAddress = true;
        this.isNewCard = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.showPudoPickupPersonAddressForm = false;
        }
        setTimeout(() => {
            if (this.memberAddressDetails && this.memberAddressDetails.length > 0) {
                if (this.savedAddressElement && this.savedAddressElement.nativeElement) {
                    this.savedAddressElement.nativeElement.focus();
                }
            } else {
                if (this.addNewAddressEle && this.addNewAddressEle.nativeElement) {
                    this.addNewAddressEle.nativeElement.focus();
                }
            }
        }, 500);
        this.clearPudoLocationSearchData();
    }

    /**
     * @description this method will show new address form
     * @date 2018-11-16
     * @memberof OrderPromotionComponent
     */
    addNewAddress(): void {
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled && !this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayPudoAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewPudoShippingAddress();
        } else if (this.shippingAddressInfoConfig && (!this.shippingAddressInfoConfig.pudoLocationsEnabled && this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayDropAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewDropshipPersonAddress();
        } else {
            this.address = null;
            this.showSavedAddress = false;
            this.isNewCard = true;
            this.shippingAddressInfo = null;
            this.shippingMethods = [];
            this.updateTotalsAndShipMethod();
        }
        this.clearPudoLocationSearchData();
    }
    addNewPudoShippingAddress(): void {
        this.pudoAddress = null;
        this.showSavedAddress = false;
        this.showPudoPickupPersonAddressForm = true;
        setTimeout(() => {
            this.displayPudoAddress = true;
        }, 100);
    }

    addNewDropshipPersonAddress():void{
        this.pudoShippingAddressInfo = null;
        this.showSavedAddress = false;
        this.showDropShipPersonAddressForm = true;
        setTimeout(()=>{
            this.displayDropAddress = true;
        },100);
    }

    clearPudoLocationSearchForm() {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = false;
        this.buildPudoLocationSearchForm();
    }

    clearPudoLocationSearchData() {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = true;
        this.buildPudoLocationSearchForm();
    }
    getAddressIsValid(isValid) {
        this.formPickupPersonAddressValid = isValid;
        this.pudoLocationsNotFound = false;
    }

    // getPaymentMethod by Store
    getPaymentMethodsByStore(memberTypeId?: number) {
        let fpc5PercentEnabled: boolean = false;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this.credit_Card_show = this.money_Order_show = this.orange_money_show = this.cash_on_delivery_show = this.ach_show
            = this.bank_transfer_show = this.echeck_show = this.banContact_misterCash_and_maestro_show = this.wire_Transfer_show
            = this.misterCash_and_maestro_show = this.single_debit_show = this.direct_debit_show = this.pay_by_link_show = false;
        const memberId = this.memberInfo && this.memberInfo.memberId && (this.memberInfo.memberTypeId == MemberTypeEnum.DISTRIBUTOR || (this.appConfig.showBonusInfoForFPC && this.memberInfo.memberTypeId == MemberTypeEnum.FPC)) ? this.memberInfo.memberId : null;
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode,
            this.storeDefaultLanguage ? this.storeDefaultLanguage : this.languageCode,
            this.memberInfo ? this.memberInfo.memberTypeId : memberTypeId,
            this.memberInfo ? this.memberInfo.wholeSaleQualified : null, fpc5PercentEnabled, false, false, memberId,this.memberInfo ? this.memberInfo.homeCompany: null).subscribe(response => {
                if (response) {
                    //response = this._commonService.singleOrDirectDebitCardEligibilityCheck(response, this.countryCode, this.memberInfo ? this.memberInfo.homeCompany : null);
                    if (response.find(x => x.paymentMethodName === PaymentMethodTypes.Credit_Card && x.paymentProcessor === PaymentProcessorAlias.ADYEN)) {
                        this._commonService.getPaymentMethodsSourceConfiguration().subscribe(
                            (paymentMethodSourceConfigurations: PaymentMethodSourceConfiguration[]) => {
                                if (paymentMethodSourceConfigurations && paymentMethodSourceConfigurations.length > 0 && response && response.length > 0) {
                                    const paymentmethodsConfig = paymentMethodSourceConfigurations.find((paymentMethodSourceConfiguration: PaymentMethodSourceConfiguration) => paymentMethodSourceConfiguration && paymentMethodSourceConfiguration.country == this.selectedIsoCountryCode);
                                    if (paymentmethodsConfig) {
                                        response = this._commonService.filterPaymentMethods(paymentmethodsConfig, response, this.orderFormGroup.value.orderType);
                                        this.initialPaymentMethods = response;
                                    }
                                }
                                this.updatePaymentMethodsDisplayStatus(response);
                            },
                            (error) => {
                                this.updatePaymentMethodsDisplayStatus(response);
                            });
                    } else {
                        this.updatePaymentMethodsDisplayStatus(response);
                    }
                }
            },
                (error) => {
                });
    }


    updatePaymentMethodsDisplayStatus(response) {
        this.storePaymentInfo = response;
        this.initializePaymentMethods();
        this.storePaymentInfo.forEach(
            paymentMethod => {
                if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                    this.credit_Card_show = (this.checkoutConfig.disableAddNewCards && (!this.paymentComponentSettings || !this.paymentComponentSettings.savedCards || this.paymentComponentSettings.savedCards.length === 0)) ? false : true;
                    if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NEXIO) {
                        this.isNexioPayment = true;
                    }
                    else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.ADYEN) {
                        this.isAdyenPayment = true;
                    } else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NI) {
                        this.isNIPayment = true;
                    }
                    else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.WPAYXML) {
                        this.isWorldpayPayment = true;
                    }
                } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                    this.displayStatementForWavePayment = this.appConfig.displayStatementForWavePayment;
                    if (this.displayStatementForWavePayment) {
                        this.money_Order_show = true;
                        this.displayStatementForWavePayment = this.appConfig.displayStatementForWavePayment;
                    } else {
                        this.money_Order_show = true;
                        this.getBankDetailsByCountry(this.countryCode, PaymentModeConstants.Money_Order);
                    }
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                    this.wire_Transfer_show = true;
                    this.getBankDetailsByCountry(this.countryCode, PaymentModeConstants.Wire_Transfer);
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                    this.bank_transfer_show = true;
                    this.getBankDetailsByCountry(this.countryCode);
                } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                    this.cash_on_delivery_show = true
                } else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                    this.orange_money_show = true
                } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                    this.ach_show = true;
                    this.getSavedAchs();
                } else if (paymentMethod.paymentMethodId === PaymentType.Direct_Debit) {
                    this.direct_debit_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                    this.pay_by_link_show = true;
                }
            });
        if (this.direct_debit_show) {
            this.getPaymentTermsAndPoliciesDocuments();
        }
        const option = this.credit_Card_show ? this.paymentTypeEnum.Credit_Card : this.money_Order_show ? this.paymentTypeEnum.Money_order : this.wire_Transfer_show ? this.paymentTypeEnum.Wire_Transfer
            : this.bank_transfer_show ? this.paymentTypeEnum.Bank_Transfer : this.cash_on_delivery_show ? this.paymentTypeEnum.Cash_On_Delivery : this.ach_show ? this.paymentTypeEnum.eCheck
                : this.banContact_misterCash_and_maestro_show ? this.paymentTypeEnum.BanContact_MisterCash_and_Maestro : this.misterCash_and_maestro_show ? this.paymentTypeEnum.MisterCash_and_Maestro
                    : this.direct_debit_show ? this.paymentTypeEnum.Direct_Debit : this.pay_by_link_show ? this.paymentTypeEnum.Pay_By_Link : this.orange_money_show ? this.paymentTypeEnum.Orange_Money : null;
        if (option) {
            this.setPaymentMethod(option);
        }
        this.savePaymentMethod = this.orderSession && this.orderSession.savePaymentMethod ?
            this.orderSession.savePaymentMethod : false;
        if (!this.appConfig.showBonusInfoForFPC) {
            this.restrictPaymentsByItemTotals();
        }
    }
    initializePaymentMethods() {
        this.isWorldpayPayment = false;
        this.isAdyenPayment = false;
        this.isNIPayment = false;
        this.isNexioPayment = false;
    }
    setPaymentMethod = (value) => {
        if (value && value != this.orderFormGroup.controls['paymentSelector'].value) {
            this.orderFormGroup.controls['paymentSelector'].setValue(value.toString());
        }
        this.onPaymentMethodChnage();
    }

    /**
     * @description to get payment terms and Conditions documents
     * @param storeInfo
     */
    getPaymentTermsAndPoliciesDocuments() {
        const accountlevelID = this._commonService.getMemberAccountLevelId(this.memberInfo);
        if (accountlevelID) {
            this._documentService.getDocuments(Portal.Csp, accountlevelID, DisplaySectionId.Payment_Page, this.countryCode, this.storeDefaultLanguage).subscribe(
                (res) => {
                    if (res && res[0] && res[0].body && res[0].body.length > 0) {
                        this.paymentTermsAndPoliciyDocuments = res[0].body;
                        this.paymentTermsAndPoliciyDocuments.forEach(item => {
                            item.isSelected = true
                        });
                    }
                },
                (error) => {
                }
            );
        }
    }

    /**
   * @description get Order Min Max Business Rules
   * @memberof OrderPromotionComponent
   */
    getOrderRules(storeInfo?: StoreConfig): void {
        const userInfo: Member = this.memberInfo;
        let isFboUpgradeFlow = false;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
            isFboUpgradeFlow = (+this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR &&
                this.appConfig && this.appConfig.displayPurchaseLimitationMessage);
        }
        const orderRulesRequest: OrderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL,
            orderType: userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Personal
                : MemberOrderType.Retail
        };

        if (!isFboUpgradeFlow) {
            this.getBusinessOrderRules(orderRulesRequest);
        }

        this._orderService.getMemberOrderRestrictionsInfo(userInfo, this.selectedIsoCountryCode)
            .subscribe((response: any) => {
                if (response) {
                    this.restrictedDays = response.restrictedDays;
                    this.getMemberRankLevelHistory(orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow);
                }
            }, error => {
            });

        if (userInfo && userInfo.memberId && userInfo.memberTitleId !== MemberLevel.RETAIL) {
            if (!isFboUpgradeFlow) {
                this.getMemberOrderRules(userInfo, false);
            }
            this.getMemberCCOverrides(userInfo.memberId);
        }
    }

    getPaymentRules(): void {
        if (this.memberInfo) {
            let fpc5PercentEnabled: boolean = false;
            let memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;

            let wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified ? true : false;
            if (wholesaleQualified == null) {
                wholesaleQualified = false;
            }
            if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
                fpc5PercentEnabled = true;
            }
            let paymentdroolsRequest: PaymentDroolsRequest = {
                countryCode: this.selectedIsoCountryCode.toUpperCase(),
                orderType: this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId),
                memberType: this.memberInfo.memberTypeId,
                orderSource: OrderSourceValue.CUSTOMER,
                vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false
            }
            this._orderService.getPaymentDroosResponse(paymentdroolsRequest).subscribe(response => {
                if (response) {
                    this.paymentDroolsResponse = response;
                }
            },
                (error) => {
                });
        }


    }

    getBusinessOrderRules(orderRulesRequest, userInfo?: Member, isFboUpgradeFlow?: boolean): void {
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe((response: any) => {
                if (response && response.success) {
                    this.orderRules = response;
                    if (isFboUpgradeFlow) {
                        this.getMemberOrderRules(userInfo, false, null, true);
                    }
                }
                else{
                    this.orderRules = null;
                }
            }, error => {
                this.orderRules = null;
            });
    }

    /**
     * Get member cc overrides
     * @param memberId
    */
    getMemberCCOverrides(memberId: number): void {
        this._customerService.getMemberCCOverride(this.storeId, memberId)
            .subscribe(response => {
                if (response && response.length) {
                    this.memberCCOverride = response[0];
                } else {
                    this.memberCCOverride = null;
                }
            }, (err: any) => {
            });
    }

    /** get Member Order rules
     * @description
     * @date 2019-05-20
     * @memberof OrderPromotionComponent
     */
    getMemberOrderRules(userInfo: Member, isBackOrderDate: boolean, requestUrl?: string, isFboUpgradeFlow?: boolean): void {
        this.memberOrderCCInfo = null;
        let fromDate;
        let toDate;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        }
        if (isFboUpgradeFlow) {
            fromDate = this.memberInfo.enrolmentDate.substr(0, 10);
            const enrollDate = new Date(fromDate);
            const orderToDateStr = enrollDate.setDate(enrollDate.getDate() + this.restrictedDays);
            toDate = moment(orderToDateStr).format(DateConstants.DOBFormat);
        }
        this._orderService.getMemberOrderBusinessRules(userInfo.memberId, this.storeId, isBackOrderDate,
            this.selectedIsoCountryCode, userInfo.memberTitleId, null, fromDate, toDate)
            .subscribe((response: any) => {
                if (response) {
                    const memberOrderRules = response;
                    const frequencyType = this.isMemberFboUpgraded ? Constants.FREQUENCY_ABSOLUTE : Constants.FREQUENCY_MONTHLY;
                    this.memberOrderCCInfo = memberOrderRules.memberOrderCCInfo.filter((x: any) => x.frequency === frequencyType)[0];
                    const validateOrderRule = this.verifyOrderRules(isBackOrderDate);
                    this.upgradeFboLimitExceeded = frequencyType === Constants.FREQUENCY_ABSOLUTE ?
                        validateOrderRule.purchaseLimitExceed : false;
                    this.thresholdCrossed = validateOrderRule.thresholdCrossed;
                    this.memberCCLimitExceeded = validateOrderRule.monthlyCCValid;
                    this.monthlyCCValue = validateOrderRule.monthlyCCValue;
                    this.memberCCOverrideLimitExceeded = validateOrderRule.memberCCOverride;
                    this.cartLimitExceed = validateOrderRule.cartLimitExceed;
                    this.cartLimitNotReach = validateOrderRule.cartLimitNotReach;
                    if (requestUrl) {
                        this.placeOrder(requestUrl);
                    }
                }
            }, error => {
            });
    }

    /**
     * @description savePayment methos
     * @memberof OrderPromotionComponent
     */
    savePaymentMethodClicked(savePaymentMethod: boolean): void {
        this.savePaymentMethod = !savePaymentMethod;
    }

    /**
     * @description get Terms and Conditions Document
     * fetchTermsConditionDocument
     * @memberof OrderPromotionComponent
     */
    fetchTermsConditionDocument(agreementDocuments: DocumentLibrary[]): void {
        this.agreementDocuments = agreementDocuments;
        const unselectedAgreements = this.agreementDocuments.filter(agreement => !agreement.isSelected);
        if (unselectedAgreements && unselectedAgreements.length > 0) {
            this.agreementCheck = false;
        } else {
            this.agreementCheck = true;
            this.isSubmitted = false;
        }
    }

    /**
     * @description prepare Terms and Conditions Document request
     * prepareAgreementDocumentsRequest
     * @memberof OrderPromotionComponent
     */
    prepareAgreementDocumentsRequest(): void {
        this.documentsRequest = {
            customerTypeId: this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL ? MemberLevel.GUEST
                : MemberLevel.RETAIL,
            portalId: Portal.Csp,
            displaySectionId: this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL
                ? DisplaySectionId.Guest_Checkout_Page : DisplaySectionId.Retail_Checkout_Page,
            countryCode: this.countryCode,
            languageCode: this.orderFormGroup.value.language
        };
    }
    gotoCheckout(): void {
        if (this.shoppingCartCount) {
            if (!this.memberCart) {
                if (this.memberCartInfo.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCartInfo,
                        shoppingBagClicked: true
                    });
                }
            }
            else {
                if (this.memberCart.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCart,
                        shoppingBagClicked: true
                    });
                }
            }
        }
    }

    /**
     * @description close modal
     * @memberof OrderPromotionComponent
     */
    closeModal(): void {
        this.orderTypeChangeConfirmation.close();
    }

    closeModalPopUp(status: boolean) {
        this.accountRestriction = status;
    }
    /**
     * @description
     * @date 2020-03-19
     * @private
     * @memberof OrderPromotionComponent
     */
    private getParticipatingCountries(countryCode: string): void {
        this._customerService.getParticipatingCountries(countryCode)
            .subscribe(response => {
                if (response && response.length > 0) {
                    const participatingCountries = response;
                    if (!this.orderFormGroup.value.orderType || (this.orderFormGroup.value.orderType !== this.orderType.NEW_GUEST_RETAIL
                        && this.orderFormGroup.value.orderType !== this.orderType.NEW_RETAIL)) {
                        const selectedCountryID = participatingCountries.map(item => item.countryId).join(',');
                        this.getMemberAddressByMemberId(this.memberInfo.memberId, selectedCountryID);
                    }
                }
            });
    }

    /**
     * check member has access to place an order
     */
    checkMemberAccess() {
        if (this.memberInfo && this.orderFormGroup && this.orderFormGroup.value.orderType === this.orderType.REGULAR
            && this.restrictedDays > 0) {
            const dateParts =  this.memberInfo.enrolmentDate ? this.memberInfo.enrolmentDate.split('-') : this.memberInfo.createdDate.split('-');
            const enrollmentDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
            enrollmentDate.setHours(0, 0, 0, 0);
            enrollmentDate.setDate(enrollmentDate.getDate() + this.restrictedDays);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            if (this.isFBOValidationPending) {
                return;
            }
            if (this.upgradeFboLimitExceeded && this.isMemberFboUpgraded) {
                this.displayPurchaseLimitMessage(enrollmentDate);
                this.isMemberHasAccessToOrder = this.calculateItemsSubTotal(this.storeInfo) > 0 ? true : false;
                return;
            } else if (this.isMemberFboUpgraded) {
                this.isMemberHasAccessToOrder = true;
                this._commonService.removeNotification(Constants.PURCHASE_WINDOW);
            } else if (enrollmentDate.getTime() > currentDate.getTime() && this.memberInfo.fboId && !this.isMemberFboUpgraded ) {
                let restrictPlacingOrder = true;
                if((this.memberInfo.sponsorTransactionalSourceId == transactional.SPNC && this.countryCode && environment.skipOrderRestrictionCountriesOnSPNCTransaction.includes(this.countryCode.toUpperCase()))){
                    restrictPlacingOrder = false
                }
                if(restrictPlacingOrder){
                    const nextOrderDate = moment(enrollmentDate).format(DateConstants.DateFormat);
                    const orderPlacingError: any = this._translatePipe.get('order.Next Order is permitted after');
                    this._commonService.createNotification('', orderPlacingError.value + nextOrderDate, NotificationType.ERROR);
                    this.isMemberHasAccessToOrder = false;
                }
            }
        }
    }

    displayPurchaseLimitMessage(enrollmentDate): void {
        let purchaseLimitExceedMessage = this._translatePipe
            .get('order.Orders should not exceed an aggregate of ||maxValue|| until ||endDate||')['value'];
        const nextOrderEligibleDate = moment(enrollmentDate).format(DateConstants.DateFormat);
        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue,this.storeInfo);
        purchaseLimitExceedMessage = this._translateKey.transform(purchaseLimitExceedMessage,
            {
                maxValue: maxValue,
                endDate: nextOrderEligibleDate
            });
        this._commonService.createNotification('', purchaseLimitExceedMessage, NotificationType.ERROR, 0, Constants.PURCHASE_WINDOW);
    }

    /**
    *
    * @param items
    */
    getItemVolumeSum(items): number {
        if (this.appConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        } else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    }
    trackByItem(index: number): number {
        return index;
    }

    /**
    * @description this method used for allow user to enter address fields
    * @memberof PersonalInfoComponent
    */
    enableAddressFields(block: string): void {
        const addressFieldInfo: AddressVisibility = {
            isEnableAddressFields: true,
            block: block
        };
        this.messageService.setEnableAddressFields(addressFieldInfo);
    }

    loadPreferences(response: StoreConfig): void {
        let memberTypeId: any;
        let preferenceConfig: any;
        if (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) {
            memberTypeId = MemberTypeEnum.RETAIL;
        } else if (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) {
            memberTypeId = MemberTypeEnum.GUEST;
        }
        preferenceConfig = response && response.storePreferenceModels && memberTypeId ? response.storePreferenceModels.find(config => config.memberTypeId === memberTypeId) : null;
        if (preferenceConfig) {
            if (preferenceConfig.value === Constants.YES || preferenceConfig.value === Constants.DEFAULT) {
                this.orderFormGroup.controls['isContactSponsor'].setValue(true);
            }
            else if (preferenceConfig.value === Constants.NO) {
                this.orderFormGroup.controls['isContactSponsor'].setValue(false);
            }
            this.checkContactSponsor();
        }
    }

    validateSubTotalBasedOnType(products: any[], subTotal?: any): boolean {
        let isThresholdCrossed = true;
        let itemSubTotal = subTotal;
        let orderMinValue = this.orderRules.minValue;
        let orderMaxValue = this.orderRules.maxValue;
        if (this.isLiteratureValidation(products)) {
            orderMinValue = this.orderRules.literatureMinValue;
            orderMaxValue = this.orderRules.literatureMaxValue;
        }
        if (itemSubTotal >= orderMinValue && itemSubTotal <= orderMaxValue) {
            isThresholdCrossed = false;
        }
        const hasMinValueIgnoreProduct = this._enrollmentCommonService.checkMinValueProduct(this.products, this.orderRules);
        if (itemSubTotal <= orderMinValue) {
            this.isOverrideMinimumLimit === true || hasMinValueIgnoreProduct ? isThresholdCrossed = false : isThresholdCrossed = true;
        }
        return isThresholdCrossed;
    }

    isLiteratureValidation(products?: any): boolean {
        let literatureItems = this.getLiteratureItems(products);
        let isLiterature = literatureItems && literatureItems.length && products && products.length
            && products.length === literatureItems.length;
        return isLiterature;
    }

    /**
*
* @param items
*/
    getItemTotalSum(item): number {
        return this.calculateSubTotal(this.storeInfo,
            this.countryTaxInclusive, item, this.memberInfo, true);
    }

    /**
      * Get Total CartItems Cost.
      */
    calculateSubTotal(store: StoreConfig, taxInclusiveShippingCountry: boolean,
        item: any, userInfo: Member, taxCalculated: boolean): number {
        let subTotal = 0;
        if (item) {
            const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            if (userInfo && store && store.taxInclusive && isEnableVATCalculation) {
                subTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(item,
                    store, taxInclusiveShippingCountry, userInfo, taxCalculated);
            } else {

                subTotal += this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry,
                    isCalculateTaxExclusivePrice, taxCalculated, userInfo);
            }
        }
        if (store) {
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    }

    /**
     * calculate subtotal for vat and not vat registered user
     * calculateSubtotalForVatAndNonVatRegisteredUser()
     */
    calculateSubtotalForVatAndNonVatRegisteredUser(item: any, store: StoreConfig, taxInclusiveShippingCountry: boolean,
        userInfo: Member, taxCalculated: boolean): number {
        if (!item.literature && (taxCalculated || !userInfo.vatRegistered)) {
            if (userInfo.transactionalOptin &&
                userInfo.transactionalWholesaleQualified
                && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                    || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                        && this._commonService.isWHLSAL00enabledForAsstSupervisor(store.homeIsocodeThree)))) {
                const total = Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
            } else {
                return Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'applicablePrice'].
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
            }
        } else if (taxCalculated && (userInfo.vatRegistered)) {
            return Number(item.catalogPrice.
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        } else {
            return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry);
        }
    }

    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    calculateItemSubtotal(item: any, store: StoreConfig, taxInclusiveShippingCountry: boolean, isCalcTaxExclusivePrice?: boolean, taxCalculated?: boolean, userInfo?: Member): number {
        if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
            let productPrice = 'applicablePrice';
            if (userInfo && (userInfo.vatRegistered || (!userInfo.vatRegistered && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR && this.isCalculateTax))) {
                productPrice = 'catalogPrice';
            }
            return Number(item[productPrice].
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;

        } else {
            return Number(item[(taxInclusiveShippingCountry === false || isCalcTaxExclusivePrice) ? 'catalogPrice' : 'applicablePrice'].
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
    }


    /**
     *
     */
    calculateDiscountAmount(item: any, displayPriceConfig: DisplayPriceConfig): number {
        let discountAmount = 0;
        discountAmount = (parseFloat(item.baseRetailPrice.toFixed(2)) * item.quantity) -
            (parseFloat(item.catalogPrice.toFixed(2)) * item.quantity);
        return discountAmount;
    }

    /**
  * Get Total CartItems Cost.
  */
    calculateItemsSubTotal(store: StoreConfig): number {
        this.orderLevelDiscount = 0;
        let itemsSubTotal = 0;
        this.isBWPEnabledProduct = false;
        const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
        const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
        for (let i = 0; i < this.products.length; i++) {
            if (this.memberInfo && store.taxInclusive && isEnableVATCalculation) {
                const presentItemSubtotal = this.calculateSubtotalForVatAndNonVatRegisteredUser(this.products[i],
                    store, this.countryTaxInclusive, this.memberInfo, true);
                itemsSubTotal += presentItemSubtotal;
                if (this.isBWPEnabled && store.bwpEnabled) {
                    const isBWPEnabledProduct = this.products[i].productMetaData.find(x => x.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && x.metaKeyWords === '1');
                    if (isBWPEnabledProduct && presentItemSubtotal > 0 && this.storeInfo && this.storeInfo.bwpEnabled) {
                        this.isBWPEnabledProduct = true;
                        this.orderLevelDiscount += ((presentItemSubtotal * 5) / 100);
                    }
                }
            } else {
                const presentItemSubtotal = this.calculateItemSubtotal(this.products[i], store,
                    this.countryTaxInclusive, isCalculateTaxExclusivePrice, true, this.memberInfo);
                itemsSubTotal += presentItemSubtotal;
                if (this.isBWPEnabled && store.bwpEnabled) {
                    const isBWPEnabledProduct = this.products[i].productMetaData.find(x => x.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && x.metaKeyWords === '1');
                    if (isBWPEnabledProduct && presentItemSubtotal > 0 && this.storeInfo && this.storeInfo.bwpEnabled) {
                        this.isBWPEnabledProduct = true;
                        this.orderLevelDiscount += ((presentItemSubtotal * 5) / 100);
                    }
                }
            }
        }

        if (store) {
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    }

    /**
       * get member shipping discount offer
       */
    getMemberShippingDiscountOffer(memberId: number): void {
        this._commonService.getMemberShippingDiscountOffer(memberId, this.countryCode).subscribe((response: any) => {
            if (response && response.effectiveEndDate) {
                const currentDate = new Date().setHours(0, 0, 0, 0);
                const endDate = new Date(response.effectiveEndDate.split('T')[0]).setHours(0, 0, 0, 0);
                this.memberShippingDiscountOfferEligible = currentDate <= endDate ? true : false;
            } else {
                this.memberShippingDiscountOfferEligible = false;
            }
        });
    }

    /**
    * @description this method will remove member discount offer for UK FPC second order
    * @memberof OrderSummaryNewComponent
    */
    removeMemberDiscountOffer(memberId: number): void {
        this._commonService.removeMemberDiscountOffer(memberId)
            .subscribe((response: any) => {
            });
    }

    calculateNetUnitPrice(product: any): number {
        const netUnitPrice = product.computedTaxInclusivePrice / (1 + (product.taxRate / 100));
        return Math.round((netUnitPrice + Number.EPSILON) * 100) / 100;
    }

    /**
    * @description this method will calculate shipping cost that has to be used for calculating order summary
    * @memberof OrderPromotionComponent
    */
    getShippingCostForOrderSummary(): number {
        let shippingCost = +this.getOrderShippingCost() || 0;
        if (this.memberShippingDiscountOfferEligible) {
            shippingCost = 0;
        } else if (this.orderFormGroup.value.isShippingDiscountApplied) {
            const skipShippingTaxCalculation = (this.memberInfo && this.memberInfo.vatRegistered) || this.appConfig.skipShippingTaxCalculationInShipping;
            if ((this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()
                && this.shippingCost > 0)
                || (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString() ||
                    this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.fourthOption.toString()
                    && this.orderFormGroup.controls['shippingCostPercentage'].value > 0)) {
                if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
                    shippingCost = shippingCost;
                } else {
                    const shippingCostWithTax = (this.shippingCost || 0) + (this.shippingTax || 0);
                    if (this.shippingTax && !skipShippingTaxCalculation) {
                        this.isShippingTaxAddedToShippingCost = true;
                    }
                    shippingCost = skipShippingTaxCalculation ? (this.shippingCost || 0) : shippingCostWithTax;
                }

            } else if ((this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()
                && this.shippingCost === 0)
                || (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                    && this.orderFormGroup.controls['shippingCostPercentage'].value === 100)) {
                shippingCost = 0;
            }
        }
        this.itemShippingCost = shippingCost;
        return shippingCost;
    }

    /**
    * @description this method will calculate tax exclusive shipping cost
    * @memberof OrderPromotionComponent
    */
    getTaxExclusiveShippingCost(): number {
        let shippingCost = this.shippingCost || 0;
        if (this.memberShippingDiscountOfferEligible) {
            shippingCost = 0;
        } else if (this.orderFormGroup.value.isShippingDiscountApplied) {
            if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                && this.orderFormGroup.controls['shippingCostPercentage'].value === 100) {
                shippingCost = 0;
            }
        }
        return shippingCost;
    }

    /**
    * @description this method will calculate total shipping cost that includes taxes
    * @memberof OrderPromotionComponent
    */
    getOrderShippingCost(): number {
        if (this.orderSession) {
            this.shippingCost = this.orderSession.shippingCost ? this.orderSession.shippingCost : this.orderSession.shippingCostValue;
            this.shippingTax = this.orderSession.shippingTax;
            this.taxCalculationStatus = this.orderSession.taxCalculationStatus;
            this.appConfig = this.appConfig ? this.appConfig : this.orderSession.appConfig;
            this.orderTaxResponse = this.orderTaxResponse ? this.orderTaxResponse : this.orderSession.orderTaxResponse;
            this.importFeeValue = this.orderSession.importFeeValue;
        }
        if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
            return (this.memberInfo && this.memberInfo.memberTypeId === MemberTypeId.DISTRIBUTOR) ? this.shippingCost : (this.shippingCost + this.shippingTax);
        } else {
            return ((this.memberInfo && this.memberInfo.vatRegistered) || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) || (this.appConfig && this.appConfig.displayTaxInclusivePrice)) ? this.shippingCost : (this.shippingCost + this.shippingTax);
        }
    }

    /**
    * @description
    * @date 2020-12-11
    * @param {*} value
    * @memberof OrderPromotionComponent
    */
    updateProductInCart(value): void {
        this.updateCartProduct = value;
    }

    updateMemberDetails(value): void {
        this.updateMemberDetail = value;
    }

    /**
      * map Ach Info for payment
      */
    getAchInfo() {
        this.achPaymentInfo = this.achPaymentInfo ? this.achPaymentInfo : this.selectedAchInfo;
        if (this.achPaymentInfo) {
            const paymentAchInfo = {
                name: this.achPaymentInfo.billingAddress.name,
                accountNumber: this.achPaymentInfo.accountNumber,
                routingNumber: this.achPaymentInfo.routingNumber,
                accountType: this.achPaymentInfo.accountType,
                mecTransactionID: '',
                nameOnBankAccount: this.achPaymentInfo.nameOnBankAccount,
                customMessage: '',
                reusable: this.achPaymentInfo.reusable,
                eCheckID: this.achPaymentInfo.id,
                email: this.achPaymentInfo.email,
                phone: this.achPaymentInfo.phone,
                secType: this.achPaymentInfo.secType,
                //dlState:this.achPaymentInfo.dlState,
                //dlNumber:this.achPaymentInfo.dlNumber,
                checkNumber: this.achPaymentInfo.checkNumber,
            };
            return paymentAchInfo;
        }

    }
    getUserMemberId() {
        let memberId = null;
        if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
            memberId = this.accountMemberInfo.memberId;
        } else
            memberId = 0

        return memberId;
    }


    /**
  * @description To get the list of bank details from payment service based on country
  * @date 2021-01-07
  * @param {*} countryCode
  * @memberof OrderPromotionComponent
  */
    getBankDetailsByCountry(countryCode: any, paymentMethod?: string) {
        this._achService.getBankDetailsByCountry(countryCode, paymentMethod).subscribe(response => {
            if (response && response.length > 0) {
                if (paymentMethod && PaymentMethodTypes.Wire_Transfer.toLowerCase() === paymentMethod.toLowerCase()) {
                    this.bankDetailsCountryList = response.filter((bankDetail) => bankDetail.paymentMode.toLowerCase() === PaymentMethodTypes.Wire_Transfer.toLowerCase());
                } else {
                    this.bankDetailsCountryList = response;
                }
            } else {
                this.bankDetailsCountryList = [];
            }
        });
    }
    /**
  * @description To get the order details based on sessionguid
  * @date 2021-22-01
  * @memberof OrderPromotionComponent
  */
    getOrderDetailsByUuid(orderSessionGuid: string, distrubutorId?: string) {
        if (orderSessionGuid) {
            this._orderService.getOrderDetailsUuid(orderSessionGuid, distrubutorId).subscribe((response: any) => {
                if (response) {
                    if (this.appConfig && this.appConfig.freeShippingFPCOrder && this.memberShippingDiscountOfferEligible) {
                        this.removeMemberDiscountOffer(this.memberInfo.memberId);
                    }
                    const shippingLogInfo = this.getShippingLogInfo();
                    if (shippingLogInfo) {
                    }
                    this.orderSuccess(response);
                    const sessionGuid = ((this.memberCart && this.memberCart.sessionGuid) || this.memberCartSessionGuid);
                    if (sessionGuid && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST && this.shoppingBagClicked) {
                        this.deleteCart(sessionGuid);
                    }
                }
                else {
                    const notification: any = this._translatePipe.get
                        ('order.Unable to Process Order.');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            }, (error: Response) => {
                const notification: any = this._translatePipe.get
                    ('order.Unable to Process Order.');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
            });
        }
    }
    mapShippingAddress() {
        if (this.shippingAddressInfo) {
            this.paymentComponentSettings.shippingAddressDetail = this.shippingAddressInfo;
        }
    }

    //FBo Referela Id Section

    searchSponsorByFboId(sponsorId: AbstractControl): void {

        if ((sponsorId && sponsorId.value && sponsorId.valid)) {
            this.sponsorInformation = null;
            this.getSponsorInfoByReferralOrAutoSuggest(this.fboReferralId, true, true);
        }
    }

    isEnableFboReferralId(): boolean {
        if ((this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL || (this.memberTypeId == MemberTypeEnum.GUEST)) && this.storeInfo && this.storeInfo.enableCspFBOReferralId && this.sponsorInformation) {
            return true;
        }
        return false;
    }

    resetSponsorDetails(): void {
        this.sponsorInformation = null;
        this.fboReferralId = null;
    }
    /**
     * @description Method to get Government ID details based on country
     * @date 2021-03-31
     * @memberof OrderPromotionComponent
     */
    getGovermentIdentificationPatterns() {
        this._commonService.getGovermentIdentificationPatterns().subscribe((response: any[]) => {
            if (response) {
                this.identificationPatternByCountry = response.find(item => item.countryCode.toLowerCase() ===
                    this.countryCode.toLowerCase());
                if (this.identificationPatternByCountry && this.identificationPatternByCountry.required) {
                    this.fboUpgradeForm.controls['governmentId'].setValidators(Validators.required);
                    this.fboUpgradeForm.controls['governmentId'].updateValueAndValidity();
                }
            }
        });
    }

    onChange() {
        this.isSubmitted = false;
        this.governmentIdValidInProgress = true;
        this.fboUpgradeForm.controls['governmentId'].setValue(this.fboUpgradeForm.value.governmentId.toUpperCase());
    }

    /**
     * @description Method to search address based on name
     * @date 2021-04-19
     * @memberof OrderPromotionComponent
     */
    searchShippingAddress(event: any) {
        this.addressSearchResult = this._commonService.searchShippingAddress(event, this.memberAddressDetails);
    }


    selectBonusPaymentType(paymentOption: any) {
        this.isSelectedBonusPaymentOptionType = true;
        this.bonusPaymentOptionType = paymentOption;
        if (paymentOption === this.bonusPaymentOption.DECIDE_LATER) {
            this.bonusInformation = null;
        }
    }

    setBonusInformation(): void {
        this._personalMessageService.setSubmitBonusInfoForm(true);
    }

    getBonusInfo(bonusInformation: BonusInfo): void {
        this.bonusInformation = bonusInformation;
    }

    getBonusInfoOnInputChange(bonusInfoFormValidated): void {
        this.bonusInfoFormValidated = bonusInfoFormValidated;
        if (this.beneluxCountry) {
            this.messageService.accountNumber.subscribe((accountNumber: string) => {
                this.accountNumber = (accountNumber === undefined || accountNumber === "") ? "" : accountNumber;
                this.disableBonusAgreement = (accountNumber === undefined || accountNumber === "") ? true : false;
                if (this.accountNumber !== undefined || this.accountNumber !== "") {
                    this.bonusInfoAgreementCheckError = false;
                }
            });
        }
    }

    /**
     * @description Reteriving guest info from personal info for guest to retail update
     * @date 2021-05-26
     * @param {*} event
     * @memberof OrderPromotionComponent
     */
    getGuestToRetailUsers(event): void {
        this.guestToRetailMember = event;
    }

    fetchEcheckSecTypes(secType: string): string {
        if (secType === SecType.Web) {
            return 'WEB ACH'
        } else {
            return 'PPD ACH'
        }
    }


    /**
     * To Get Promotions based on store
     */
    getStorePromotions(resetPromotion?: boolean) {
        if (this.memberInfo && (this.orderFormGroup.get('orderType').value == this.orderType.REGULAR) && this.storeDetails) {
            if (this.memberHomeCountry && this.memberInfo.memberPreferences && this.memberInfo.memberPreferences.length > 0 && this.selectedIsoCountryCode && (this.memberHomeCountry.toUpperCase() === this.selectedIsoCountryCode.toUpperCase())) {
                const webSitelanguagePreference = this.memberInfo.memberPreferences.find(x => x.preferenceId === MemberPreferencesType.PREFERREDWEBSITELANGUAGE);
                if (webSitelanguagePreference) {
                    const language = this.storeDetails.languages.find(x => x.languageId === parseInt(webSitelanguagePreference.preferenceValue, 0));
                    if (language) {
                        this.storeLangCultureId = parseInt(language.cultureId);
                        this.storeLanguageCultureName = language.cultureName;
                        this.storeDefaultLanguageShortCode = language.languageCode;
                    }
                }

            } else {
                this.storeLangCultureId = this.storeDetails.languages.find((languageCulture: any) => languageCulture.default).cultureId;
                this.storeLanguageCultureName = this.storeDetails.languages.find((languageCulture: any) => languageCulture.default).cultureName;
                this.storeDefaultLanguageShortCode = this.storeDetails.languages.find((languageCulture: any) => languageCulture.default).languageCode;
            }
        }
        this.promotionModels = [];
        const promotionrequest: Promotion = {
            memberType: (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) ? MemberTypeEnum.RETAIL : (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL) ? MemberTypeEnum.GUEST : (this.memberInfo && this.memberInfo.memberTypeId) ? this.memberInfo.memberTypeId : null,
            memberLevel: ((this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) || (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL)) ? null : (this.memberInfo && this.memberInfo.memberTypeId == MemberTypeEnum.DISTRIBUTOR) ? this.memberInfo.memberTitleId : null,
            orderType: PromotionOrderType.SHOP,
            distributorId: ((this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL) || (this.orderFormGroup.value.orderType === this.orderType.NEW_GUEST_RETAIL)) ? null : (this.memberInfo && this.memberInfo.fboId) ? this.memberInfo.fboId : null,
            isTaxInclusive: this.countryTaxInclusive,
            languageSetting: this.storeLangCultureId ? this.storeLangCultureId : null
        };
        this._commonService.getPromotionEngineConfigurations(this.storeId, promotionrequest).subscribe((response: any) => {
            if (response && response.promotionModelList && response.promotionModelList.length > 0) {
                this.promotionModels = response.promotionModelList;
                if (resetPromotion && (<FormArray>this.orderFormGroup.get('items')).length > 0) {
                    this.reUpdateCartAndPromotion()
                }
            } else {
                this.promotionModels = [];
                this.reUpdateCartAndPromotion();
            }
        }, error => {
            this.promotionModels = [];
            this.reUpdateCartAndPromotion();
        });
    }


    /**
     * Rebind the products based promotions
     */
    reUpdateCartAndPromotion() {
        const items = this.orderFormGroup.get('items');
        const freeProductsInfo = this.validatePromotionCriteria(items);
        const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
        if (productIds && productIds.length) {
            this.addPromotionEngineProducts(productIds, freeProductsInfo);
        } else {
            this.updateTotalsAndShipMethod();
        }
    }
    /**
     * Validate Promotions based on all criteria
     * @param product
     * @returns
     */
    validatePromotionCriteria(items: any) {
        const subTotal = this.calculateItemsSubTotal(this.storeInfo);
        let freeProductsInfo = [];
        if (this.promotionModels && this.promotionModels.length > 0) {
            this._commonService.setSubTotalAndOrderCC(subTotal, this.totalCommissionableVolume, this.countryTaxInclusive);
            this._commonService.validateOrderCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderSubTotalCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderCCCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductAtQuantityCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateMultipleProductCriteria(this.promotionModels, freeProductsInfo, items);
        }
        return this._commonService.removeDuplicates(freeProductsInfo);
        //return freeProductsInfo;
    }

    /**
     * To Get Promotion Product details and bind it to order line items
     * @param productIds
     */
    addPromotionEngineProducts(productIds: number[], freeProductsInfo: any) {
        let items: any = this.orderFormGroup.get('items');
        if (items && items.length >= 0) {
            const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
                ? this.memberInfo.wholeSaleQualified : false;
            const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
            const memberTitleId = this.memberInfo ? this.memberInfo.memberTitleId : MemberLevel.RETAIL;
            const purchaseFlowType = this.memberTypeId === MemberTypeEnum.GUEST || this.memberTypeId === MemberTypeEnum.RETAIL
                ? PurchaseFlows.RETAIL : PurchaseFlows.PERSONAL;
            this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, memberTitleId,
                purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe((products: Product[]) => {
                    if (products && products.length > 0) {
                        products.forEach((product) => {
                            const freeProductIndex = items.controls.findIndex(item => item.controls['productId'].value === product.id);
                            if (items && items.length >= 0 && freeProductIndex < 0) {
                                const currentFreeProduct = freeProductsInfo.find((freeProduct) => freeProduct.productId === product.id);
                                let stockQuantity: StockQuantity = this._commonService.stockQuantityCheck(product, currentFreeProduct);
                                if (stockQuantity.currentFreeProductQuantity > 0) {
                                    this.addItemNumber();
                                    const index = (items.length - 1);
                                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                    if (currentFreeProduct.promotionId && currentFreeProduct.promotionId.length > 0) {
                                        currentFreeProduct.promotionId.forEach((promotionId) => {
                                            if (this.promotionIds.indexOf(promotionId) == -1) {
                                                this.promotionIds.push(promotionId)
                                            }
                                        });
                                    }
                                    currentFreeProduct.quantity = stockQuantity.currentFreeProductQuantity;
                                    items = this._commonService.addPromoItem(items, index, product,
                                        environment.uiTemplateBaseUrl, environment.cdnURL);
                                    const productItem = items.controls[index].controls['productItem'].value;
                                    productItem.orderPromotionTrackings = stockQuantity.orderPromotionTrackings;
                                    if (!items.controls[index].controls['quantity'].value) {
                                        items.controls[index].controls['quantity'].setValue(currentFreeProduct.quantity);
                                    }
                                    items.controls[index].controls['quantity'].updateValueAndValidity();
                                    productItem.quantity = currentFreeProduct.quantity;
                                    items.controls[index].controls['productItem'].setValue(productItem);
                                }
                            }
                        });

                    } else {
                        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                            this.itemLevelSearch.nativeElement.focus();
                        }
                    }
                    this.itemLevelSearch.nativeElement.value = '';
                    this.updateTotalsAndShipMethod();
                });
        }
    }

    getPlaceOrderButtonEnabled() {
        let isEnablePlaceOrder: boolean;
        isEnablePlaceOrder = !((!this.mailAlreadyExist) && !this.taxCalculationStatus
            && ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
                && this.shippingAddressInfo)
                || ((this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP && this.shipMethod)
                    || (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP
                        && this.pudoShippingMethod && this.selectedPudoCollectionPoint)))
            && (this.products.length > 0 && this.orderFormGroup.valid &&
                (this.guestPersonalInfoFormValid || this.personalInfoFormValid) && ((this.orderFormGroup.value.orderType !== this.orderType.NEW_RETAIL) || (this.orderFormGroup.value.orderType === this.orderType.NEW_RETAIL && this.sponsorInformation && this.mailingAddress))));
        return isEnablePlaceOrder ? true : false;
    }

    getAddCartButtonEnabled() {
        let isEnablePlaceOrder: boolean;
        isEnablePlaceOrder = (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY ? !this.shippingAddressInfo : false) && !this.mailingAddress && !(this.memberInfo && this.memberInfo.address);
        return isEnablePlaceOrder ? true : false;

    }
    regularOrderPlaceOrderButtonEnabled() {
        let isEnablePlaceOrder: boolean;
        if (!this.taxCalculationStatus && !this.minMaxPriceValidation && this.orderFormGroup.valid && this.isActive && (!this.isSubmitted)) {
            isEnablePlaceOrder = false;

        }
        else {
            isEnablePlaceOrder = true;
        }

        return isEnablePlaceOrder;
    }


    fetchBonusInfoTermsAndConditions(countryCode: string, languageCode: string) {
        this._documentService.getDocuments(Portal.Csp, DocumentLibraryMemberId.Distributor, DisplaySectionId.Fbo_Sign_up, countryCode, languageCode)
            .subscribe((response) => {
                if (response && response.length > 0 && response[0].body && response[0].body.length > 0) {
                    this.bonusInfoAgreements = response[0].body;
                    this.bonusInfoAgreements.forEach((agreement: any) =>
                        agreement.isSelected = false
                    );
                } else {
                    const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            }, (error: any) => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
    }

    selectedAgreements(index: number) {
        this.bonusInfoAgreements[index].isSelected = !this.bonusInfoAgreements[index].isSelected;
        this.checkBonusInfoDocumentsSelected();
    }

    checkBonusInfoDocumentsSelected(): void {
        const selectedDocuments = this.bonusInfoAgreements.filter(x => x.isSelected);
        if (selectedDocuments && selectedDocuments.length === this.bonusInfoAgreements.length) {
            this.bonusInfoAgreementCheckError = false;
            this.formSubmitted = false;
        } else {
            this.bonusInfoAgreementCheckError = true;
            this.formSubmitted = false;
        }
    }

    setFboBonusInformationPermissions(storeId: number) {
        this.hasFboBonusInfoViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_VIEW + ']'), AccessLevel.Store, storeId);
        this.hasFboBonusInfoDeletePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_DELETE + ']'), AccessLevel.Store, storeId);
        this.hasFboBonusInfoManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_MANAGE + ']'), AccessLevel.Store, storeId);
    }

    subscribePersistedMemberId() {
        this.messageService.getPersitedMemberId().subscribe(fboId => {
            this.persistedMemberId = fboId;
            this.hasPersistedMemberId = fboId ? true : false;
        });
    }

    getOrderFromLookupEmit(value): void {
        this.orderFromLookup = value;
    }
    /**
    * @description To get gbo ferferal id
    * @date 2021-08-25
    * @memberof OrderPromotionComponent
    */
    getBusinessEntityByHomeCountryCode(homeCountryCode: string): void {
        this._sponsorService.getBusinessEntityByHomeCountryCode(homeCountryCode).subscribe((response) => {
            if (response) {
                this.businessEntityDetails = response;
                if (this.businessEntityDetails && this.businessEntityDetails.anonymousRetailFboId) {
                    this._commonService.anonymousSponsorSearch(this.businessEntityDetails.anonymousRetailFboId).subscribe((response) => {
                        if (response && response.length > 0) {
                            this.processSearchSponsorResponse(null, this.businessEntityDetails.anonymousRetailFboId, null, response,SponsorSearchOption.SearchByIKnowSponsor);
                        } else {
                            this.isSponsorFound = false;
                            this.displayErrorMessage(null);
                        }
                    }, (error) => {
                        this.isSponsorFound = false;
                        this.displayErrorMessage(null);
                    });
                } else {
                    this.getSponsorInfoByReferralOrAutoSuggest();
                }
            } else {
                this.getSponsorInfoByReferralOrAutoSuggest();
            }
        });
    }

    setBusinessInformation() {
        this._personalMessageService.setSubmitBusinessInfo(true);
    }

    getBusinessInfo(event: any): void {
        if (event) {
            this.businessInformation = event;
            if (this.businessInformation.isBusinessInfoValid) {
                this.validateMemberUpdateInformation(this.legalRequirements);
            }
        }
    }

    getBusinessInfoOnInputChange(event: any): void {
        if (event) {
            this.businessInformation = event;
        }
    }

    getPodiCollectPointAddress(): any {
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            let pudoaddress: any = null;
            pudoaddress = this.getWarehouseAddress();
            if (this.selectedPudoCollectionPoint && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                pudoaddress.addressLine1 = this.selectedPudoCollectionPoint.street;
                pudoaddress.addressLine2 = this.selectedPudoCollectionPoint.address2;
                pudoaddress.city = this.selectedPudoCollectionPoint.city;
                pudoaddress.addressType = AddressType.PUDO;
                pudoaddress.zip = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.postalCode = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.name = this.selectedPudoCollectionPoint.name;
                pudoaddress.countryId = this.shippingAddressInfo && this.shippingAddressInfo.countryId ? this.shippingAddressInfo.countryId : this.countryID;
            } else if (this.selectedPudoCollectionPoint && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                pudoaddress.addressLine1 = this.selectedPudoCollectionPoint.street;
                pudoaddress.addressLine2 = this.selectedPudoCollectionPoint.address2;
                pudoaddress.city = this.selectedPudoCollectionPoint.city;
                pudoaddress.addressType = AddressType.PUDO;
                pudoaddress.zip = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.postalCode = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.name = this.selectedPudoCollectionPoint.name;
                pudoaddress.countryId = this.shippingAddressInfo && this.shippingAddressInfo.countryId ? this.shippingAddressInfo.countryId : this.countryID;
            }
            return pudoaddress;
        }
    }

    buildPayByLinkForm() {
        this.emailForm = this._formbuilder.group({
            payByLinkEmail: ['', [Validators.required]]
        });
    }

    emailCheck() {
        if (this.emailForm.controls['payByLinkEmail'].value !== '' && this.emailForm.controls['payByLinkEmail'].valid) {
            this.isPayByLinkValid = true;
        } else {
            this.isPayByLinkValid = false;
        }
    }

    getMailingAddress(address: any) {
        let countryObj: any = {};
        if (address.countryId) {
            countryObj = this.countries.filter((x: Country) => x.countryId === +address.countryId)[0];
        }
        const mailingAddress: any = {
            addressLine1: address.addressLine1,
            countryCodeTwo: countryObj ? countryObj.isocodeTwo : this.selectedCountryCodeTwo,
            stateCode: address.stateCode,
            city: address.city,
            postalCode: address.postalCode,
            addressType: AddressType.MAILING
        }
        return mailingAddress;
    }

    onChangeLanguage() {
        if (this.orderFormGroup.controls['language']) {
            this.storeLangCultureId = '';
            const cultureName = this.orderFormGroup.controls['language'].value;
            const selectedLanguage = this.storeInfo.languages.find(language => language.cultureName === cultureName);
            if (selectedLanguage) {
                this.getFboDocuments(cultureName, true);
                this.languageCulture = selectedLanguage.cultureName;
                this.payByLinkLanguageShortCode = selectedLanguage.languageCode;
                this.storeLangCultureId = +selectedLanguage.cultureId;
                this.getStorePromotions(true);
                this.isDropShipOptionExist = false;
                this.isPickUpOptionExist = false;
            }
        }
    }

    savedCardInfo(savedcardDetails: any) {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        if (savedcardDetails) {
            this.paymentComponentSettings.savedCards.unshift(savedcardDetails);
            this.showNexioPopup.close();
            this.showNexioPayment = false;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length) {
                const savedCard = this.paymentComponentSettings.savedCards[0];
                if (savedCard && savedCard.id === savedcardDetails.id) {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(savedCard.id);
                } else {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedCards[0].id);

                }
                this.selectedpayvisionCardInfo = savedcardDetails;
            }
        }

    }
    getStorePriceTierName() {
        if (this.products && this.products.length > 0) {
            this.productDiscountPercentage = this.products[0].storePriceTierPercentage ? this.products[0].storePriceTierPercentage : 0;
            const priceTierId: any = StorerPiceTier[this.products[0].priceTierName];
            const enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.paymentComponentSettings.isoCountryCode);
            if (priceTierId) {
                this.priceTierName = this._commonService.getDiscountPriceLevel(priceTierId, this.productDiscountPercentage, this.paymentComponentSettings.memberTypeId, enableWHLSAL00ForAsstSupervisor);
            }

        }
        return this.priceTierName;
    }
    private getPudoDropShipPersonAddress(collectionPoint?: CollectionPoint): any {
        let address: any = collectionPoint;
        let dropShipAddress;
        if (collectionPoint) {
            dropShipAddress = {
                addressLine1: address.street ? collectionPoint.street : this.pudoShippingAddressInfo.addressLine1,
                addressLine2: address.address2,
                addressLine3: address.address3,
                city: address.city,
                state: collectionPoint.state,
                stateCode: this.pudoShippingAddressInfo.stateCode || null,
                countryCode: this.selectedIsoCountryCode,
                country: collectionPoint.country || this.selectedIsoCountryCode,
                postalCode: this.pudoShippingAddressInfo.postalCode || null,
                zipCode: address.zipCode,
                countryId: this.pudoShippingAddressInfo.countryId,
                stateId: this.pudoShippingAddressInfo.stateId,
                externalId: address.externalId,
                name: address.name ? this.storeInfo.warehouseAddress.name : null
            }
            this.pudoAddress = dropShipAddress;
            this.messageService.setPudoPersonAddress(true)
            this.dropShipAddress = dropShipAddress;
        }
        else if (this.dropLoactionSelected) {
            return this.dropShipAddress;
        } else if (this.orderSession && this.orderSession.pudoaddress) {
            return this.orderSession.pudoaddress;
        } else {
            return
        }
    }

    isRetailFreeShipping(shippingMethodResponse?) {
        if (this.enableRetailFreeShipping && this.isRetailFreeShippingEnabledCountries() && this.isRetailORGuest() && this.isStoreParticipating()) {
            const isTotalOverRFS = this.isSubTotalReachedThresholdValue();
            const freeShippingMethod = this.shippingMethods.find(x => x.shippingMethod == RetailFreeShippingConstants.FREE_SHIPPING);
            if (isTotalOverRFS && freeShippingMethod) {
                for (let i = 0; i < this.shippingMethods.length; i++) {
                    this.shippingMethods[i].disabledDeliveryMethods = true;
                    if (this.shippingMethods[i].shippingMethod && (this.shippingMethods[i].shippingMethod.toLowerCase() == RetailFreeShippingConstants.FREE_SHIPPING.toLowerCase())) { this.shippingMethods[i].disabledDeliveryMethods = false; }
                    if (this.shippingMethods[i].shortCode && (RetailFreeShippingConstants.ShortCode.includes(this.shippingMethods[i].shortCode.toUpperCase()))) {
                        this.shippingMethods[i].disabledDeliveryMethods = false;
                    } else if(this.shippingMethods[i].freeShippingEligible){
                        this.shippingMethods[i].disabledDeliveryMethods = false;
                    }
                }
                this.orderFormGroup.get('shipMethodId').setValue(freeShippingMethod ? freeShippingMethod.shippingMethodId : "");
                return freeShippingMethod ? freeShippingMethod : null;
            }
            else {
                let setIndex = 0;
                for (let i = 0; i < this.shippingMethods.length; i++) {
                    if (this.shippingMethods[i].shippingMethod && (this.shippingMethods[i].shippingMethod.toLowerCase() == RetailFreeShippingConstants.FREE_SHIPPING.toLowerCase())) {
                        this.shippingMethods[i].disabledDeliveryMethods = true;
                        if (i > 0) { setIndex = 0; }
                        if (i <= 0) { setIndex = 1; }
                        break;
                    }
                }
                const shippingMethod = this.shippingMethods[setIndex];
                this.orderFormGroup.get('shipMethodId').setValue(shippingMethod ? shippingMethod.shippingMethodId : "");
                return shippingMethod ? shippingMethod : null;
            }
        }
        return null;
    }

    isRetailORGuest() {
        const OrderTypevalue = this.orderFormGroup && +this.orderFormGroup.get('orderType').value;
        if (OrderTypevalue && OrderTypevalue == this.orderType.NEW_GUEST_RETAIL || OrderTypevalue == this.orderType.NEW_RETAIL) return true;
        let isMemberRetailORGuest = this.memberInfo && (this.memberInfo.memberTypeId == this.memberTypeEnum.GUEST || this.memberInfo.memberTypeId == this.memberTypeEnum.RETAIL) ? true : false
        if (OrderTypevalue && OrderTypevalue == this.orderType.REGULAR && isMemberRetailORGuest) return true;
        return false;
    }

    isStoreParticipating() {
        if (this.storeDetails) {
            const isParticipating = this.storeDetails.retailFreeShippingParticipationType && this.storeDetails.retailFreeShippingParticipationType == this.RFSConstants.RFS_PARTICIPATING ? true : false;
            return isParticipating;
        }
        return false;
    }
    isSubTotalReachedThresholdValue() {
        if (this.storeDetails) {
            const subTotal = this.calculateItemsSubTotal(this.storeDetails);
            if (subTotal >= this.storeDetails.retailFreeShippingTransactionAmount) return true;
        }
        return false;
    }

    isRetailFreeShippingEnabledCountries() {
        const isoCountryCode = this.storeDetails && this.storeDetails.homeIsocodeThree ? this.storeDetails.homeIsocodeThree : ""
        const retailFreeShippingCountries = environment && environment.retailFreeShippingEnabledCountries ? environment.retailFreeShippingEnabledCountries.toUpperCase() : "";
        return isoCountryCode && retailFreeShippingCountries ? retailFreeShippingCountries.split(',').includes(isoCountryCode.toUpperCase()) : false;
    }

    isOrderMeetsRFSCriteria() {
        return (this.enableRetailFreeShipping && this.isRetailFreeShippingEnabledCountries() && this.isRetailORGuest() && this.isStoreParticipating() && this.isSubTotalReachedThresholdValue())
    }

    liveFormDataIsValid(formStatus: boolean): void {
        this.liveFormStatusIsValid = formStatus;
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY && this.liveFormStatusIsValid) {
            this.liveFormStatusIsValid = true;
        } else {
            this.liveFormStatusIsValid = false;
        }
    }
    setPUDOSuggestedAddress() {
        this.pudoSuggestedAddressSubscription = this.messageService.getPUDOSuggestedAddress().subscribe((value) => {
            if (value) {
                this.buildPudoLocationSearchForm(value.zip, value.city, value.addressLine1);
                this.getPudoLocations();
            }
        });
    }

    private getSponsorEligibilty(sponsorSearchResponse: SponsorSearchResponse) {
        this._commonService
            .getSearchSponsorsByUUID(sponsorSearchResponse)
            .subscribe((sponsorEligibiltyCheckResponse: any) => {
                if (sponsorEligibiltyCheckResponse) {
                    if (this.sponsorPollCount < this.sponsorMaxPollCount) {
                        this.sponsorPollCount = this.sponsorPollCount + 1;
                        if (sponsorEligibiltyCheckResponse.requestStatus === ResponseStatus.QUEUED ||
                            sponsorEligibiltyCheckResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                            setTimeout(() => {
                                this.getSponsorEligibilty(sponsorEligibiltyCheckResponse);
                            }, this.sponsorSearchTimeDelay);
                        } else if (sponsorEligibiltyCheckResponse.requestStatus === ResponseStatus.FAILED) {
                            this.isSponsorFound = false;
                            this.displayErrorMessage(null);
                            this.sponsorInformation = null;
                            if (this.businessEntityDetails && this.businessEntityDetails.anonymousRetailFboId) {
                                this.fboReferralId = null;
                            }
                        }
                    }
                }
            })
    }

    ngOnDestroy() {
        if (this.pudoSuggestedAddressSubscription) {
            this.pudoSuggestedAddressSubscription.unsubscribe();
        }
        this._cacheService.remove(CacheKey.COUNTRY_CODE);
        this._cacheService.remove(CacheKey.COUNTRY_ID);
    }

    getMembergovernmentIdentificationsInfo(memberId: number) {
        if (memberId) {
            this._customerService.getMembergovernment_identifications(memberId).subscribe(response => {
                if (response) {
                    this.memberInfo.memberGovernmentIdentifications = response.memberGovernmentIdentificationModel;
                    this.memberInfo.vatDetailModel = response.vatDetailModel;
                }
            });
        }

    }
    /**
     * @description To get the Payment method type based on USA country pick up location.
     * @date 2023-28-06
     * @param shippingMethod 
     */
    getPickupDetailsForUSA(shippingMethod) {
        if (shippingMethod.shippingMethod == CommonConstant.LOS_ANGELES_PRODUCT_CENTER) {
            this.storePaymentInfo.forEach(
                paymentMethod => {
                    if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                        this.credit_Card_show = true;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                        this.money_Order_show = false;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                        this.wire_Transfer_show = false;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                        this.bank_transfer_show = false;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                        this.cash_on_delivery_show = false;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                        this.orange_money_show = false;
                    } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                        this.ach_show = false;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Direct_Debit) {
                        this.direct_debit_show = false;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                        this.pay_by_link_show = false;
                    }
                });
        }
        else {
            this.storePaymentInfo.forEach(
                paymentMethod => {
                    if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                        this.credit_Card_show = false;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                        this.money_Order_show = true;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                        this.wire_Transfer_show = true;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                        this.bank_transfer_show = true;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                        this.cash_on_delivery_show = true;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                        this.orange_money_show = true;
                    } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                        this.ach_show = true;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Direct_Debit) {
                        this.direct_debit_show = true;
                    } else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                        this.pay_by_link_show = true;
                    }
                });
        }
    }
    /**
     * @description To get the Payment method type based on USA country for delivery option.
     * @date 2023-28-06
     * @param shippingMethod 
     */
    getDeliveryOptionsPayment() {
        this.storePaymentInfo.forEach(
            paymentMethod => {
                if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                    this.credit_Card_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                    this.money_Order_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                    this.wire_Transfer_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                    this.bank_transfer_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                    this.cash_on_delivery_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                    this.orange_money_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                    this.ach_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Direct_Debit) {
                    this.direct_debit_show = true;
                } else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                    this.pay_by_link_show = true;
                }
            });
    }

    updateAutoshipProfile(memberId: number){
        if (memberId) {
            this._orderService.getAutoShipDetailsByMemberId(memberId).subscribe((response) => {
                if (response && response[0] && response[0].body && response[0].body.length) {
                    const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
                    this._orderService.updateAutoshipProfile(memberId, MemberTypeId.DISTRIBUTOR, this.storeInfo.taxInclusive, optin)
                        .subscribe((response: any) => {
                            if (response && response.success) {
                            }
                        }, (error: any) => {
                            console.log(error);
                        });
                }
            }, (error: any) => {
                console.log(error);
            });
        }
    }

    getDropShipPudoShippingMethods(shippingOptions: ShippingOptionsRequest, shippingMethods: ShippingMethod[], mappingRequired: boolean = true) {
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist)) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this.getWarehouseAddress();
                }
            } else {
                shippingOptions.toAddress = this.getWarehouseAddress();
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;

            this._orderService.getShipmentService(shippingOptions).subscribe((response) => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    // Testing Purpose .
                    //response.shippingMethods[0].pudoEnabled = true;
                    this.dropshipPudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                    if (mappingRequired) {
                        if (this.dropshipPudoShippingMethod) {
                            this.dropshipPudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                    }
                }
            }, (error) => {
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/order-promotion.component.ts